// TODO: временное решение в связи с отсутствием данных на беке
// что бы не создавать лишних дефиниций в платформеко, а так же лишних асинхронных запросов
// возможно тут будет проще расположить этот хардкод
// не через стейт, что бы не дублировать данные

export const response = {
    "total_advive": 1082,
    "total_page": 121,
    "items": [
        {
            "title": "Как самостоятельно установить дверную ручку на межкомнатную дверь",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "13.04.2026",
            "link": "kak-samostoyatelno-ustanovit-dvernuyu-ruchku-na-mezhkomnatnuyu-dver",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1776087403/fudzi/advice/kak-samostoyatelno-ustanovit-ruchki-photo-001.png/kak-samostoyatelno-ustanovit-ruchki-photo-001.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/v1776087403/fudzi/advice/kak-samostoyatelno-ustanovit-ruchki-photo-001.png/kak-samostoyatelno-ustanovit-ruchki-photo-001.png 2x",
            "views": 8736,
            "total_comment": 0,
            "is_video": true,
            "likes": 86,
            "id": "aan4lbldn483ntablaw32b6"
        },
        {
            "title": "Как сделать зону отдыха на даче своими руками: интересные идеи для обустройства",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "23.07.2024",
            "link": "kak-sdelat-zonu-otdyha-na-dache-svoimi-rukami-interesnye-idei-dlya-obustroystva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1721745511/fudzi/advice/zona-otdiha-na-dache-000-hero.jpg/zona-otdiha-na-dache-000-hero.jpg",
            "views": 9133,
            "total_comment": 0,
            "is_video": false,
            "likes": 91,
            "id": "aan4lbldn483ntablaw32g9"
        }, {
            "title": "Капельный полив своими руками видеоинструкция",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.07.2024",
            "link": "kapelnyy-poliv-svoimi-rukami-videoinstrukciya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1719392046/fudzi/advice/kapelnii-poliv-000-hero.jpg/kapelnii-poliv-000-hero.jpg",
            "views": 8193,
            "total_comment": 0,
            "is_video": false,
            "likes": 32,
            "id": "kdn4lbsklkd2e8abptsqbw6p"
        }, {
            "title": "Как правильно выбрать и установить душевой трап",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "25.06.2024",
            "link": "kak-pravilno-vybrat-i-ustanovit-dushevoy-trap",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1719315625/fudzi/advice/dushevoi-trap-000-hero.jpg/dushevoi-trap-000-hero.jpg",
            "views": 11093,
            "total_comment": 0,
            "is_video": false,
            "likes": 97,
            "id": "kpnsl3s2ldd7e3a0psslb262"
        }, {
            "title": "Как сделать капельный полив в теплице и на огороде своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "11.04.2024",
            "link": "kak-sdelat-kapelnyy-poliv-v-teplice-i-na-ogorode-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1722497194/fudzi/advice/kak-sdelat-kapelnii-poliv-svoimi-rukami-000-hero.jpg/kak-sdelat-kapelnii-poliv-svoimi-rukami-000-hero.jpg",
            "views": 9425,
            "total_comment": 0,
            "is_video": false,
            "likes": 86,
            "id": "kpe1zcs2ldd7e3a0pf1e3262"
        },
        {
            "title": "Какой полив лучше выбрать для огорода: организация системы полива на даче",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "11.04.2024",
            "link": "kakoy-poliv-luchshe-vybrat-dlya-ogoroda-organizaciya-sistemy-poliva-na-dache",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1722493143/fudzi/advice/kakoy-poliv-luchshe-vibrat-000-hero.jpg/kakoy-poliv-luchshe-vibrat-000-hero.jpg",
            "views": 10227,
            "total_comment": 0,
            "is_video": false,
            "likes": 62,
            "id": "kpe1zcs2eee7e3a005de3262"
        }, {
            "title": "Как выбрать гриль-барбекю для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "09.04.2024",
            "link": "kak-vybrat-gril-barbekyu-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1712593181/fudzi/advice/kak-vibrat'-gril-barbeku-000-hero.jpg/kak-vibrat'-gril-barbeku-000-hero.jpg",
            "views": 12601,
            "total_comment": 0,
            "is_video": false,
            "likes": 38,
            "id": "0b21zcc2eee7eda005de3f62"
        },
        {
            "title": "Как выбрать садовый стол для дачи или загородного дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "08.04.2024",
            "link": "kak-vybrat-sadovyy-stol-dlya-dachi-ili-zagorodnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1712584418/fudzi/advice/kak-vibrat-sadovii-stol-dlya-dachi-000-hero.jpg/kak-vibrat-sadovii-stol-dlya-dachi-000-hero.jpg",
            "views": 15278,
            "total_comment": 0,
            "is_video": false,
            "likes": 72,
            "id": "0a21ecc2ebe7edd005de3f66"
        },
        {
            "title": "Как выбрать и установить душевой уголок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "20.11.2023",
            "link": "kak-pravilno-vybrat-i-ustanovit-dushevoy-trap",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1697784249/fudzi/advice/000-hero-dushevoy-ugolok.jpg/000-hero-dushevoy-ugolok.jpg",
            "views": 8043,
            "total_comment": 0,
            "is_video": false,
            "likes": 107,
            "id": "vlanvb7v2ldd7sj74nb93b262"
        },
        {
            "title": "Какой обогреватель выбрать для квартиры и дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "02.10.2023",
            "link": "kakoy-obogrevatel-vybrat-dlya-kvartiry-i-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1696249604/fudzi/advice/000-hero.jpg/000-hero.jpg",
            "views": 11953,
            "total_comment": 0,
            "is_video": false,
            "likes": 203,
            "id": "vlaldnr92ntd7saaqogn33262"
        },
        {
            "title": "Виды и размеры профилей для гипсокартона",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "11.04.2023",
            "link": "vidy-i-razmery-profiley-dlya-gipsokartona",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1708004492/fudzi/advice/vidi-i-razmeri-profiley-dlya-gipsokartona-000-hero.jpg/vidi-i-razmeri-profiley-dlya-gipsokartona-000-hero.jpg",
            "views": 11193,
            "total_comment": 0,
            "is_video": false,
            "likes": 283,
            "id": "kbqffdkl529n77lnsslwnb42"
        },
        {
            "title": "Как выбрать тротуарную плитку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "11.04.2023",
            "link": "kak-vybrat-trotuarnuyu-plitku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1708000587/fudzi/advice/kak-vibrat'-troruarnuuy-plitku-hero-001.png/kak-vibrat'-troruarnuuy-plitku-hero-001.png",
            "views": 11193,
            "total_comment": 0,
            "is_video": false,
            "likes": 283,
            "id": "kbqfls94mwav77lntrde3f6x"
        },
        {
            "title": "Как правильно выбрать садовый зонт для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "11.04.2023",
            "link": "kak-pravilno-vybrat-sadovyy-zont-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1712578504/fudzi/advice/kak-vibrat'-sadovii-zont-000-hero.jpg/kak-vibrat'-sadovii-zont-000-hero.jpg",
            "views": 11193,
            "total_comment": 0,
            "is_video": false,
            "likes": 138,
            "id": "kbq1zoi2mwa7eda005de3f6x"
        },
        {
            "title": "Быстрое обновление ванной комнаты",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "11.07.2022",
            "link": "bystroe-obnovlenie-vannoy-komnaty",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/bystroe-obnovlenie-vannoj-komnaty/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/bystroe-obnovlenie-vannoj-komnaty/000-hero.jpg/000-hero.jpg 2x",
            "views": 7382,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9d538aced40254f20cf"
        },
        {
            "title": "Какой генератор выбрать для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "17.08.2022",
            "link": "kakoy-generator-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakoy-generator-vibrat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakoy-generator-vibrat/000-photo.jpg/000-photo.jpg 2x",
            "views": 12053,
            "total_comment": 1,
            "is_video": false,
            "likes": 12,
            "id": "648ac9d538aced40254f20d0"
        },
        // {
        //     "title": "Кусачки, бокорезы: разбираемся в понятиях",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Инструменты",
        //     "dept_slug": "instrumenty",
        //     "date_publish": "17.08.2022",
        //     "link": "chem-kysachki-otlochayutsa-ot-bokorezov",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chem-kysachki-otlochayutsa-ot-bokorezov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chem-kysachki-otlochayutsa-ot-bokorezov/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 9137,
        //     "total_comment": 1,
        //     "is_video": false,
        //     "likes": 6,
        //     "id": "648ac9d538aced40254f20d1"
        // },
        {
            "title": "Виды финишной отделки дверных полотен",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "12.08.2022",
            "link": "vidy-finishnoy-otdelki-dvernyh-poloten",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vidy-finishnoy-otdelki-dvernyh-polpten/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vidy-finishnoy-otdelki-dvernyh-polpten/000-photo.jpg/000-photo.jpg 2x",
            "views": 13483,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9d538aced40254f20d2"
        },
        {
            "title": "Как наносить эпоксидную затирку на плитку",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "09.11.2022",
            "link": "kak-nanosit-epoksidnuyu-zatirku-na-plitku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-nanosit-epokcidnyu-zatirku-na-plitky/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-nanosit-epokcidnyu-zatirku-na-plitky/000-photo.png/000-photo.png 2x",
            "views": 15154,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9d638aced40254f20d3"
        },
        {
            "title": "Как правильно развести клей для обоев",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.08.2022",
            "link": "kak-pravilno-podgotovit-kley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravilno-podgotovit-kley/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravilno-podgotovit-kley/000-photo.jpg/000-photo.jpg 2x",
            "views": 14094,
            "total_comment": 2,
            "is_video": false,
            "likes": 8,
            "id": "648ac9d638aced40254f20d4"
        },
        {
            "title": "Выбор гофротрубы для электрического кабеля",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "28.08.2022",
            "link": "vybor-gofrotruby-dlya-elektricheskogo-kabelya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vibor-gofrotruby-dla-electrycheskogo-kabelya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vibor-gofrotruby-dla-electrycheskogo-kabelya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15741,
            "total_comment": 2,
            "is_video": false,
            "likes": 12,
            "id": "648ac9d638aced40254f20d5"
        },
        {
            "title": "Фотообои – лайфхак для хорошего настроения",
            "description": "Фотообои – лайфхак для хорошего настроения",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.08.2022",
            "link": "fotooboi-layfkhak-dlya-khoroshego-nastroeniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/fotooboi-layfkhak-dlya-khoroshego-nastroeniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/fotooboi-layfkhak-dlya-khoroshego-nastroeniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15252,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9d638aced40254f20d6"
        },
        {
            "title": "Лайфхаки для переезда",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "24.08.2022",
            "link": "layfkhaki-dlya-pereezda",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/layfkhaki-dlya-pereezda/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/layfkhaki-dlya-pereezda/000-photo.jpg/000-photo.jpg 2x",
            "views": 5775,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9d638aced40254f20d7"
        },
        {
            "title": "Как выбрать настенные аксессуары для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "01.08.2022",
            "link": "kak-vybrat-nastennye-aksessuary-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-nastennye-aksessuary-dlya-kuhni/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-nastennye-aksessuary-dlya-kuhni/000-hero.jpg/000-hero.jpg 2x",
            "views": 5722,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648ac9d738aced40254f20d8"
        },
        {
            "title": "Кухонные настольные аксессуары",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "24.05.2023",
            "link": "kukhonnye-nastolnye-aksessuary",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kukhonnye-nastolnye-aksessuary/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kukhonnye-nastolnye-aksessuary/000-photo.jpg/000-photo.jpg 2x",
            "views": 10521,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9d738aced40254f20d9"
        },
        {
            "title": "Детали меняют всё: 5 способов легко и быстро обновить внешний вид кухни",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "03.02.2020",
            "link": "detali-menyayut-vse-5-sposobov-legko-i-bystro-obnovit-vneshniy-vid-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/detali-menyayut-vse-5-sposobov-legko-i-bystro-obnovit-vneshniy-vid-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/detali-menyayut-vse-5-sposobov-legko-i-bystro-obnovit-vneshniy-vid-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 5526,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9d738aced40254f20da"
        },
        {
            "title": "Выбираем штангу для шторки в ванную комнату",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.10.2021",
            "link": "vybiraem-shtangu-dlya-shtorki-v-vannuyu-komnatu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vybiraem-shtangu-dlya-shtorki-v-vannuyu-komnatu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vybiraem-shtangu-dlya-shtorki-v-vannuyu-komnatu/000-photo.jpg/000-photo.jpg 2x",
            "views": 5583,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9d738aced40254f20dc"
        },
        {
            "title": "Советы по уходу за кухонной бытовой техникой",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "sovety-po-uhodu-za-kuhonnoy-bytovoy-tehnikoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/sovety-po-ukhodu-za-kukhonnoy-bytovoy-tekhnikoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/sovety-po-ukhodu-za-kukhonnoy-bytovoy-tekhnikoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 13296,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9d838aced40254f20dd"
        },
        {
            "title": "Как безопасно подключить посудомоечную машину",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "18.08.2022",
            "link": "kak-bezopasno-podklyuchit-posudomoechnuyu-mashinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-bezopasno-podklyuchit-posudomoechnuyu-mashinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-bezopasno-podklyuchit-posudomoechnuyu-mashinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 4593,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9d838aced40254f20de"
        },
        {
            "title": "Три простых шага к удобной кухне",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.10.2021",
            "link": "tri-prostyh-shaga-k-udobnoy-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/tri-prostykh-shaga-k-udobnoy-kukhne/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/tri-prostykh-shaga-k-udobnoy-kukhne/000-photo.jpg/000-photo.jpg 2x",
            "views": 11790,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9d838aced40254f20df"
        },
        {
            "title": "Как выбрать бытовой измельчитель отходов для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-bytovoy-izmelchitel-othodov-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-izmelchitel-bytovykh-otkhodov-dlya-kukhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-izmelchitel-bytovykh-otkhodov-dlya-kukhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 10174,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9d838aced40254f20e0"
        },
        {
            "title": "Как установить гардеробную систему",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-garderobnuyu-sistemu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-ustanovit-garderobnuyu-sistemu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-ustanovit-garderobnuyu-sistemu/000-photo.jpg/000-photo.jpg 2x",
            "views": 5157,
            "total_comment": 1,
            "is_video": true,
            "likes": 7,
            "id": "648ac9d838aced40254f20e1"
        },
        {
            "title": "Как планировать встроенные шкафы",
            "description": "Как планировать встроенные шкафы",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-planirovat-vstroennye-shkafy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-planirovat-vstroennye-shkafy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-planirovat-vstroennye-shkafy/000-photo.jpg/000-photo.jpg 2x",
            "views": 8623,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9d838aced40254f20e2"
        },
        {
            "title": "Выбор аксессуаров для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "vybor-aksessuarov-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybor-aksessuarov-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybor-aksessuarov-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 13338,
            "total_comment": 0,
            "is_video": true,
            "likes": 8,
            "id": "648ac9d938aced40254f20e3"
        },
        {
            "title": "Как выбрать посудомоечную машину",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "17.08.2022",
            "link": "kak-vybrat-posudomoechnuyu-mashinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-posudomoechnuyu-mashinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-posudomoechnuyu-mashinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 13575,
            "total_comment": 2,
            "is_video": false,
            "likes": 12,
            "id": "648ac9d938aced40254f20e4"
        },
        {
            "title": "Как измерить кухню",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "03.08.2022",
            "link": "kak-izmerit-kuhnyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-izmerit-kukhnyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-izmerit-kukhnyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 8870,
            "total_comment": 3,
            "is_video": false,
            "likes": 12,
            "id": "648ac9d938aced40254f20e5"
        },
        {
            "title": "Уход за каменными столешницами",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "07.02.2023",
            "link": "uhod-za-kamennymi-stoleshnicami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/uhod-za-kamennymi-stoleshnicami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/uhod-za-kamennymi-stoleshnicami/000-photo.jpg/000-photo.jpg 2x",
            "views": 6282,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9d938aced40254f20e6"
        },
        {
            "title": "Как выбрать лампу для светильника",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "02.06.2022",
            "link": "kak-vybrat-lampu-dlya-svetilnika",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/osveshchenie/kak-vybrat-lampu-dlya-svetilnika/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/osveshchenie/kak-vybrat-lampu-dlya-svetilnika/000-photo.jpg/000-photo.jpg 2x",
            "views": 9447,
            "total_comment": 6,
            "is_video": false,
            "likes": 7,
            "id": "648ac9d938aced40254f20e7"
        },
        {
            "title": "Игры с огнем: как создать акценты с помощью освещения?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "30.05.2022",
            "link": "igry-s-ognem-kak-sozdat-akcenty-s-pomoshchyu-osveshcheniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/igry-s-ognem-kak-sozdat-aktsenty-s-pomoshchyu-osveshcheniya/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/igry-s-ognem-kak-sozdat-aktsenty-s-pomoshchyu-osveshcheniya/000-hero.jpg/000-hero.jpg 2x",
            "views": 11928,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9da38aced40254f20e8"
        },
        {
            "title": "Подбираем карнизы для штор: виды, формы, цвета",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "podbiraem-karnizy-dlya-shtor-vidy-formy-cveta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/podbiraem-karnizy-dlya-shtor-vidy-formy-cveta/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/podbiraem-karnizy-dlya-shtor-vidy-formy-cveta/000-photo.jpg/000-photo.jpg 2x",
            "views": 7139,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9da38aced40254f20e9"
        },
        {
            "title": "Как установить кухню",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-kuhnyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit-kuhnyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit-kuhnyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 11271,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9da38aced40254f20ea"
        },
        {
            "title": "Монтаж мойки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "26.07.2022",
            "link": "montazh-moyki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/montazh-moyki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/montazh-moyki/000-photo.jpg/000-photo.jpg 2x",
            "views": 14276,
            "total_comment": 2,
            "is_video": false,
            "likes": 13,
            "id": "648ac9da38aced40254f20ec"
        },
        {
            "title": "Уход за посудомоечной машиной",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.10.2021",
            "link": "uhod-za-posudomoechnoy-mashinoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/ukhod-za-posudomoechnoy-mashinoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/ukhod-za-posudomoechnoy-mashinoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 10091,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9db38aced40254f20ed"
        },
        {
            "title": "Классическая плита или варочная панель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "klassicheskaya-plita-ili-varochnaya-panel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/klassicheskaya-plita-ili-varochnaya-panel/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/klassicheskaya-plita-ili-varochnaya-panel/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10246,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648ac9db38aced40254f20ee"
        },
        {
            "title": "Преимущества светодиодных светильников",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "02.06.2022",
            "link": "preimushchestva-svetodiodnyh-svetilnikov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/preimushchestva-svetodiodnyh-svetilnikov/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/preimushchestva-svetodiodnyh-svetilnikov/000-photo.png/000-photo.png 2x",
            "views": 11276,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9db38aced40254f20ef"
        },
        {
            "title": "Виды стеновых панелей для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "vidy-stenovyh-paneley-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vidy-stenovykh-paneley-dlya-kukhni/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vidy-stenovykh-paneley-dlya-kukhni/000-hero.jpg/000-hero.jpg 2x",
            "views": 11381,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9db38aced40254f20f1"
        },
        {
            "title": "Кухни под размеры помещения: как использовать каждый сантиметр",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kuhni-pod-razmery-pomeshcheniya-kak-ispolzovat-kazhdyy-santimetr",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhni-pod-razmery-pomeshcheniya-kak-ispolzovat-kazhdyy-santimetr/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhni-pod-razmery-pomeshcheniya-kak-ispolzovat-kazhdyy-santimetr/000-photo.jpg/000-photo.jpg 2x",
            "views": 5720,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9db38aced40254f20f2"
        },
        {
            "title": "Как самостоятельно обустроить кухню в скандинавском стиле",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kak-samostoyatelno-obustroit-kuhnyu-v-skandinavskom-stile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-samostoyatelno-obustroit-kuhnyu-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-samostoyatelno-obustroit-kuhnyu-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 2x",
            "views": 12229,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9dc38aced40254f20f3"
        },
        {
            "title": "Как обеспечить безопасность детей на кухне",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kak-obespechit-bezopasnost-detey-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-obespechit-bezopasnost-detey-na-kuhne/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-obespechit-bezopasnost-detey-na-kuhne/000-photo.jpg/000-photo.jpg 2x",
            "views": 15448,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9dc38aced40254f20f4"
        },
        {
            "title": "Как обустроить кухню в скандинавском стиле",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "kak-obustroit-kuhnyu-v-skandinavskom-stile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-obustroit-kuhnyu-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-obustroit-kuhnyu-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 2x",
            "views": 15195,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9dc38aced40254f20f5"
        },
        {
            "title": "Выбираем посуду для готовки и кухонную утварь",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "29.05.2023",
            "link": "vybiraem-posudu-dlya-gotovki-i-kuhonnuyu-utvar",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybirayem-posudu-dlya-gotovki-i-kukhonnuyu-utvar/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybirayem-posudu-dlya-gotovki-i-kukhonnuyu-utvar/000-photo.jpg/000-photo.jpg 2x",
            "views": 5435,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9dc38aced40254f20f6"
        },
        {
            "title": "Выбираем комнатные растения",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vybiraem-komnatnye-rasteniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-komnatnye-rasteniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-komnatnye-rasteniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15701,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648ac9dc38aced40254f20f7"
        },
        {
            "title": "Что лучше выбрать: вытяжку или воздухоочиститель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.04.2022",
            "link": "chto-luchshe-vybrat-vytyazhku-ili-vozduhoochistitel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-luchshe-vybrat-vytyazhku-ili-vozdukhoochistitel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-luchshe-vybrat-vytyazhku-ili-vozdukhoochistitel/000-photo.jpg/000-photo.jpg 2x",
            "views": 4541,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9dd38aced40254f20f8"
        },
        {
            "title": "Кухни с барными стойками: виды, применение, установка",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "08.08.2022",
            "link": "kuhni-s-barnymi-stoykami-vidy-primenenie-ustanovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhni-s-barnymi-stoykami-vidy-primenenie-ustanovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhni-s-barnymi-stoykami-vidy-primenenie-ustanovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 10552,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9dd38aced40254f20f9"
        },
        {
            "title": "Как выбрать и подключить люстру, подвес и другие потолочные светильники",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "02.06.2022",
            "link": "kak-vybrat-i-podklyuchit-lyustru-podves-i-drugie-potolochnye-svetilniki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-podklyuchit-lyustru-podves-i-drugie-potolochnye-svetilniki/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-podklyuchit-lyustru-podves-i-drugie-potolochnye-svetilniki/000-hero.jpg/000-hero.jpg 2x",
            "views": 4140,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9dd38aced40254f20fa"
        },
        {
            "title": "Как спроектировать гардеробную",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-sproektirovat-garderobnuyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sproektirovat-garderobnuyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sproektirovat-garderobnuyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 6758,
            "total_comment": 2,
            "is_video": false,
            "likes": 15,
            "id": "648ac9dd38aced40254f20fb"
        },
        {
            "title": "Как замерить дверной проем для входной двери",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-zamerit-dvernoy-proem-dlya-vhodnoy-dveri",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-zamerit-dvernoy-proyem-dlya-vkhodnoy-dveri/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-zamerit-dvernoy-proyem-dlya-vkhodnoy-dveri/000-photo.jpg/000-photo.jpg 2x",
            "views": 7404,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9dd38aced40254f20fc"
        },
        {
            "title": "Хозяйственные кронштейны: выбор и установка",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "khozyaystvennye-kronshteyny-vybor-i-ustanovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/khozyaystvennye-kronshteyny-vybor-i-ustanovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/khozyaystvennye-kronshteyny-vybor-i-ustanovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 16435,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9de38aced40254f20fd"
        },
        {
            "title": "Нестандартное использование рулонных штор",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.09.2019",
            "link": "nestandartnoe-ispolzovanie-rulonnyh-shtor",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/netradicionnoe-ispolzovanie-rulonnyh-shtor/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/netradicionnoe-ispolzovanie-rulonnyh-shtor/000-photo.jpg/000-photo.jpg 2x",
            "views": 11213,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9de38aced40254f20fe"
        },
        {
            "title": "Четыре стороны уюта. Подбираем декор для квартир в разных стилях",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "chetyre-storony-uyuta-podbiraem-dekor-dlya-kvartir-v-raznyh-stilyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chetyre-storony-uyuta-podbiraem-dekor-dlya-kvartir-v-raznyh-stilyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chetyre-storony-uyuta-podbiraem-dekor-dlya-kvartir-v-raznyh-stilyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 13229,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9de38aced40254f20ff"
        },
        {
            "title": "Как наполнить дом уютом",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "kak-napolnit-dom-uyutom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-napolnit-dom-uyutom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-napolnit-dom-uyutom/000-photo.jpg/000-photo.jpg 2x",
            "views": 5082,
            "total_comment": 3,
            "is_video": false,
            "likes": 12,
            "id": "648ac9de38aced40254f2100"
        },
        {
            "title": "Организация хранения в нежилых помещениях: гараж, балкон, кладовая",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "22.05.2023",
            "link": "organizatsiya-khraneniya-v-nezhilykh-pomeshcheniyakh-garazh-balkon-kladovaya-",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/organizatsiya-khraneniya-v-nezhilykh-pomeshcheniyakh-garazh-balkon-kladovaya-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/organizatsiya-khraneniya-v-nezhilykh-pomeshcheniyakh-garazh-balkon-kladovaya-/000-photo.jpg/000-photo.jpg 2x",
            "views": 8363,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9de38aced40254f2101"
        },
        {
            "title": "Пять интерьеров кухонь, которые легко повторить самостоятельно",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "17.08.2022",
            "link": "pyat-intererov-kuhon-kotorye-legko-povtorit-samostoyatelno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/pyat-intererov-kuhon-kotorye-legko-povtorit-samostoyatelno/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/pyat-intererov-kuhon-kotorye-legko-povtorit-samostoyatelno/000-hero.jpg/000-hero.jpg 2x",
            "views": 16623,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9df38aced40254f2102"
        },
        {
            "title": "Как установить бытовой измельчитель для кухни",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.04.2022",
            "link": "kak-ustanovit-bytovoy-izmelchitel-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit-bytovoy-izmelchitel-dlya-kukhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit-bytovoy-izmelchitel-dlya-kukhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 8419,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9df38aced40254f2103"
        },
        {
            "title": "Всё в порядке: 5 идей для организации хранения на кухне",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.10.2021",
            "link": "vse-v-poryadke-5-idey-dlya-organizacii-hraneniya-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 8335,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9df38aced40254f2104"
        },
        {
            "title": "Выбираем рейлинги и навесные аксессуары для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.10.2021",
            "link": "vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 11124,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9df38aced40254f2105"
        },
        // {
        //     "title": "Выбираем рейлинги и навесные аксессуары для кухни",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Кухни",
        //     "dept_slug": "kuhni",
        //     "date_publish": "19.10.2021",
        //     "link": "vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni1",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vybiraem-reylingi-i-navesnye-aksessuary-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 10548,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 11,
        //     "id": "648ac9df38aced40254f2106"
        // },
        // {
        //     "title": "Всё в порядке: 5 идей для организации хранения на кухне",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Кухни",
        //     "dept_slug": "kuhni",
        //     "date_publish": "05.10.2021",
        //     "link": "vse-v-poryadke-5-idey-dlya-organizacii-hraneniya-na-kuhne1",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vse-v-poryadke-5-idey-dlya-organizacii-hraneniya-na-kuhne/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/vse-v-poryadke-5-idey-dlya-organizacii-hraneniya-na-kuhne/000-hero.jpg/000-hero.jpg 2x",
        //     "views": 4834,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 5,
        //     "id": "648ac9e038aced40254f2107"
        // },
        {
            "title": "Как сделать маленькую комнату светлее и уютнее",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "01.08.2022",
            "link": "kak-sdelat-malenkuyu-komnatu-svetlee-i-uyutnee",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat-malenkuyu-komnatu-svetlee-i-uyutnee/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat-malenkuyu-komnatu-svetlee-i-uyutnee/000-hero.jpg/000-hero.jpg 2x",
            "views": 8974,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9e038aced40254f2108"
        },
        {
            "title": "Три европейских интерьера кухни, которые легко повторить самостоятельно",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "24.05.2023",
            "link": "tri-evropeyskih-interera-kuhni-kotorye-legko-povtorit-samostoyatelno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/tri-evropeyskih-interera-kuhni-kotorye-legko-povtorit-samostoyatelno/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/tri-evropeyskih-interera-kuhni-kotorye-legko-povtorit-samostoyatelno/000-photo.jpg/000-photo.jpg 2x",
            "views": 4518,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9e038aced40254f2109"
        },
        {
            "title": "Свежее сочетание: белый цвет и древесные текстуры в интерьере кухни",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "svezhee-sochetanie-belyy-cvet-i-drevesnye-tekstury-v-interere-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/svezhee-sochetanie-belyy-cvet-i-drevesnye-tekstury-v-interere-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/svezhee-sochetanie-belyy-cvet-i-drevesnye-tekstury-v-interere-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 11078,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e038aced40254f210a"
        },
        {
            "title": "Как сделать маленькую кухню максимально вместительной и функциональной",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "24.05.2023",
            "link": "kak-sdelat-malenkuyu-kuhnyu-maksimalno-vmestitelnoy-i-funkcionalnoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-sdelat-malenkuyu-kuhnyu-maksimalno-vmestitelnoy-i-funkcionalnoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-sdelat-malenkuyu-kuhnyu-maksimalno-vmestitelnoy-i-funkcionalnoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 4540,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9e038aced40254f210c"
        },
        {
            "title": "Уход за деревянными столешницами",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "uhod-za-derevyannymi-stoleshnicami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/ukhod-za-derevyannymi-stoleshnitsami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/ukhod-za-derevyannymi-stoleshnitsami/000-photo.jpg/000-photo.jpg 2x",
            "views": 11908,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9e138aced40254f210d"
        },
        {
            "title": "Монтаж рейлинга",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "montazh-reylinga",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1774893251/fudzi/advice/montazh-reilinga-000-photo.jpg/montazh-reilinga-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/v1774893251/fudzi/advice/montazh-reilinga-000-photo.jpg/montazh-reilinga-000-photo.jpg 2x",
            "views": 11395,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648ac9e138aced40254f210e"
        },
        {
            "title": "Аксессуары для столешниц и стеновых панелей",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.04.2022",
            "link": "aksessuary-dlya-stoleshnic-i-stenovyh-paneley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/aksessuary-dlya-stoleshnits-i-stenovykh-paneley/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/aksessuary-dlya-stoleshnits-i-stenovykh-paneley/000-photo.png/000-photo.png 2x",
            "views": 4426,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9e138aced40254f210f"
        },
        {
            "title": "Совет по выбору модульной кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "sovet-po-vyboru-modulnoy-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/sovet-po-vyboru-modulnoy-kukhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/sovet-po-vyboru-modulnoy-kukhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 9369,
            "total_comment": 4,
            "is_video": false,
            "likes": 8,
            "id": "648ac9e138aced40254f2110"
        },
        {
            "title": "Монтаж рулонных штор",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "montazh-rulonnyh-shtor",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/montazh-rulonnyh-shtor/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/montazh-rulonnyh-shtor/000-photo.jpg/000-photo.jpg 2x",
            "views": 11947,
            "total_comment": 0,
            "is_video": true,
            "likes": 7,
            "id": "648ac9e138aced40254f2111"
        },
        {
            "title": "Как установить светодиодную ленту на кухне",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "28.05.2022",
            "link": "kak-ustanovit-svetodiodnuyu-lentu-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit-svetodiodnuyu-lentu-na-kuhne/Photo1.jpg/Photo1.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit-svetodiodnuyu-lentu-na-kuhne/Photo1.jpg/Photo1.jpg 2x",
            "views": 9906,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9e238aced40254f2112"
        },
        {
            "title": "Порядок в гараже и мастерской: идеи хранения инструментов",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "23.05.2023",
            "link": "poryadok-v-garazhe-i-masterskoy-idei-khraneniya-instrumentov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/poryadok-v-garazhe-i-masterskoy-idei-khraneniya-instrumentov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/poryadok-v-garazhe-i-masterskoy-idei-khraneniya-instrumentov/000-photo.jpg/000-photo.jpg 2x",
            "views": 4300,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9e238aced40254f2113"
        },
        {
            "title": "Наводим порядок в нежилых помещениях",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "navodim-poryadok-v-nezhilykh-pomeshcheniyakh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/navodim-poryadok-v-nezhilykh-pomeshcheniyakh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/navodim-poryadok-v-nezhilykh-pomeshcheniyakh/000-photo.jpg/000-photo.jpg 2x",
            "views": 8643,
            "total_comment": 0,
            "is_video": true,
            "likes": 15,
            "id": "648ac9e238aced40254f2114"
        },
        {
            "title": "Как установить уличный светильник в грунт",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "22.12.2020",
            "link": "kak-ustanovit-ulichnyy-svetilnik-v-grunt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit-svetilniki-v-grunt-ili-sadovyy-stolb/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit-svetilniki-v-grunt-ili-sadovyy-stolb/000-photo.jpg/000-photo.jpg 2x",
            "views": 6425,
            "total_comment": 0,
            "is_video": true,
            "likes": 7,
            "id": "648ac9e238aced40254f2115"
        },
        {
            "title": "Светильники и люстры для натяжных потолков",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "02.06.2022",
            "link": "svetilniki-i-lyustry-dlya-natyazhnyh-potolkov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/svetilniki-i-lyustry-dlya-natyazhnyh-potolkov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/svetilniki-i-lyustry-dlya-natyazhnyh-potolkov/000-photo.jpg/000-photo.jpg 2x",
            "views": 11383,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9e238aced40254f2116"
        },
        {
            "title": "Выбираем светильники Inspire для дачи, сада, загородного дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "23.05.2022",
            "link": "vybiraem-svetilniki-inspire-dlya-dachi-sada-zagorodnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vybiraem-svetilniki-inspire-dlya-dachi-sada-zagorodnogo-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vybiraem-svetilniki-inspire-dlya-dachi-sada-zagorodnogo-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 6651,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9e238aced40254f2117"
        },
        {
            "title": "Как собрать и подключить трековую систему",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "24.01.2023",
            "link": "kak-sobrat-i-podklyuchit-trekovuyu-sistemu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-sobrat-i-podklyuchit-trekovuyu-sistemu/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-sobrat-i-podklyuchit-trekovuyu-sistemu/000-photo.png/000-photo.png 2x",
            "views": 9660,
            "total_comment": 1,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e338aced40254f2118"
        },
        {
            "title": "Как установить настенный уличный светильник",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "23.05.2022",
            "link": "kak-ustanovit-nastennyy-ulichnyy-svetilnik",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/ustanovka-ulichnogo-svetilnika/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/ustanovka-ulichnogo-svetilnika/000-photo.jpg/000-photo.jpg 2x",
            "views": 11167,
            "total_comment": 0,
            "is_video": true,
            "likes": 9,
            "id": "648ac9e338aced40254f2119"
        },
        {
            "title": "Делаем вместе: прихожая в светлых тонах",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "delaem-vmeste-prikhozhaya-v-svetlykh-tonakh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-vmeste-prikhozhaya-v-svetlykh-tonakh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-vmeste-prikhozhaya-v-svetlykh-tonakh/000-photo.jpg/000-photo.jpg 2x",
            "views": 10388,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9e338aced40254f211a"
        },
        {
            "title": "Шкаф на прокачку: 15+ советов по хранению одежды и обуви",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "23.05.2023",
            "link": "shkaf-na-prokachku-15-sovetov-po-hraneniyu-odezhdy-i-obuvi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/shkaf-na-prokachku-15-sovetov-po-hraneniyu-odezhdy-i-obuvi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/shkaf-na-prokachku-15-sovetov-po-hraneniyu-odezhdy-i-obuvi/000-photo.jpg/000-photo.jpg 2x",
            "views": 11950,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9e338aced40254f211b"
        },
        {
            "title": "Как сделать шкаф с жалюзийными дверками своими руками",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-shkaf-s-zhalyuziynymi-dverkami-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sdelat-shkaf-s-zhalyuziynymi-dverkami-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sdelat-shkaf-s-zhalyuziynymi-dverkami-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 4296,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648ac9e338aced40254f211d"
        },
        {
            "title": "Как выбрать фитолампу для комнатных растений и рассады",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "20.03.2023",
            "link": "kak-vybrat-fitolampu-dlya-komnatnyh-rasteniy-i-rassady",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-fitolampu-dlya-komnatnyh-rasteniy-i-rassady/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-fitolampu-dlya-komnatnyh-rasteniy-i-rassady/Photo.jpg/Photo.jpg 2x",
            "views": 8554,
            "total_comment": 4,
            "is_video": false,
            "likes": 14,
            "id": "648ac9e438aced40254f211e"
        },
        {
            "title": "Как выбрать и подключить светодиодную ленту",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "01.06.2022",
            "link": "kak-vybrat-i-podklyuchit-svetodiodnuyu-lentu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshtenie/kak-vybrat-i-podklyuchit-svetodiodnuyu-lentu/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshtenie/kak-vybrat-i-podklyuchit-svetodiodnuyu-lentu/Photo.jpg/Photo.jpg 2x",
            "views": 13145,
            "total_comment": 2,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e438aced40254f211f"
        },
        {
            "title": "Собираем стеллаж для мастерской или гаража: материал, полки, комплектующие",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "23.05.2023",
            "link": "sobiraem-stellazh-dlya-masterskoy-ili-garazha-material-polki-komplektuyushchie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/sobiraem-stellazh-dlya-masterskoy-ili-garazha-material-polki-komplektuyushchie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/sobiraem-stellazh-dlya-masterskoy-ili-garazha-material-polki-komplektuyushchie/000-photo.jpg/000-photo.jpg 2x",
            "views": 9679,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9e438aced40254f2120"
        },
        {
            "title": "Виды и установка точечных светильников",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "22.05.2023",
            "link": "vidy-i-ustanovka-tochechnyh-svetilnikov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vstraivaemyy-svetilnik-napravlennogo-sveta/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vstraivaemyy-svetilnik-napravlennogo-sveta/000-photo.jpg/000-photo.jpg 2x",
            "views": 4188,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9e438aced40254f2121"
        },
        {
            "title": "Свет для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "23.05.2022",
            "link": "svet-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshtenie/svet-dlya-dachi/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshtenie/svet-dlya-dachi/000-hero.jpg/000-hero.jpg 2x",
            "views": 15085,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9e538aced40254f2122"
        },
        {
            "title": "Подбираем комплектующие и собираем модульный шкаф «Лион»",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "23.05.2023",
            "link": "podbiraem-komplektuyushchie-i-sobiraem-modulnyy-shkaf-lion",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1755519268/fudzi/advice/vse-o-sisteme-hraneniya-lion-000-hero.jpg/vse-o-sisteme-hraneniya-lion-000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1755519268/fudzi/advice/vse-o-sisteme-hraneniya-lion-000-hero.jpg/vse-o-sisteme-hraneniya-lion-000-hero.jpg 2x",
            "views": 9936,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9e538aced40254f2123"
        },
        {
            "title": "Три простых идеи: делаем полки, стол и комод из мебельных щитов",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "delaem-polki-stol-i-komod-iz-mebelnyh-shchitov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-polki-stol-i-komod-iz-mebelnyh-shchitov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-polki-stol-i-komod-iz-mebelnyh-shchitov/000-photo.jpg/000-photo.jpg 2x",
            "views": 5706,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e538aced40254f2124"
        },
        // {
        //     "title": "Как сделать раскладку плитки в ванной комнате",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Сантехника",
        //     "dept_slug": "santehnika",
        //     "date_publish": "29.12.2021",
        //     "link": "kak-sdelat-raskladku-plitki-v-vannoy-komnate",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-sdelat-raskladku-plitki-v-vannoy-komnate/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-sdelat-raskladku-plitki-v-vannoy-komnate/Photo.jpg/Photo.jpg 2x",
        //     "views": 14981,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 13,
        //     "id": "648ac9e538aced40254f2125"
        // },
        {
            "title": "Как выбрать сантехнику и мебель для маленькой ванной комнаты",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "29.12.2021",
            "link": "kak-vybrat-santehniku-i-mebel-dlya-malenkoy-vannoy-komnaty",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-santehniku-dlya-malenkih-vannyh-komnat/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-santehniku-dlya-malenkih-vannyh-komnat/Photo.jpg/Photo.jpg 2x",
            "views": 5089,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e538aced40254f2126"
        },
        {
            "title": "Гравировка: мастер-класс по декорированию светильника",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "03.06.2022",
            "link": "gravirovka-master-klass-po-dekorirovaniyu-svetilnika",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/gravirovka-master-klass-po-dekorirovaniyu-svetilnika/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/gravirovka-master-klass-po-dekorirovaniyu-svetilnika/000-photo.jpg/000-photo.jpg 2x",
            "views": 10642,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9e638aced40254f2127"
        },
        {
            "title": "Как выбрать болгарку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "24.02.2022",
            "link": "kak-vybrat-bolgarku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-bolgarku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-bolgarku/000-photo.jpg/000-photo.jpg 2x",
            "views": 15987,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648ac9e638aced40254f2128"
        },
        {
            "title": "Организуем хранение инструмента и аксессуаров в домашней мастерской вместе с Bosch",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "organizuem-hranenie-instrumenta-i-aksessuarov-v-domashney-masterskoy-vmeste-s-bosch",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/organizuem-hranenie-instrumenta-i-aksessuarov-v-domashney-masterskoy-vmeste-s-bosch/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/organizuem-hranenie-instrumenta-i-aksessuarov-v-domashney-masterskoy-vmeste-s-bosch/000-photo.jpg/000-photo.jpg 2x",
            "views": 9644,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e638aced40254f2129"
        },
        {
            "title": "Как собрать и повесить вертикальные жалюзи",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.02.2022",
            "link": "kak-sobrat-i-povesit-vertikalnye-zhalyuzi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sobrat-i-povesit-vertikalnye-zhalyuzi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sobrat-i-povesit-vertikalnye-zhalyuzi/000-photo.jpg/000-photo.jpg 2x",
            "views": 13581,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e638aced40254f212a"
        },
        {
            "title": "Как выбрать кухонную мойку из кварца",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "25.05.2022",
            "link": "kak-vybrat-kuhonnuyu-moyku-iz-kvarca",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-kuhonnuyu-moyku-iz-kvarca/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-kuhonnuyu-moyku-iz-kvarca/000-photo.jpg/000-photo.jpg 2x",
            "views": 15886,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9e638aced40254f212b"
        },
        {
            "title": "Точнее, быстрее и удобнее: 3 умных гаджета Bosch",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "tochnee-bystree-i-udobnee-3-umnyh-gadzheta-bosch",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/tochnee-bystree-i-udobnee-3-umnyh-gadzheta-bosch/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/tochnee-bystree-i-udobnee-3-umnyh-gadzheta-bosch/000-photo.jpg/000-photo.jpg 2x",
            "views": 6732,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e738aced40254f212c"
        },
        {
            "title": "10 идей интерьерных поделок из ЛДСП",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "10-idey-interernyh-podelok-iz-ldsp",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/10-idey-interernyh-podelok-iz-ldsp/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/10-idey-interernyh-podelok-iz-ldsp/000-photo.jpg/000-photo.jpg 2x",
            "views": 8106,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9e738aced40254f212d"
        },
        {
            "title": "Зимняя сказка: подбираем идеальные цвета",
            "description": "Зимняя сказка: подбираем идеальные цвета",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "zimnyaya-skazka-podbiraem-idealnye-tsveta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/zimnyaya-skazka-podbiraem-idealnye-tsveta-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/zimnyaya-skazka-podbiraem-idealnye-tsveta-/000-photo.jpg/000-photo.jpg 2x",
            "views": 15782,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9e738aced40254f212e"
        },
        {
            "title": "Как выбрать двери купе",
            "description": "Как планировать встроенные шкафы",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-dveri-kupe",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-dveri-kupe/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-dveri-kupe/000-photo.jpg/000-photo.jpg 2x",
            "views": 8407,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e738aced40254f212f"
        },
        {
            "title": "Делаем вместе: функциональная прихожая",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "delaem-vmeste-funkcionalnaya-prihozhaya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-vmeste-funkcionalnaya-prihozhaya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/delaem-vmeste-funkcionalnaya-prihozhaya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15439,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9e738aced40254f2130"
        },
        {
            "title": "Как выбрать обувницу",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "24.08.2022",
            "link": "kak-vybrat-obuvnitsu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-obuvnitsu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-obuvnitsu/000-photo.jpg/000-photo.jpg 2x",
            "views": 11845,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9e838aced40254f2131"
        },
        {
            "title": "Аксессуары для шкафов",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "17.08.2022",
            "link": "aksessuary-dlya-shkafov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/aksessuary-dlya-shkafov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/aksessuary-dlya-shkafov/000-photo.jpg/000-photo.jpg 2x",
            "views": 12123,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9e838aced40254f2132"
        },
        {
            "title": "Как собрать навесную систему хранения",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "kak-sobrat-navesnuyu-sistemu-hraneniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sobrat-navesnuyu-sistemu-hraneniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-sobrat-navesnuyu-sistemu-hraneniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 10595,
            "total_comment": 0,
            "is_video": true,
            "likes": 9,
            "id": "648ac9e838aced40254f2133"
        },
        {
            "title": "Проекты клиентов: семейное гнездышко своими руками",
            "description": "Проекты клиентов: спальня и прихожая с яркими акцентами",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "proekty-klientov-spalnya-i-prikhozhaya-s-yarkimi-aktsentami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-spalnya-i-prikhozhaya-s-yarkimi-aktsentami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-spalnya-i-prikhozhaya-s-yarkimi-aktsentami/000-photo.jpg/000-photo.jpg 2x",
            "views": 14198,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9e838aced40254f2134"
        },
        {
            "title": "Весне дорогу: генеральная уборка после зимы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "02.02.2022",
            "link": "vesne-dorogu-generalnaya-uborka-posle-zimy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vesne-dorogu-generalnaya-uborka-posle-zimy/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vesne-dorogu-generalnaya-uborka-posle-zimy/000-hero.jpg/000-hero.jpg 2x",
            "views": 10462,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9e838aced40254f2135"
        },
        {
            "title": "Новое поколение лазерных нивелиров",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "25.02.2022",
            "link": "novoe-pokolenie-lazernyh-nivelirov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/novoe-pokolenie-lazernyh-nivelirov-bosch/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/novoe-pokolenie-lazernyh-nivelirov-bosch/000-photo.jpg/000-photo.jpg 2x",
            "views": 6985,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e838aced40254f2136"
        },
        {
            "title": "Обустраиваем домашнюю мастерскую: рабочее место, инструменты, система хранения",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.03.2022",
            "link": "obustraivaem-domashnyuyu-masterskuyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/obustraivaem-domashnyuyu-masterskuyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/obustraivaem-domashnyuyu-masterskuyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 12758,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9e938aced40254f2137"
        },
        {
            "title": "Все, что нужно знать об освещении",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "31.05.2022",
            "link": "vse-chto-nuzhno-znat-ob-osveshchenii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vse-chto-nuzhno-znat-ob-osveshchenii/000_Photo.jpg/000_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/vse-chto-nuzhno-znat-ob-osveshchenii/000_Photo.jpg/000_Photo.jpg 2x",
            "views": 14428,
            "total_comment": 5,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e938aced40254f2138"
        },
        {
            "title": "Выбираем электропилы и распиловочные станки для работы по дереву",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "24.02.2022",
            "link": "vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/000-photo.png/000-photo.png 2x",
            "views": 5093,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9e938aced40254f2139"
        },
        {
            "title": "Как правильно работать сваркой",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "24.02.2022",
            "link": "kak-pravilno-rabotat-svarkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pravilno-rabotat-svarkoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pravilno-rabotat-svarkoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 5643,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9e938aced40254f213a"
        },
        {
            "title": "Как защитить рассаду от вредителей",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "12.04.2022",
            "link": "kak-zashchitit-rassadu-ot-vrediteley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-zashchitit'-rassadu-ot-vrediteley/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-zashchitit'-rassadu-ot-vrediteley/000-photo.jpg/000-photo.jpg 2x",
            "views": 13180,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9e938aced40254f213b"
        },
        {
            "title": "Тренды в отделке ванной комнаты 2022",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "24.05.2022",
            "link": "trendy-v-otdelke-vannoy-komnaty",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/trendy-v-otdelke-vannoy-komnaty-2022/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/trendy-v-otdelke-vannoy-komnaty-2022/000-photo.jpg/000-photo.jpg 2x",
            "views": 16150,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9ea38aced40254f213c"
        },
        {
            "title": "Маленькая кухня — не повод для расстройства",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "14.11.2022",
            "link": "malenkaya-kuhnya-ne-povod-dlya-rasstroystva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/malen'kaya-kukhnya-ne-povod-dlya-rasstroystva/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/malen'kaya-kukhnya-ne-povod-dlya-rasstroystva/000-photo.jpg/000-photo.jpg 2x",
            "views": 6063,
            "total_comment": 4,
            "is_video": false,
            "likes": 8,
            "id": "648ac9ea38aced40254f213d"
        },
        {
            "title": "Проекты клиентов: персональная Скандинавия",
            "description": "Проекты клиентов: персональная Скандинавия",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "proekty-klientov-personalnaya-skandinaviya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-personalnaya-skandinaviya/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-personalnaya-skandinaviya/000-hero.jpg/000-hero.jpg 2x",
            "views": 9263,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9ea38aced40254f213e"
        },
        {
            "title": "Разделяй и радуйся. Шесть способов зонировать интерьер",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "razdelyay-i-raduysya-shest-sposobov-zonirovat-interer",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/razdelyay-i-raduysya-shest-sposobov-zonirovat-interer/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/razdelyay-i-raduysya-shest-sposobov-zonirovat-interer/000-photo.jpg/000-photo.jpg 2x",
            "views": 14735,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9ea38aced40254f213f"
        },
        {
            "title": "Проекты клиентов: семейное гнездышко своими руками",
            "description": "Проекты клиентов: семейное гнездышко своими руками",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "proekty-klientov-semeynoe-gnezdyshko-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-semeynoe-gnezdyshko-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-semeynoe-gnezdyshko-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 7165,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9ea38aced40254f2140"
        },
        {
            "title": "Проекты клиентов: таунхаус с этажами в разных стилях",
            "description": "Проекты клиентов: таунхаус с этажами в разных стилях",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "proekty-klientov-taunkhaus-s-etazhami-v-raznykh-stilyakh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-taunkhaus-s-etazhami-v-raznykh-stilyakh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-taunkhaus-s-etazhami-v-raznykh-stilyakh/000-photo.jpg/000-photo.jpg 2x",
            "views": 16265,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9eb38aced40254f2141"
        },
        {
            "title": "Виды стелажей",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "08.09.2019",
            "link": "vidy-stelazhey",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/vidy-stelazhey/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/vidy-stelazhey/000-photo.jpg/000-photo.jpg 2x",
            "views": 7046,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9eb38aced40254f2142"
        },
        {
            "title": "Виды гардеробных систем",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "05.10.2021",
            "link": "vidy-garderobnykh-sistem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/vidy-garderobnykh-sistem/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/vidy-garderobnykh-sistem/000-photo.jpg/000-photo.jpg 2x",
            "views": 6723,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648ac9eb38aced40254f2143"
        },
        {
            "title": "Гардеробная для разных типов планировок",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "19.10.2021",
            "link": "garderobnaya-dlya-raznykh-tipov-planirovok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/garderobnaya-dlya-raznykh-tipov-planirovok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/garderobnaya-dlya-raznykh-tipov-planirovok/000-photo.jpg/000-photo.jpg 2x",
            "views": 6264,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9eb38aced40254f2144"
        },
        {
            "title": "Проекты клиентов: бохо-кухня для съемок",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2021",
            "link": "proekty-klientov-boho-kuhnya-dlya-semok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/proekty-klientov-bokho-kukhnya-dlya-semok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/proekty-klientov-bokho-kukhnya-dlya-semok/000-photo.jpg/000-photo.jpg 2x",
            "views": 6470,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9ec38aced40254f2145"
        },
        {
            "title": "Детский столик своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "11.01.2022",
            "link": "detskiy-stolik-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskiy-stolik-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskiy-stolik-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 13355,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9ec38aced40254f2146"
        },
        {
            "title": "Как выбрать светильники для ванной",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "14.05.2022",
            "link": "kak-vybrat-svetilniki-dlya-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-svetilniki-dlya-vannoy/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-svetilniki-dlya-vannoy/000-hero.jpg/000-hero.jpg 2x",
            "views": 8214,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9ec38aced40254f2147"
        },
        {
            "title": "Как выбрать инверторный сварочный аппарат",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "kak-vybrat-invertornyy-svarochnyy-apparat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-invertornyy-svarochnyy-apparat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-invertornyy-svarochnyy-apparat/000-photo.jpg/000-photo.jpg 2x",
            "views": 6185,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9ec38aced40254f2148"
        },
        {
            "title": "Как выбрать лобзик",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "kak-vybrat-lobzik",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-lobzik/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-lobzik/000-photo.jpg/000-photo.jpg 2x",
            "views": 9173,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9ec38aced40254f2149"
        },
        {
            "title": "Как измерить ванную комнату",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.07.2022",
            "link": "kak-izmerit-vannuyu-komnatu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-izmerit-vannuyu-komnatu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-izmerit-vannuyu-komnatu/000-photo.jpg/000-photo.jpg 2x",
            "views": 16341,
            "total_comment": 4,
            "is_video": false,
            "likes": 10,
            "id": "648ac9ed38aced40254f214a"
        },
        {
            "title": "Как выбрать дрель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "kak-vybrat-drel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-drel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-drel/000-photo.jpg/000-photo.jpg 2x",
            "views": 7036,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9ed38aced40254f214b"
        },
        {
            "title": "Как правильно выбрать шторы?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "22.04.2022",
            "link": "kak-pravilno-vybrat-shtory",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravil'no-vybrat'-shtory/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravil'no-vybrat'-shtory/000-photo.jpg/000-photo.jpg 2x",
            "views": 9058,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9ed38aced40254f214c"
        },
        {
            "title": "Как выбрать душевой поддон",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "29.04.2022",
            "link": "kak-vybrat-dushevoy-poddon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/sovety-po-vyboru-dushevogo-poddona/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/sovety-po-vyboru-dushevogo-poddona/000-photo.png/000-photo.png 2x",
            "views": 7728,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9ed38aced40254f214d"
        },
        {
            "title": "Как установить домофон - как сделать?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "15.04.2022",
            "link": "kak-ustanovit-domofon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-ustanovit-domofon/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-ustanovit-domofon/000-photo.png/000-photo.png 2x",
            "views": 13865,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648ac9ed38aced40254f214e"
        },
        {
            "title": "Как защитить рассаду от болезней",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "13.04.2022",
            "link": "kak-zashchitit-rassadu-ot-bolezney",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-zashchitit'-rassadu-ot-bolezney/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-zashchitit'-rassadu-ot-bolezney/000-photo.jpg/000-photo.jpg 2x",
            "views": 6896,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9ee38aced40254f214f"
        },
        {
            "title": "Детская кровать в скандинавском стиле своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "25.03.2021",
            "link": "detskaya-krovat-v-skandinavskom-stile-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskaya-krovat-v-skandinavskom-stile-svoimi-rukami/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskaya-krovat-v-skandinavskom-stile-svoimi-rukami/000-hero.jpg/000-hero.jpg 2x",
            "views": 8655,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9ee38aced40254f2150"
        },
        {
            "title": "Стеллаж-лесенка для детской",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "13.05.2022",
            "link": "stellazh-lesenka-dlya-detskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stellazh-lesenka-dlya-detskoy/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stellazh-lesenka-dlya-detskoy/000-photo.png/000-photo.png 2x",
            "views": 8542,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9ee38aced40254f2151"
        },
        {
            "title": "Уютная лоджия с акцентной стеной",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "07.01.2022",
            "link": "uyutnaya-lodzhiya-s-akcentnoy-stenoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/uyutnaya-lodzhiya-s-akcentnoy-stenoy/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/uyutnaya-lodzhiya-s-akcentnoy-stenoy/000-photo.png/000-photo.png 2x",
            "views": 15004,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9ee38aced40254f2152"
        },
        {
            "title": "Стол-скамейка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "12.04.2022",
            "link": "stol-skameyka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stol-skameyka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stol-skameyka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 10463,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9ee38aced40254f2153"
        },
        {
            "title": "Как выбрать и установить уличное освещение",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "25.05.2022",
            "link": "kak-vybrat-i-ustanovit-ulichnoe-osveshchenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/000-photo.png/000-photo.png 2x",
            "views": 16407,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648ac9ef38aced40254f2154"
        },
        {
            "title": "Ключница своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "klyuchnica-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/klyuchnica-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/klyuchnica-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 9005,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9ef38aced40254f2155"
        },
        {
            "title": "Деревянная прикроватная тумба своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "15.04.2021",
            "link": "derevyannaya-prikrovatnaya-tumba-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-prikrovatnaya-tumbasvoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-prikrovatnaya-tumbasvoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 5138,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9ef38aced40254f2156"
        },
        {
            "title": "Деревянная перегородка в прихожей",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "10.03.2021",
            "link": "derevyannaya-peregorodka-v-prihozhey",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-peregorodka-v-prihozhey/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-peregorodka-v-prihozhey/000-photo.png/000-photo.png 2x",
            "views": 11293,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9ef38aced40254f2157"
        },
        {
            "title": "Деревянная кухня своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.07.2022",
            "link": "derevyannaya-kuhnya-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-kuhnya-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-kuhnya-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7827,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9ef38aced40254f2158"
        },
        {
            "title": "Как выбрать мойку из мраморной крошки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "18.09.2019",
            "link": "kak-vybrat-moyku-iz-mramornoy-kroshki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-moyku-iz-mramornoy-kroshki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-moyku-iz-mramornoy-kroshki/000-photo.jpg/000-photo.jpg 2x",
            "views": 12831,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f038aced40254f2159"
        },
        {
            "title": "Журнальный столик своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "09.02.2022",
            "link": "zhurnalnyy-stolik-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhurnalnyy-stolik-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhurnalnyy-stolik-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 5159,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9f038aced40254f215a"
        },
        {
            "title": "Как сгладить неровности пола с помощью наливного пола",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "26.04.2022",
            "link": "kak-sgladit-nerovnosti-pola-s-pomoshchyu-nalivnogo-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sgladit-nerovnosti-pola-s-pomoshchyu-nalivnogo-pola/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sgladit-nerovnosti-pola-s-pomoshchyu-nalivnogo-pola/000-hero.jpg/000-hero.jpg 2x",
            "views": 13829,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f038aced40254f215b"
        },
        {
            "title": "Как сделать вентиляцию в ванной",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "26.04.2022",
            "link": "kak-sdelat-ventilyatsiyu-v-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-sdelat-ventilyatsiyu-v-vannoy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-sdelat-ventilyatsiyu-v-vannoy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4532,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648ac9f038aced40254f215c"
        },
        {
            "title": "Полусухая стяжка пола своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "26.04.2022",
            "link": "polusukhaya-styazhka-pola-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/polusukhaya-styazhka-pola-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/polusukhaya-styazhka-pola-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 13497,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f038aced40254f215d"
        },
        {
            "title": "Как сделать гидроизоляцию пола",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "26.04.2022",
            "link": "kak-sdelat-gidroizolyatsiyu-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-gidroizolyatsiyu-pola/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-gidroizolyatsiyu-pola/000-photo.jpg/000-photo.jpg 2x",
            "views": 11853,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f138aced40254f215e"
        },
        {
            "title": "Тележка-кашпо для садовых цветов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "12.02.2022",
            "link": "telezhka-kashpo-dlya-sadovyh-cvetov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/telezhka-kashpo-dlya-sadovyh-cvetov-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/telezhka-kashpo-dlya-sadovyh-cvetov-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 10788,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9f138aced40254f2160"
        },
        {
            "title": "Картина из подручных материалов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "24.02.2022",
            "link": "kartina-iz-podruchnyh-materialov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kartina-iz-podruchnyh-materialov-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kartina-iz-podruchnyh-materialov-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 4559,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f138aced40254f2161"
        },
        {
            "title": "Подвесное кашпо для цветов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "02.01.2022",
            "link": "podvesnoe-kashpo-dlya-cvetov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1738137462/fudzi/advice/podvesnoe-kashpo-svoimi-rukami-000-photo.jpg/podvesnoe-kashpo-svoimi-rukami-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1738137462/fudzi/advice/podvesnoe-kashpo-svoimi-rukami-000-photo.jpg/podvesnoe-kashpo-svoimi-rukami-000-photo.jpg 2x",
            "views": 7177,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9f138aced40254f2162"
        },
        {
            "title": "Подставка под горячее своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "21.03.2022",
            "link": "podstavka-pod-goryachee-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podstavka-pod-goryachee-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podstavka-pod-goryachee-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 15811,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9f238aced40254f2163"
        },
        {
            "title": "Кашпо для суккулентов",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "06.01.2022",
            "link": "kashpo-dlya-sukkulentov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kashpo-dlya-sukkulentov/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kashpo-dlya-sukkulentov/000-hero.jpg/000-hero.jpg 2x",
            "views": 8622,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9f238aced40254f2164"
        },
        {
            "title": "Живая картина из суккулентов",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "02.01.2022",
            "link": "zhivaya-kartina-iz-sukkulentov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhivaya-kartina-iz-sukkulentov/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhivaya-kartina-iz-sukkulentov/000-photo.png/000-photo.png 2x",
            "views": 4885,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f238aced40254f2165"
        },
        {
            "title": "Декоративные фонарики своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "12.01.2022",
            "link": "dekorativnye-fonariki-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnye-fonariki-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnye-fonariki-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 5054,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9f238aced40254f2166"
        },
        {
            "title": "Кашпо из джута",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.01.2022",
            "link": "kashpo-iz-dzhuta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kashpo-iz-dzhuta/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kashpo-iz-dzhuta/000-photo.png/000-photo.png 2x",
            "views": 12551,
            "total_comment": 2,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f238aced40254f2167"
        },
        {
            "title": "Фотофон из подручных материалов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "23.02.2022",
            "link": "fotofon-iz-podruchnyh-materialov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/fotofon-iz-podruchnyh-materialov-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/fotofon-iz-podruchnyh-materialov-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 11752,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9f338aced40254f2168"
        },
        {
            "title": "Декорирование стены деревянными рейками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.01.2022",
            "link": "dekorirovanie-steny-derevyannymi-reykami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorirovanie-steny-derevyannymi-reykami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorirovanie-steny-derevyannymi-reykami/000-photo.png/000-photo.png 2x",
            "views": 15078,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9f338aced40254f2169"
        },
        {
            "title": "Декоративная лесенка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "09.02.2022",
            "link": "dekorativnaya-lesenka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-lesenka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-lesenka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 15061,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9f338aced40254f216a"
        },
        {
            "title": "Доска настроения (мудборд) своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "23.02.2022",
            "link": "doska-nastroeniya-mudbord-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/doska-nastroeniya-mudbord-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/doska-nastroeniya-mudbord-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 16509,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9f338aced40254f216b"
        },
        {
            "title": "Декоративная вешалка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "06.05.2022",
            "link": "dekorativnaya-veshalka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-veshalka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-veshalka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7843,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9f338aced40254f216c"
        },
        {
            "title": "Переносной столик своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "15.02.2022",
            "link": "perenosnoy-stolik-dlya-noutbuka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/perenosnoy-stolik-dlya-noutbuka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/perenosnoy-stolik-dlya-noutbuka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7221,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9f338aced40254f216d"
        },
        {
            "title": "Полка-столик для ванны своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "15.02.2022",
            "link": "polka-stolik-dlya-vanny-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/polka-stolik-dlya-vanny-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/polka-stolik-dlya-vanny-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 8153,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f438aced40254f216e"
        },
        {
            "title": "Подставка для столовых приборов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "podstavka-dlya-stolovyh-priborov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1737009440/fudzi/advice/podstavka-pod-pribiri-1.jpg/podstavka-pod-pribiri-1.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1737009440/fudzi/advice/podstavka-pod-pribiri-1.jpg/podstavka-pod-pribiri-1.jpg 2x",
            "views": 4607,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9f438aced40254f216f"
        },
        {
            "title": "Дизайнерский консольный столик своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "26.02.2022",
            "link": "dizaynerskiy-konsolnyy-stolik-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dizaynerskiy-konsolnyy-stolik-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dizaynerskiy-konsolnyy-stolik-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 6604,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9f438aced40254f2170"
        },
        {
            "title": "Садовый игровой домик своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "10.03.2021",
            "link": "sadovyy-igrovoy-domik-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/sadovyy-igrovoy-domik-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/sadovyy-igrovoy-domik-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 12241,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9f438aced40254f2171"
        },
        {
            "title": "Шкаф в прихожей",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "07.03.2022",
            "link": "shkaf-v-prihozhey",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/shkaf-v-prihozhey/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/shkaf-v-prihozhey/000-hero.jpg/000-hero.jpg 2x",
            "views": 15169,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9f438aced40254f2172"
        },
        {
            "title": "Шкаф для хранения солений на балконе",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "03.01.2022",
            "link": "shkaf-dlya-hraneniya-soleniy-na-balkone",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/shkaf-dlya-hraneniya-soleniy-na-balkone/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/shkaf-dlya-hraneniya-soleniy-na-balkone/000-photo.png/000-photo.png 2x",
            "views": 4203,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9f538aced40254f2173"
        },
        {
            "title": "3D рамка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "3d-ramka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/3d-ramka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/3d-ramka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 10745,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f538aced40254f2174"
        },
        {
            "title": "Чайный поднос своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "03.02.2022",
            "link": "chaynyy-podnos-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/chaynyy-podnos-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/chaynyy-podnos-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 14711,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9f538aced40254f2175"
        },
        {
            "title": "Арт-панно из эпоксидной смолы",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "04.01.2021",
            "link": "art-panno-iz-epoksidnoy-smoly",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/art-panno-iz-epoksidnoy-smoly/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/art-panno-iz-epoksidnoy-smoly/000-photo.png/000-photo.png 2x",
            "views": 4310,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9f538aced40254f2176"
        },
        {
            "title": "Декоративная рамка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.03.2022",
            "link": "dekorativnaya-ramka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-ramka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorativnaya-ramka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 15908,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9f538aced40254f2177"
        },
        {
            "title": "Дженга своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "dzhenga-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dzhenga-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dzhenga-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 5500,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9f638aced40254f2178"
        },
        {
            "title": "Гекс горшок своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "geks-gorshok-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1737713834/fudzi/advice/gegs-gorshok-9.jpg/gegs-gorshok-9.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1737713834/fudzi/advice/gegs-gorshok-9.jpg/gegs-gorshok-9.jpg 2x",
            "views": 6105,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9f638aced40254f217a"
        },
        {
            "title": "Организация освещения на кухне",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "22.05.2023",
            "link": "organizaciya-osveshcheniya-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/organizaciya-osveshcheniya-na-kuhne/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/organizaciya-osveshcheniya-na-kuhne/Photo.jpg/Photo.jpg 2x",
            "views": 8887,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9f638aced40254f217b"
        },
        {
            "title": "Детская игрушечная кухня своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "03.02.2022",
            "link": "detskaya-igrushechnaya-kuhnya-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskaya-igrushechnaya-kuhnya-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/detskaya-igrushechnaya-kuhnya-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 12346,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9f738aced40254f217c"
        },
        {
            "title": "Декорирование стены досками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.02.2022",
            "link": "dekorirovanie-steny-doskami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorirovanie-steny-doskami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dekorirovanie-steny-doskami/000-photo.png/000-photo.png 2x",
            "views": 16428,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f738aced40254f217d"
        },
        {
            "title": "Выбор бачка для унитаза",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.07.2022",
            "link": "vybor-bachka-dlya-unitaza",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vybor-bachka-dlya-unitaza/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vybor-bachka-dlya-unitaza/000-photo.jpg/000-photo.jpg 2x",
            "views": 12540,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9f738aced40254f217f"
        },
        {
            "title": "Уютная лежанка для питомца своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "08.02.2022",
            "link": "uyutnaya-lezhanka-dlya-pitomca-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/uyutnaya-lezhanka-dlya-pitomca-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/uyutnaya-lezhanka-dlya-pitomca-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7444,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9f738aced40254f2180"
        },
        {
            "title": "Ящик для мелочей в технике обжига",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "25.02.2022",
            "link": "yashchik-dlya-melochey-v-tehnike-obzhiga",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/yashchik-dlya-melochey-v-tehnike-obzhiga/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/yashchik-dlya-melochey-v-tehnike-obzhiga/000-photo.png/000-photo.png 2x",
            "views": 6885,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9f838aced40254f2181"
        },
        {
            "title": "Роскошное гримёрное зеркало",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "12.04.2022",
            "link": "roskoshnoe-grimernoe-zerkalo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/roskoshnoe-grimernoe-zerkalo/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/roskoshnoe-grimernoe-zerkalo/000-photo.png/000-photo.png 2x",
            "views": 8695,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9f838aced40254f2182"
        },
        {
            "title": "Реставрация старого комода",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "08.03.2022",
            "link": "restavraciya-starogo-komoda",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-starogo-komoda/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-starogo-komoda/000-photo.png/000-photo.png 2x",
            "views": 9818,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9f838aced40254f2183"
        },
        {
            "title": "Пуфик-банкетка своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "09.02.2022",
            "link": "pufik-banketka-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/pufik-banketka-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/pufik-banketka-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 4865,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9f838aced40254f2184"
        },
        {
            "title": "Столик-накладка на диван своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "18.03.2022",
            "link": "stolik-nakladka-na-divan-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stolik-nakladka-na-divan-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/stolik-nakladka-na-divan-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 10089,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9f838aced40254f2185"
        },
        {
            "title": "Оформление стены декоративным камнем",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "22.02.2022",
            "link": "oformlenie-steny-dekorativnym-kamnem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/oformlenie-steny-dekorativnym-kamnem/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/oformlenie-steny-dekorativnym-kamnem/000-hero.jpg/000-hero.jpg 2x",
            "views": 10535,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648ac9f938aced40254f2186"
        },
        {
            "title": "Живое панно из мха своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "23.05.2022",
            "link": "zhivoe-panno-iz-mha-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhivoe-panno-iz-mha-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/zhivoe-panno-iz-mha-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 9367,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9f938aced40254f2187"
        },
        {
            "title": "Как выбрать электрогриль для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "30.09.2022",
            "link": "kak-vybrat-elektrogril-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektrogril'-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektrogril'-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 13390,
            "total_comment": 4,
            "is_video": false,
            "likes": 12,
            "id": "648ac9fa38aced40254f218d"
        },
        {
            "title": "Как выбрать вентилятор для дома и квартиры",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "03.10.2022",
            "link": "kak-vybrat-ventilyator-dlya-doma-i-kvartiry",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-ventilyator-dlya-doma-i-kvartiry/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-ventilyator-dlya-doma-i-kvartiry/000-photo.jpg/000-photo.jpg 2x",
            "views": 14516,
            "total_comment": 2,
            "is_video": false,
            "likes": 8,
            "id": "648ac9fa38aced40254f218e"
        },
        {
            "title": "Ящик для фруктов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "yashchik-dlya-fruktov-i-ovoshchey-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/v1737715461/fudzi/advice/yachik-dla-fruktov-6.jpg/yachik-dla-fruktov-6.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/v1737715461/fudzi/advice/yachik-dla-fruktov-6.jpg/yachik-dla-fruktov-6.jpg 2x",
            "views": 10931,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9fa38aced40254f218f"
        },
        {
            "title": "Подвесная ваза для цветов своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "07.02.2021",
            "link": "podvesnaya-vaza-dlya-cvetov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podvesnaya-vaza-dlya-cvetov-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podvesnaya-vaza-dlya-cvetov-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 16632,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9fb38aced40254f2190"
        },
        {
            "title": "Реставрация полки в ванной",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "16.01.2022",
            "link": "restavraciya-polki-v-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-polki-v-vannoy/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-polki-v-vannoy/000-hero.jpg/000-hero.jpg 2x",
            "views": 13370,
            "total_comment": 0,
            "is_video": false,
            "likes": 16,
            "id": "648ac9fb38aced40254f2192"
        },
        {
            "title": "Полка-лесенка на джутовом канате",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "10.05.2022",
            "link": "polka-lesenka-na-dzhutovom-kanate",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/polka-lesenka-na-dzhutovom-kanate/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/polka-lesenka-na-dzhutovom-kanate/000-photo.png/000-photo.png 2x",
            "views": 14130,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9fb38aced40254f2193"
        },
        {
            "title": "Рабочий стол с ящиками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "16.03.2021",
            "link": "rabochiy-stol-s-yashchikami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/rabochiy-stol-s-yashchikami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/rabochiy-stol-s-yashchikami/000-photo.png/000-photo.png 2x",
            "views": 6728,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9fb38aced40254f2194"
        },
        {
            "title": "Комод в стиле ретро",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "31.12.2021",
            "link": "komod-v-stile-retro",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/komod-v-stile-retro/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/komod-v-stile-retro/000-photo.png/000-photo.png 2x",
            "views": 9758,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9fc38aced40254f2195"
        },
        {
            "title": "Полки соты своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.07.2022",
            "link": "polki-soty-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1737368597/fudzi/advice/polki-soti-svoimi-rukami-000-hero.jpg/polki-soti-svoimi-rukami-000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1737368597/fudzi/advice/polki-soti-svoimi-rukami-000-hero.jpg/polki-soti-svoimi-rukami-000-hero.jpg 2x",
            "views": 7831,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648ac9fc38aced40254f2196"
        },
        {
            "title": "Изголовье кровати из жалюзийных дверок",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "27.01.2022",
            "link": "izgolove-krovati-iz-zhalyuziynyh-dverok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/izgolove-krovati-iz-zhalyuziynyh-dverok/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/izgolove-krovati-iz-zhalyuziynyh-dverok/000-photo.png/000-photo.png 2x",
            "views": 5586,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9fc38aced40254f2197"
        },
        {
            "title": "Как выбрать правильную хлебопечку для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "04.10.2022",
            "link": "kak-vybrat-pravilnuyu-hlebopechku-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-pravil'nuyu-hlebopechku-dlya-doma/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-pravil'nuyu-hlebopechku-dlya-doma/000-hero.jpg/000-hero.jpg 2x",
            "views": 10627,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9fc38aced40254f2198"
        },
        {
            "title": "Как и какой выбрать триммер для бороды и усов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2022",
            "link": "kak-i-kakoy-vybrat-trimmer-dlya-borody-i-usov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakoj-vybrat'-trimmer-dlya-borody-i-usov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakoj-vybrat'-trimmer-dlya-borody-i-usov/000-photo.jpg/000-photo.jpg 2x",
            "views": 9462,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648ac9fc38aced40254f2199"
        },
        {
            "title": "Как выбрать робот-пылесос для квартиры и загородного дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "06.10.2022",
            "link": "kak-vybrat-robot-pylesos-dlya-kvartiry-i-zagorodnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-robot-pylesos-dlya-kvartiry-i-zagorodnogo-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-robot-pylesos-dlya-kvartiry-i-zagorodnogo-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 15267,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9fd38aced40254f219a"
        },
        {
            "title": "Как выбрать кресло-мешок с разным наполнителем и разного размера?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "04.10.2022",
            "link": "kak-vybrat-kreslo-meshok-s-raznym-napolnitelem-i-raznogo-razmera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat'-kreslo-meshok-s-raznym-napolnitelem-i-raznogo-razmera/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat'-kreslo-meshok-s-raznym-napolnitelem-i-raznogo-razmera/000-photo.jpg/000-photo.jpg 2x",
            "views": 14138,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648ac9fd38aced40254f219b"
        },
        {
            "title": "Как выбрать лучшую соковыжималку для овощей и фруктов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "15.11.2022",
            "link": "kak-vybrat-luchshuyu-sokovyzhimalku-dlya-ovoshchey-i-fruktov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-luchuy-sokovizhimalku-dlya-ovochey-i-fructov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-luchuy-sokovizhimalku-dlya-ovochey-i-fructov/000-photo.jpg/000-photo.jpg 2x",
            "views": 5506,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648ac9fd38aced40254f219c"
        },
        {
            "title": "Виды декоративной штукатурки для внутренней отделки: состав, текстура, наполнитель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "03.10.2022",
            "link": "vidy-dekorativnoy-shtukaturki-dlya-vnutrenney-otdelki-sostav-tekstura-napolnitel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-dekorativnoj-shtukaturki-dlya-vnutrennej-otdelki--sostav,-tekstura,-napolnitel'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-dekorativnoj-shtukaturki-dlya-vnutrennej-otdelki--sostav,-tekstura,-napolnitel'/000-photo.jpg/000-photo.jpg 2x",
            "views": 13477,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648ac9fd38aced40254f219d"
        },
        {
            "title": "Что подарить на новоселье друзьям и родственникам",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.10.2022",
            "link": "chto-podarit-na-novosele-druzyam-i-rodstvennikam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-podarit'-na-novosel'e-druz'yam-i-rodstvennikam/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-podarit'-na-novosel'e-druz'yam-i-rodstvennikam/000-photo.jpg/000-photo.jpg 2x",
            "views": 10934,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648ac9fd38aced40254f219e"
        },
        {
            "title": "Какие удобрения вносить осенью под перекопку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "02.10.2022",
            "link": "kakie-udobreniya-vnosit-osenyu-pod-perekopku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kakie-udobreniya-vnocit-osenu-pod-perecop/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kakie-udobreniya-vnocit-osenu-pod-perecop/000-photo.jpg/000-photo.jpg 2x",
            "views": 9356,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648ac9fe38aced40254f219f"
        },
        {
            "title": "Как сделать садовые качели своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "30.09.2022",
            "link": "kak-sdelat-sadovye-kacheli-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-sadovye-kacheli-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-sadovye-kacheli-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 13623,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9fe38aced40254f21a0"
        },
        {
            "title": "Новый шкаф из старой мебельной стенки",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.05.2022",
            "link": "novyy-shkaf-iz-staroy-mebelnoy-stenki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/novyy-shkaf-iz-staroy-mebelnoy-stenki/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/novyy-shkaf-iz-staroy-mebelnoy-stenki/000-photo.png/000-photo.png 2x",
            "views": 12138,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648ac9fe38aced40254f21a1"
        },
        {
            "title": "Органайзер для мелочей своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "01.02.2022",
            "link": "organayzer-dlya-melochey-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/organayzer-dlya-melochey-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/organayzer-dlya-melochey-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 4383,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648ac9fe38aced40254f21a2"
        },
        {
            "title": "Два стеллажа из одного готового",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "07.01.2022",
            "link": "dva-stellazha-iz-odnogo-gotovogo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dva-stellazha-iz-odnogo-gotovogo/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/dva-stellazha-iz-odnogo-gotovogo/000-photo.png/000-photo.png 2x",
            "views": 13473,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9ff38aced40254f21a3"
        },
        {
            "title": "Изящный встроенный шкаф в ванной",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "03.01.2022",
            "link": "izyashchnyy-vstroennyy-shkaf-v-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/izyashchnyy-vstroennyy-shkaf-v-vannoy/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/izyashchnyy-vstroennyy-shkaf-v-vannoy/000-photo.png/000-photo.png 2x",
            "views": 8770,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648ac9ff38aced40254f21a4"
        },
        {
            "title": "Подсвечник из алебастра",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "10.01.2021",
            "link": "podsvechnik-iz-alebastra",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podsvechnik-iz-alebastra/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/podsvechnik-iz-alebastra/000-photo.png/000-photo.png 2x",
            "views": 10761,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648ac9ff38aced40254f21a5"
        },
        {
            "title": "Как сделать дачный участок уютным и красивым",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "05.10.2022",
            "link": "kak-sdelat-dachnyy-uchastok-uyutnym-i-krasivym",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-dachnyj-uchastok-uyutnym-i-krasivym/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-dachnyj-uchastok-uyutnym-i-krasivym/000-hero.jpg/000-hero.jpg 2x",
            "views": 15046,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648ac9ff38aced40254f21a7"
        },
        {
            "title": "Что такое мульчирование",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "04.10.2022",
            "link": "chto-takoe-mulchirovanie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-mul'chirovanie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-mul'chirovanie/000-photo.jpg/000-photo.jpg 2x",
            "views": 10651,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca0038aced40254f21a8"
        },
        {
            "title": "Как сделать забор из сетки-рабицы своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "04.10.2022",
            "link": "kak-sdelat-zabor-iz-setki-rabicy-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-zabor-iz-setki-rabicy-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-zabor-iz-setki-rabicy-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 9349,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0038aced40254f21a9"
        },
        {
            "title": "Чем отмыть унитаз от известкового налёта и ржавых потёков",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "03.10.2022",
            "link": "chem-otmyt-unitaz-ot-izvestkovogo-naleta-i-rzhavyh-potekov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chem-otmyt'-unitaz-ot-izvestkovogo-nalyota-i-rzhavyh-potyokov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chem-otmyt'-unitaz-ot-izvestkovogo-nalyota-i-rzhavyh-potyokov/000-photo.jpg/000-photo.jpg 2x",
            "views": 5917,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca0038aced40254f21aa"
        },
        {
            "title": "Как выбрать электрическую мини-печь для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "04.10.2022",
            "link": "kak-vybrat-elektricheskuyu-mini-pech-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-mini-pech'-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-mini-pech'-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 11255,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca0038aced40254f21ab"
        },
        {
            "title": "Самостоятельная укладка бордюра для тротуарной плитки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2022",
            "link": "samostoyatelnaya-ukladka-bordyura-dlya-trotuarnoy-plitki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/samostoyatel'naya-ukladka-bordyura-dlya-trotuarnoj-plitki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/samostoyatel'naya-ukladka-bordyura-dlya-trotuarnoj-plitki/000-photo.jpg/000-photo.jpg 2x",
            "views": 8701,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0038aced40254f21ac"
        },
        {
            "title": "Как выбрать кондиционер для квартиры?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2022",
            "link": "kak-vybrat-kondicioner-dlya-kvartiry",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-kondicioner-dlya-kvartiry-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-kondicioner-dlya-kvartiry-/000-photo.jpg/000-photo.jpg 2x",
            "views": 16634,
            "total_comment": 2,
            "is_video": false,
            "likes": 12,
            "id": "648aca0138aced40254f21ad"
        },
        {
            "title": "Как выбрать гладильную доску для дома и чехол к ней",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "06.10.2022",
            "link": "kak-vybrat-gladilnuyu-dosku-dlya-doma-i-chehol-k-ney",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-gladil'nuyu-dosku-dlya-doma-i-chekhol-k-nej/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-gladil'nuyu-dosku-dlya-doma-i-chekhol-k-nej/000-photo.jpg/000-photo.jpg 2x",
            "views": 13700,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca0138aced40254f21ae"
        },
        {
            "title": "Термопот: что это такое, как им пользоваться, сравнение с чайником и сложности выбора",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "29.09.2022",
            "link": "termopot-chto-eto-takoe-kak-im-polzovatsya-sravnenie-s-chaynikom-i-slozhnosti-vybora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/termopot--chto-eto-takoe,-kak-im-pol'zovat'sya,-sravnenie-s-chajnikom-i-slozhnosti-vybora/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/termopot--chto-eto-takoe,-kak-im-pol'zovat'sya,-sravnenie-s-chajnikom-i-slozhnosti-vybora/000-photo.jpg/000-photo.jpg 2x",
            "views": 7413,
            "total_comment": 4,
            "is_video": false,
            "likes": 5,
            "id": "648aca0138aced40254f21af"
        },
        {
            "title": "Деревянная сушилка для белья своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "03.02.2022",
            "link": "derevyannaya-sushilka-dlya-belya-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-sushilka-dlya-belyasvoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-sushilka-dlya-belyasvoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7853,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca0138aced40254f21b0"
        },
        {
            "title": "Деревянная полочка для ванны своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "07.04.2022",
            "link": "derevyannaya-polochka-dlya-vanny-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-polochka-dlya-vanny-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/derevyannaya-polochka-dlya-vanny-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 4046,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0138aced40254f21b1"
        },
        {
            "title": "Реставрация кресла своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.05.2022",
            "link": "restavraciya-kresla-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-kresla-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-kresla-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 14263,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0238aced40254f21b2"
        },
        {
            "title": "Коробки из картона и джута своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "29.01.2022",
            "link": "korobki-iz-kartona-i-dzhuta-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/korobki-iz-kartona-i-dzhuta-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/korobki-iz-kartona-i-dzhuta-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 11853,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca0238aced40254f21b3"
        },
        {
            "title": "Перегородка из жалюзийных дверок",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.02.2022",
            "link": "peregorodka-iz-zhalyuziynyh-dverok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/peregorodka-iz-zhalyuziynyh-dverok/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/peregorodka-iz-zhalyuziynyh-dverok/000-photo.png/000-photo.png 2x",
            "views": 8813,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0238aced40254f21b4"
        },
        {
            "title": "Выбираем лазерный уровень",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.09.2022",
            "link": "vybiraem-lazernyy-uroven",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vibiraem-lazernyi-yroven/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vibiraem-lazernyi-yroven/000-photo.png/000-photo.png 2x",
            "views": 9183,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca0238aced40254f21b5"
        },
        {
            "title": "На какой высоте вешать зеркало в ванной комнате",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "17.08.2022",
            "link": "na-kakoy-vysote-veshat-zerkalo-v-vannoy-komnate",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/na-kakoy-visote-veshat-ztrkalo-v-vannoy-komnate/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/na-kakoy-visote-veshat-ztrkalo-v-vannoy-komnate/000-photo.jpg/000-photo.jpg 2x",
            "views": 16273,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca0238aced40254f21b6"
        },
        {
            "title": "Как красить обои под покраску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "01.09.2022",
            "link": "kak-krasit-oboi-pod-pokrasku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-krasit-oboi-pod-krasky/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-krasit-oboi-pod-krasky/000-photo.png/000-photo.png 2x",
            "views": 8023,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca0338aced40254f21b7"
        },
        {
            "title": "Как правильно разводить колер в краску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "30.08.2022",
            "link": "kak-pravilno-razvodit-koler-v-krasku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-razvodit-koler-v-krasky/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-razvodit-koler-v-krasky/000-photo.jpg/000-photo.jpg 2x",
            "views": 15968,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca0338aced40254f21b8"
        },
        {
            "title": "Какие алюминиевые радиаторы выбрать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.09.2022",
            "link": "kakie-alyuminievye-radiatory-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakie-vibrat-radiatory-aluminievye/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakie-vibrat-radiatory-aluminievye/000-photo.jpg/000-photo.jpg 2x",
            "views": 10006,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca0338aced40254f21b9"
        },
        {
            "title": "Реставрация шкафа своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "26.03.2022",
            "link": "restavraciya-shkafa-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-shkafa-svoimi-rukami/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/restavraciya-shkafa-svoimi-rukami/000-photo.png/000-photo.png 2x",
            "views": 7396,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0338aced40254f21ba"
        },
        {
            "title": "Кухня в бохо-стиле",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "02.02.2022",
            "link": "kuhnya-v-boho-stile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kuhnya-v-boho-stile/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kuhnya-v-boho-stile/000-photo.png/000-photo.png 2x",
            "views": 9796,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca0338aced40254f21bb"
        },
        {
            "title": "Как установить раковину в ванной, на какой высоте вешать и как крепить к стене",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "27.09.2022",
            "link": "kak-ustanovit-rakovinu-v-vannoy-na-kakoy-vysote-veshat-i-kak-krepit-k-stene",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-rakovinu-v-vannoj--na-kakoj-vysote-veshat'-i-kak-krepit'-k-stene/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-rakovinu-v-vannoj--na-kakoj-vysote-veshat'-i-kak-krepit'-k-stene/000-hero.jpg/000-hero.jpg 2x",
            "views": 6876,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0438aced40254f21bc"
        },
        {
            "title": "Фланель – что это за ткань: состав, применение, уход и сравнение с байкой",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.09.2022",
            "link": "flanel-chto-eto-za-tkan-sostav-primenenie-uhod-i-sravnenie-s-baykoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/flanel'---chto-eto-za-tkan'--sostav,-primenenie,-uhod-i-sravnenie-s-bajkoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/flanel'---chto-eto-za-tkan'--sostav,-primenenie,-uhod-i-sravnenie-s-bajkoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 6998,
            "total_comment": 1,
            "is_video": false,
            "likes": 12,
            "id": "648aca0438aced40254f21bd"
        },
        {
            "title": "Как сделать коптильню холодного и горячего копчения своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "28.09.2022",
            "link": "kak-sdelat-koptilnyu-holodnogo-i-goryachego-kopcheniya-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-koptil'nyu-holodnogo-i-goryachego-kopcheniya-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-koptil'nyu-holodnogo-i-goryachego-kopcheniya-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 6682,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0438aced40254f21be"
        },
        {
            "title": "Как выбрать мультиварку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "28.09.2022",
            "link": "kak-vybrat-multivarku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-multivarku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-multivarku/000-photo.jpg/000-photo.jpg 2x",
            "views": 11021,
            "total_comment": 4,
            "is_video": false,
            "likes": 11,
            "id": "648aca0438aced40254f21bf"
        },
        {
            "title": "Как выбрать лучший кухонный комбайн для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "01.10.2022",
            "link": "kak-vybrat-luchshiy-kuhonnyy-kombayn-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-luchuy-sokovizhimalku-dlya-ovochey-i-fructov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-luchuy-sokovizhimalku-dlya-ovochey-i-fructov/000-photo.jpg/000-photo.jpg 2x",
            "views": 10699,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca0438aced40254f21c0"
        },
        {
            "title": "Как сделать мольберт своими руками: пошаговая инструкция",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.09.2022",
            "link": "kak-sdelat-molbert-svoimi-rukami-poshagovaya-instrukciya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat'-mol'bert-svoimi-rukami--poshagovaya-instrukciya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat'-mol'bert-svoimi-rukami--poshagovaya-instrukciya/000-photo.jpg/000-photo.jpg 2x",
            "views": 7156,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca0538aced40254f21c1"
        },
        {
            "title": "Велсофт – что это за ткань: состав, применение, уход и сравнение с байкой",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.09.2022",
            "link": "velsoft-chto-eto-za-tkan-sostav-primenenie-uhod-i-sravnenie-s-baykoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/velsoft-–-chto-eto-za-tkan'--sostav,-primenenie,-uhod-i-sravnenie-s-bajkoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/velsoft-–-chto-eto-za-tkan'--sostav,-primenenie,-uhod-i-sravnenie-s-bajkoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 8936,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca0538aced40254f21c2"
        },
        {
            "title": "Что за ткань полисатин: плюсы и минусы постельного белья из полисатина",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.09.2022",
            "link": "chto-za-tkan-polisatin-plyusy-i-minusy-postelnogo-belya-iz-polisatina",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-za-tkan'-polisatin--plyusy-i-minusy-postel'nogo-bel'ya-iz-polisatina/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-za-tkan'-polisatin--plyusy-i-minusy-postel'nogo-bel'ya-iz-polisatina/000-photo.jpg/000-photo.jpg 2x",
            "views": 15061,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca0538aced40254f21c3"
        },
        {
            "title": "Поплин — что это за ткань, и чем поплин отличается от сатина и бязи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.09.2022",
            "link": "poplin-chto-eto-za-tkan-i-chem-poplin-otlichaetsya-ot-satina-i-byazi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/poplin---chto-eto-za-tkan'-i-chem-poplin-otlichaetsya-ot-satina-i-byazi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/poplin---chto-eto-za-tkan'-i-chem-poplin-otlichaetsya-ot-satina-i-byazi/000-photo.jpg/000-photo.jpg 2x",
            "views": 14251,
            "total_comment": 1,
            "is_video": false,
            "likes": 12,
            "id": "648aca0538aced40254f21c4"
        },
        {
            "title": "Картина в технике флюид-арт",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "24.03.2022",
            "link": "kartina-v-tehnike-flyuid-art",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kartina-v-tehnike-flyuid-art/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/вдохновение/kartina-v-tehnike-flyuid-art/000-photo.png/000-photo.png 2x",
            "views": 16100,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca0538aced40254f21c5"
        },
        {
            "title": "Как выбрать, повесить на плитку и подключить зеркало в ванной комнате",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "27.09.2022",
            "link": "kak-vybrat-povesit-na-plitku-i-podklyuchit-zerkalo-v-vannoy-komnate",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat',-povesit'-na-plitku-i-podklyuchit'-zerkalo-v-vannuyu-komnatu/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat',-povesit'-na-plitku-i-podklyuchit'-zerkalo-v-vannuyu-komnatu/000-hero.jpg/000-hero.jpg 2x",
            "views": 16627,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca0638aced40254f21c6"
        },
        {
            "title": "Как и чем удалить герметик с любых поверхностей и с рук",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "29.09.2022",
            "link": "kak-i-chem-udalit-germetik-s-lyubyh-poverhnostey-i-s-ruk",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-udalit'-germetik-s-lyubyh-poverhnostej-i-s-ruk/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-udalit'-germetik-s-lyubyh-poverhnostej-i-s-ruk/000-photo.jpg/000-photo.jpg 2x",
            "views": 5463,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0638aced40254f21c7"
        },
        {
            "title": "Что такое безободковый унитаз, его плюсы и минусы",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "28.09.2022",
            "link": "chto-takoe-bezobodkovyy-unitaz-ego-plyusy-i-minusy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-bezobodkovyj-unitaz,-ego-plyusy-i-minusy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-bezobodkovyj-unitaz,-ego-plyusy-i-minusy/000-photo.jpg/000-photo.jpg 2x",
            "views": 9030,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0638aced40254f21c8"
        },
        {
            "title": "Что такое DIY",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "27.09.2022",
            "link": "chto-takoe-diy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-diy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-diy/000-photo.jpg/000-photo.jpg 2x",
            "views": 9851,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0638aced40254f21c9"
        },
        {
            "title": "Что такое и для чего нужно биде в туалете? Как выбрать и установить биде.",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "30.09.2022",
            "link": "chto-takoe-i-dlya-chego-nuzhno-bide-v-tualete-kak-vybrat-i-ustanovit-bide",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-i-dlya-chego-nuzhno-bide-v-tualete--kak-vybrat'-i-ustanovit'-bide/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-i-dlya-chego-nuzhno-bide-v-tualete--kak-vybrat'-i-ustanovit'-bide/000-photo.jpg/000-photo.jpg 2x",
            "views": 9997,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca0738aced40254f21ca"
        },
        {
            "title": "Как выбрать и повесить потолочную сушилку для белья",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "02.10.2022",
            "link": "kak-vybrat-i-povesit-potolochnuyu-sushilku-dlya-belya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-i-povesit'-potolochnuyu-sushilku-dlya-bel'ya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-i-povesit'-potolochnuyu-sushilku-dlya-bel'ya/000-photo.jpg/000-photo.jpg 2x",
            "views": 13897,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca0738aced40254f21cb"
        },
        {
            "title": "Как повесить тюль красиво и правильно",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.10.2022",
            "link": "kak-povesit-tyul-krasivo-i-pravilno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit'-tyul'-krasivo-i-pravil'no/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit'-tyul'-krasivo-i-pravil'no/000-photo.jpg/000-photo.jpg 2x",
            "views": 6961,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0738aced40254f21cc"
        },
        {
            "title": "Микрофибра - что это за ткань, состав, применение",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.09.2022",
            "link": "mikrofibra-chto-eto-za-tkan-sostav-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/mikrofibra-–-chto-eto-za-tkan',-eyo-sostav-i-primenenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/mikrofibra-–-chto-eto-za-tkan',-eyo-sostav-i-primenenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 11388,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca0738aced40254f21cd"
        },
        {
            "title": "Полиэстр - что за материал, плюсы и минусы",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.11.2022",
            "link": "poliestr-chto-za-material-plyusy-i-minusy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/poliestr---chto-za-material,-plyusy-i-minusy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/poliestr---chto-za-material,-plyusy-i-minusy/000-photo.jpg/000-photo.jpg 2x",
            "views": 4781,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0738aced40254f21ce"
        },
        {
            "title": "Как выбрать подушку для сна взрослым и детям",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "06.09.2022",
            "link": "kak-vybrat-podushku-dlya-sna-vzroslym-i-detyam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat'-podushku-dlya-sna-vzroslym-i-detyam/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat'-podushku-dlya-sna-vzroslym-i-detyam/000-hero.jpg/000-hero.jpg 2x",
            "views": 15017,
            "total_comment": 2,
            "is_video": false,
            "likes": 11,
            "id": "648aca0838aced40254f21cf"
        },
        {
            "title": "Как выбрать одеяло для любого сезона",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.09.2022",
            "link": "kak-vybrat-odeyalo-dlya-lyubogo-sezona",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vibrat-odeyalo-dla-lubogo-sezona/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vibrat-odeyalo-dla-lubogo-sezona/000-photo.jpg/000-photo.jpg 2x",
            "views": 11826,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca0838aced40254f21d0"
        },
        {
            "title": "Экостиль в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "06.09.2022",
            "link": "ekostil-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/ekostil-v-interyere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/ekostil-v-interyere/000-photo.jpg/000-photo.jpg 2x",
            "views": 10182,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca0838aced40254f21d1"
        },
        {
            "title": "Как выбрать матрас, чтобы комфортно спалось",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.09.2022",
            "link": "kak-vybrat-matras-chtoby-komfortno-spalos",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vibrat-matras-chtoby-komfortno-spalos/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vibrat-matras-chtoby-komfortno-spalos/000-photo.jpg/000-photo.jpg 2x",
            "views": 15860,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0838aced40254f21d2"
        },
        {
            "title": "Как выбрать смеситель для ванны",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "07.09.2022",
            "link": "kak-vybrat-smesitel-dlya-vanny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vibrat-smesitel-dla-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vibrat-smesitel-dla-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 11996,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0838aced40254f21d3"
        },
        {
            "title": "Какой блендер выбрать для дома: погружной или стационарный",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kakoy-blender-vybrat-dlya-doma-pogruzhnoy-ili-stacionarnyy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakoj-blender-vybrat'-dlya-doma--pogruzhnoj-ili-stacionarnyj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakoj-blender-vybrat'-dlya-doma--pogruzhnoj-ili-stacionarnyj/000-photo.jpg/000-photo.jpg 2x",
            "views": 13993,
            "total_comment": 4,
            "is_video": false,
            "likes": 11,
            "id": "648aca0938aced40254f21d4"
        },
        {
            "title": "Жаккард — что это за ткань: состав, применение и уход",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "08.09.2022",
            "link": "zhakkard-chto-eto-za-tkan-sostav-primenenie-i-uhod",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/jakkard-chto-eto-za-tkan/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/jakkard-chto-eto-za-tkan/000-photo.jpg/000-photo.jpg 2x",
            "views": 13343,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca0938aced40254f21d5"
        },
        {
            "title": "Что посадить на даче осенью",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "12.09.2022",
            "link": "chto-posadit-na-dache-osenyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-posadit-na-dache-osenyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-posadit-na-dache-osenyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 4751,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0938aced40254f21d6"
        },
        {
            "title": "Перкаль - что это за ткань, и чем постельное бельё из перкаля отличается от поплина",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "13.09.2022",
            "link": "perkal-chto-eto-za-tkan-i-chem-postelnoe-bele-iz-perkalya-otlichaetsya-ot-poplina",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/postelnoye-belyo-iz-perkalay/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/postelnoye-belyo-iz-perkalay/000-photo.jpg/000-photo.jpg 2x",
            "views": 8360,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca0938aced40254f21d7"
        },
        {
            "title": "Подготовка автомобиля к летнему сезону",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "09.08.2022",
            "link": "podgotovka-avtomobilya-k-letnemu-sezonu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-podgotovit'-avtomobil'-k--letu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-podgotovit'-avtomobil'-k--letu/000-photo.jpg/000-photo.jpg 2x",
            "views": 5357,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca0938aced40254f21d8"
        },
        {
            "title": "Подготовка автомобиля к зимнему сезону",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "09.08.2022",
            "link": "podgotovka-avtomobilya-k-zimnemu-sezonu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-podgotovit'-avtomobil'-k-zime/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-podgotovit'-avtomobil'-k-zime/000-photo.jpg/000-photo.jpg 2x",
            "views": 8903,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca0a38aced40254f21d9"
        },
        {
            "title": "Как выбрать хороший электрический чайник для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "13.09.2022",
            "link": "kak-vybrat-horoshiy-elektricheskiy-chaynik-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-horoshiy-elektricheskiy-chaynik-dlya-doma/000-hero.png/000-hero.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat-horoshiy-elektricheskiy-chaynik-dlya-doma/000-hero.png/000-hero.png 2x",
            "views": 16065,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca0a38aced40254f21da"
        },
        {
            "title": "Как выбрать тостер для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-toster-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-toster-dla-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-toster-dla-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 11141,
            "total_comment": 4,
            "is_video": false,
            "likes": 13,
            "id": "648aca0a38aced40254f21db"
        },
        {
            "title": "Как выбрать термос для чая и еды",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-termos-dlya-chaya-i-edy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-termos-dla-chaya-edy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vibrat-termos-dla-chaya-edy/000-photo.jpg/000-photo.jpg 2x",
            "views": 11667,
            "total_comment": 4,
            "is_video": false,
            "likes": 10,
            "id": "648aca0a38aced40254f21dc"
        },
        {
            "title": "Дюбели и дюбель-гвозди",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "01.02.2022",
            "link": "dyubeli-i-dyubel-gvozdi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/dubeli-i-dubel-gvozdi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/dubeli-i-dubel-gvozdi/000-photo.jpg/000-photo.jpg 2x",
            "views": 16292,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca0b38aced40254f21dd"
        },
        {
            "title": "Как выбрать микроволновку для дома – на что обратить внимание",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-mikrovolnovku-dlya-doma-na-chto-obratit-vnimanie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-mikrovolnovku-dlya-doma-–-na-chto-obratit'-vnimanie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-mikrovolnovku-dlya-doma-–-na-chto-obratit'-vnimanie/000-photo.jpg/000-photo.jpg 2x",
            "views": 7443,
            "total_comment": 4,
            "is_video": false,
            "likes": 7,
            "id": "648aca0b38aced40254f21de"
        },
        {
            "title": "Какую морозильную камеру выбрать для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kakuyu-morozilnuyu-kameru-vybrat-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakyi-vibrat-morozilnuyi0kamery-dla-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakyi-vibrat-morozilnuyi0kamery-dla-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 7272,
            "total_comment": 4,
            "is_video": false,
            "likes": 15,
            "id": "648aca0b38aced40254f21df"
        },
        {
            "title": "Как выбрать электрическую мясорубку для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-elektricheskuyu-myasorubku-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-myasorubku-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-myasorubku-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 4764,
            "total_comment": 4,
            "is_video": false,
            "likes": 14,
            "id": "648aca0b38aced40254f21e0"
        },
        {
            "title": "Что такое реноватор, как он работает и какой реноватор выбрать для дома?",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "14.10.2022",
            "link": "chto-takoe-renovator-kak-on-rabotaet-i-kakoy-renovator-vybrat-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-renovator,-kak-on-rabotaet-i-kakoj-renovator-vybrat'-dlya-doma-/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-renovator,-kak-on-rabotaet-i-kakoj-renovator-vybrat'-dlya-doma-/000-hero.jpg/000-hero.jpg 2x",
            "views": 5587,
            "total_comment": 2,
            "is_video": false,
            "likes": 11,
            "id": "648aca0b38aced40254f21e1"
        },
        {
            "title": "Что такое осушитель воздуха для квартиры, зачем он нужен и как работает",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "20.10.2022",
            "link": "chto-takoe-osushitel-vozduha-dlya-kvartiry-zachem-on-nuzhen-i-kak-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-osushitel'-vozduha-dlya-kvartiry,-zachem-on-nuzhen-i-kak-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-osushitel'-vozduha-dlya-kvartiry,-zachem-on-nuzhen-i-kak-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 7622,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca0c38aced40254f21e2"
        },
        {
            "title": "Как наточить ножи дома бруском и точилкой для ножей",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "20.10.2022",
            "link": "kak-natochit-nozhi-doma-bruskom-i-tochilkoy-dlya-nozhey",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-natochit'-nozhi-doma-bruskom-i-tochilkoj-dlya-nozhej/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-natochit'-nozhi-doma-bruskom-i-tochilkoj-dlya-nozhej/000-photo.jpg/000-photo.jpg 2x",
            "views": 10590,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca0c38aced40254f21e3"
        },
        {
            "title": "Можно ли красить ламинат, как и чем красить",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "22.10.2022",
            "link": "mozhno-li-krasit-laminat-kak-i-chem-krasit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/mozhno-li-krasit'-laminat,-kak-i-chem-krasit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/mozhno-li-krasit'-laminat,-kak-i-chem-krasit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 6214,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca0c38aced40254f21e4"
        },
        {
            "title": "Камни для бани: какие лучше, как выбирать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "24.10.2022",
            "link": "kamni-dlya-bani-kakie-luchshe-kak-vybirat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kamni-dlya-bani--kakie-luchshe,-kak-vybirat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kamni-dlya-bani--kakie-luchshe,-kak-vybirat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 11124,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0c38aced40254f21e5"
        },
        {
            "title": "Как крепить анкерный болт в бетонную и кирпичную стену",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "18.10.2022",
            "link": "kak-krepit-ankernyy-bolt-v-betonnuyu-i-kirpichnuyu-stenu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-krepit'-ankernyj-bolt-v-betonnuyu-i-kirpichnuyu-stenu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-krepit'-ankernyj-bolt-v-betonnuyu-i-kirpichnuyu-stenu/000-photo.jpg/000-photo.jpg 2x",
            "views": 8197,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca0c38aced40254f21e6"
        },
        {
            "title": "Что такое умная лампочка, как она работает, и как её подключить и настроить",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "27.10.2022",
            "link": "chto-takoe-umnaya-lampochka-kak-ona-rabotaet-i-kak-ee-podklyuchit-i-nastroit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-takoe-umnaya-lampochka,-kak-ona-rabotaet,-i-kak-eyo-podklyuchit'-i-nastroit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-takoe-umnaya-lampochka,-kak-ona-rabotaet,-i-kak-eyo-podklyuchit'-i-nastroit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 16448,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0d38aced40254f21e7"
        },
        {
            "title": "Сколько сохнет герметик, и как быстро он застывает",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2022",
            "link": "skolko-sohnet-germetik-i-kak-bystro-on-zastyvaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/skol'ko-sohnet-germetik,-i-kak-bystro-on-zastyvaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/skol'ko-sohnet-germetik,-i-kak-bystro-on-zastyvaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 12223,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0d38aced40254f21e8"
        },
        {
            "title": "Что такое биотуалет, как выбрать биотуалет для дачи и как он работает",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2022",
            "link": "chto-takoe-biotualet-kak-vybrat-biotualet-dlya-dachi-i-kak-on-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-biotualet,-kak-vybrat'-biotualet-dlya-dachi--i-kak-on-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-biotualet,-kak-vybrat'-biotualet-dlya-dachi--i-kak-on-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 16595,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca0d38aced40254f21e9"
        },
        {
            "title": "Что такое стиль шебби-шик в интерьере, и как его организовать в доме или квартире",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "22.10.2022",
            "link": "chto-takoe-stil-shebbi-shik-v-interere-i-kak-ego-organizovat-v-dome-ili-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-stil'-shebbi-shik-v-inter'ere,-i-kak-ego-organizovat'-v-dome-ili-kvartire/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-stil'-shebbi-shik-v-inter'ere,-i-kak-ego-organizovat'-v-dome-ili-kvartire/000-hero.jpg/000-hero.jpg 2x",
            "views": 15772,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca0d38aced40254f21ea"
        },
        {
            "title": "Как и какую электробритву выбрать мужчине",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "07.10.2022",
            "link": "kak-i-kakuyu-elektrobritvu-vybrat-muzhchine",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakuyu-elektrobritvu-vybrat'-muzhchine/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakuyu-elektrobritvu-vybrat'-muzhchine/000-photo.jpg/000-photo.jpg 2x",
            "views": 4616,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca0d38aced40254f21eb"
        },
        {
            "title": "Как выбрать фен для волос: профессиональный и бытовой",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "07.10.2022",
            "link": "kak-vybrat-fen-dlya-volos-professionalnyy-i-bytovoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-fen-dlya-volos--professional'nyj-i-bytovoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-fen-dlya-volos--professional'nyj-i-bytovoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 8505,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca0e38aced40254f21ec"
        },
        {
            "title": "Как правильно паять паяльником в домашних условиях",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "11.10.2022",
            "link": "kak-pravilno-payat-payalnikom-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pravil'no-payat'-payal'nikom-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pravil'no-payat'-payal'nikom-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 14836,
            "total_comment": 2,
            "is_video": false,
            "likes": 5,
            "id": "648aca0e38aced40254f21ed"
        },
        {
            "title": "Как почистить электрический чайник от накипи",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "05.10.2022",
            "link": "kak-pochistit-elektricheskiy-chaynik-ot-nakipi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-pochistit-elektricheskiy-chaynik-ot-nakipi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-pochistit-elektricheskiy-chaynik-ot-nakipi/000-photo.jpg/000-photo.jpg 2x",
            "views": 10491,
            "total_comment": 4,
            "is_video": false,
            "likes": 9,
            "id": "648aca0e38aced40254f21ee"
        },
        {
            "title": "Что такое бойлер косвенного нагрева, для чего он нужен и как работает",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "10.10.2022",
            "link": "chto-takoe-boyler-kosvennogo-nagreva-dlya-chego-on-nuzhen-i-kak-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-bojler-kosvennogo-nagreva,-dlya-chego-on-nuzhen-i-kak-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-bojler-kosvennogo-nagreva,-dlya-chego-on-nuzhen-i-kak-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 13966,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca0e38aced40254f21ef"
        },
        {
            "title": "Что такое водоэмульсионная краска, что ей можно красить и чем её отмыть",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "11.10.2022",
            "link": "chto-takoe-vodoemulsionnaya-kraska-chto-ey-mozhno-krasit-i-chem-ee-otmyt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-vodoemul'sionnaya-kraska,-chto-ej-mozhno-krasit'-i-chem-eyo-otmyt'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-vodoemul'sionnaya-kraska,-chto-ej-mozhno-krasit'-i-chem-eyo-otmyt'/000-photo.jpg/000-photo.jpg 2x",
            "views": 10311,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca0e38aced40254f21f0"
        },
        {
            "title": "Какая посуда подходит для индукционной плиты",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.10.2022",
            "link": "kakaya-posuda-podhodit-dlya-indukcionnoy-plity",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakaya-posuda-podhodit-dlya-indukcionnoj-plity/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakaya-posuda-podhodit-dlya-indukcionnoj-plity/000-photo.jpg/000-photo.jpg 2x",
            "views": 14477,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca0f38aced40254f21f1"
        },
        {
            "title": "Чем индукционная плита отличается от электрической",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.10.2022",
            "link": "chem-indukcionnaya-plita-otlichaetsya-ot-elektricheskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chem-indukcionnaya-plita-otlichaetsya-ot-elektricheskoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chem-indukcionnaya-plita-otlichaetsya-ot-elektricheskoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 16199,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca0f38aced40254f21f2"
        },
        {
            "title": "Как повесить микроволновку на стену",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.09.2022",
            "link": "kak-povesit-mikrovolnovku-na-stenu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-povesit'-mikrovolnovku-na-stenu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-povesit'-mikrovolnovku-na-stenu/000-photo.jpg/000-photo.jpg 2x",
            "views": 10951,
            "total_comment": 4,
            "is_video": false,
            "likes": 15,
            "id": "648aca0f38aced40254f21f3"
        },
        {
            "title": "Как выбрать бассейн для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "20.09.2022",
            "link": "kak-vybrat-basseyn-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-bassejn-na-dachu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-bassejn-na-dachu/000-photo.jpg/000-photo.jpg 2x",
            "views": 5506,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca0f38aced40254f21f4"
        },
        {
            "title": "Как выбрать пароварку, и чем она отличается от мультиварки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "20.09.2022",
            "link": "kak-vybrat-parovarku-i-chem-ona-otlichaetsya-ot-multivarki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-parovarku-i-chem-ona-otlichaetsya-ot-mul'tivarki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-parovarku-i-chem-ona-otlichaetsya-ot-mul'tivarki/000-photo.jpg/000-photo.jpg 2x",
            "views": 16507,
            "total_comment": 4,
            "is_video": false,
            "likes": 15,
            "id": "648aca1038aced40254f21f5"
        },
        {
            "title": "Как и чем резать керамогранит",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "25.10.2022",
            "link": "kak-i-chem-rezat-keramogranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-rezat'-keramogranit/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-rezat'-keramogranit/000-hero.jpg/000-hero.jpg 2x",
            "views": 8931,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1038aced40254f21f6"
        },
        {
            "title": "Чем и как сверлить керамогранит",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "25.10.2022",
            "link": "chem-i-kak-sverlit-keramogranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chem-i-kak-sverlit'-keramogranit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chem-i-kak-sverlit'-keramogranit/000-photo.jpg/000-photo.jpg 2x",
            "views": 9370,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1038aced40254f21f7"
        },
        {
            "title": "Что такое стеклообои и как их выбирать?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "25.10.2022",
            "link": "chto-takoe-steklooboi-i-kak-ih-vybirat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-steklooboi-i-kak-ih-vybirat'-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-steklooboi-i-kak-ih-vybirat'-/000-photo.jpg/000-photo.jpg 2x",
            "views": 6576,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca1038aced40254f21f8"
        },
        {
            "title": "Велюр – что это за ткань, состав материала и сравнение с рогожкой",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "25.10.2022",
            "link": "velyur-chto-eto-za-tkan-sostav-materiala-i-sravnenie-s-rogozhkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/velyur---chto-eto-za-tkan',-sostav-materiala-i-sravnenie-s-rogozhkoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/velyur---chto-eto-za-tkan',-sostav-materiala-i-sravnenie-s-rogozhkoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 10527,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca1038aced40254f21f9"
        },
        {
            "title": "Чем отличается инверторный кондиционер от обычного",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "01.11.2022",
            "link": "chem-otlichaetsya-invertornyy-kondicioner-ot-obychnogo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichaetsya-invertornyj-kondicioner-ot-obychnogo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichaetsya-invertornyj-kondicioner-ot-obychnogo/000-photo.jpg/000-photo.jpg 2x",
            "views": 11028,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca1138aced40254f21fa"
        },
        {
            "title": "Что такое пассатижи и чем они отличаются от плоскогубцев",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.11.2022",
            "link": "chto-takoe-passatizhi-i-chem-oni-otlichayutsya-ot-ploskogubcev",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-passatizhi-i-chem-oni-otlichayutsya-ot-ploskogubcev/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-passatizhi-i-chem-oni-otlichayutsya-ot-ploskogubcev/000-photo.jpg/000-photo.jpg 2x",
            "views": 15941,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca1138aced40254f21fb"
        },
        {
            "title": "Для чего нужен строительный фен и как выбрать технический фен для домашнего использования",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.11.2022",
            "link": "dlya-chego-nuzhen-stroitelnyy-fen-i-kak-vybrat-tehnicheskiy-fen-dlya-domashnego-ispolzovaniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/dlya-chego-nuzhen-stroitel'nyj-fen-i-kak-vybrat'-tekhnicheskij-fen-dlya-domashnego-ispol'zovaniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/dlya-chego-nuzhen-stroitel'nyj-fen-i-kak-vybrat'-tekhnicheskij-fen-dlya-domashnego-ispol'zovaniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 13733,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca1138aced40254f21fc"
        },
        {
            "title": "Как выбрать строительный степлер и начать пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.11.2022",
            "link": "kak-vybrat-stroitelnyy-stepler-i-nachat-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat'-stroitel'nyj-stepler-i-nachat'-pol'zovat'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat'-stroitel'nyj-stepler-i-nachat'-pol'zovat'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6824,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca1138aced40254f21fd"
        },
        {
            "title": "Как выбрать паяльник для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.11.2022",
            "link": "kak-vybrat-payalnik-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat'-payal'nik-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat'-payal'nik-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 7009,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca1138aced40254f21fe"
        },
        {
            "title": "Что такое эпоксидная смола, как с ней работать и что можно из неё сделать",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "02.11.2022",
            "link": "chto-takoe-epoksidnaya-smola-kak-s-ney-rabotat-i-chto-mozhno-iz-nee-sdelat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-epoksidnaya-smola,-kak-s-nej-rabotat'-i-chto-mozhno-iz-neyo-sdelat'/chto-takoe-epoksidnaya-smola-i-kak-s-ney-rabotat.jpg/chto-takoe-epoksidnaya-smola-i-kak-s-ney-rabotat.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-epoksidnaya-smola,-kak-s-nej-rabotat'-i-chto-mozhno-iz-neyo-sdelat'/chto-takoe-epoksidnaya-smola-i-kak-s-ney-rabotat.jpg/chto-takoe-epoksidnaya-smola-i-kak-s-ney-rabotat.jpg 2x",
            "views": 12941,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648aca1238aced40254f21ff"
        },
        {
            "title": "Как выбрать кофемашину для дома с капучинатором и без",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-kofemashinu-dlya-doma-s-kapuchinatorom-i-bez",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kofemashinu-dlya-doma-s-kapuchinatorom-i-bez/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kofemashinu-dlya-doma-s-kapuchinatorom-i-bez/000-hero.jpg/000-hero.jpg 2x",
            "views": 13693,
            "total_comment": 4,
            "is_video": false,
            "likes": 5,
            "id": "648aca1238aced40254f2200"
        },
        {
            "title": "Как выбрать кофеварку для дома, и чем она отличается от кофемашины",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "kak-vybrat-kofevarku-dlya-doma-i-chem-ona-otlichaetsya-ot-kofemashiny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kofevarku-dlya-doma-i-chem-ona-otlichaetsya-ot-kofemashiny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kofevarku-dlya-doma-i-chem-ona-otlichaetsya-ot-kofemashiny/000-photo.jpg/000-photo.jpg 2x",
            "views": 7829,
            "total_comment": 4,
            "is_video": false,
            "likes": 12,
            "id": "648aca1238aced40254f2201"
        },
        {
            "title": "Что такое модульная кухня, и чем она отличается от встроенных кухонь и кухонных гарнитуров",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.09.2022",
            "link": "chto-takoe-modulnaya-kuhnya-i-chem-ona-otlichaetsya-ot-vstroennyh-kuhon-i-kuhonnyh-garniturov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-modul'naya-kuhnya-i-chem-ona-otlichaetsya-ot-vstroennyh-kuhon'-i-kuhonnyh-garniturov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-modul'naya-kuhnya-i-chem-ona-otlichaetsya-ot-vstroennyh-kuhon'-i-kuhonnyh-garniturov/000-photo.jpg/000-photo.jpg 2x",
            "views": 12449,
            "total_comment": 4,
            "is_video": false,
            "likes": 9,
            "id": "648aca1238aced40254f2202"
        },
        {
            "title": "Сочетания цвета в интерьере кухни, гостиной, спальни",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.08.2022",
            "link": "sochetaniya-cveta-v-interere-kuhni-gostinoy-spalni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/sochetaniya-cveta-v-inter'ere-kuhni,-gostinoj,-spal'ni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/sochetaniya-cveta-v-inter'ere-kuhni,-gostinoj,-spal'ni/000-photo.jpg/000-photo.jpg 2x",
            "views": 11633,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1238aced40254f2203"
        },
        {
            "title": "Как убрать траву между тротуарной плиткой",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.09.2022",
            "link": "kak-ubrat-travu-mezhdu-trotuarnoy-plitkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ubrat'-travu-mezhdu-trotuarnoj-plitkoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ubrat'-travu-mezhdu-trotuarnoj-plitkoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 15205,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1338aced40254f2204"
        },
        {
            "title": "Как выбрать миксер для дома: планетарный, ручной, стационарный",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "17.08.2022",
            "link": "kak-vybrat-mikser-dlya-doma-planetarnyy-ruchnoy-stacionarnyy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-mikser-dlya-doma--planetarnyj,-ruchnoj,-stacionarnyj/000-hero.png/000-hero.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-mikser-dlya-doma--planetarnyj,-ruchnoj,-stacionarnyj/000-hero.png/000-hero.png 2x",
            "views": 16339,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca1338aced40254f2205"
        },
        {
            "title": "Что такое полиэфирное волокно, плюсы и минусы наполнителя из полиэфира",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "13.09.2022",
            "link": "chto-takoe-poliefirnoe-volokno-plyusy-i-minusy-napolnitelya-iz-poliefira",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-poliefirnoe-volokno,-plyusy-i-minusy-napolnitelya-iz-poliefira/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-poliefirnoe-volokno,-plyusy-i-minusy-napolnitelya-iz-poliefira/000-photo.jpg/000-photo.jpg 2x",
            "views": 14804,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca1338aced40254f2206"
        },
        {
            "title": "Как выбрать кухонный гарнитур по материалу, цвету и удобству",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.09.2022",
            "link": "kak-vybrat-kuhonnyy-garnitur-po-materialu-cvetu-i-udobstvu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kuhonnyj-garnitur-po-materialu,-cvetu-i-udobstvu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-kuhonnyj-garnitur-po-materialu,-cvetu-i-udobstvu/000-photo.jpg/000-photo.jpg 2x",
            "views": 11220,
            "total_comment": 4,
            "is_video": false,
            "likes": 9,
            "id": "648aca1338aced40254f2207"
        },
        {
            "title": "Что такое ирригатор для полости рта, как выбрать, и как он работает",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "22.09.2022",
            "link": "chto-takoe-irrigator-dlya-polosti-rta-kak-vybrat-i-kak-on-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-irrigator-dlya-polosti-rta,-kak-vybrat'-i-kak-on-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-irrigator-dlya-polosti-rta,-kak-vybrat'-i-kak-on-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 16527,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1338aced40254f2208"
        },
        {
            "title": "Как выбрать батут на дачу для ребенка и взрослых",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "21.09.2022",
            "link": "kak-vybrat-batut-na-dachu-dlya-rebenka-i-vzroslyh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-batut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-batut/000-photo.jpg/000-photo.jpg 2x",
            "views": 6071,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1438aced40254f2209"
        },
        {
            "title": "Как выбрать духовой шкаф: электрический или газовый, встраиваемый или нет",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.09.2022",
            "link": "kak-vybrat-duhovoy-shkaf-elektricheskiy-ili-gazovyy-vstraivaemyy-ili-net",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-duhovoj-shkaf--elektricheskij-ili-gazovyj,-vstraivaemyj-ili-net/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-duhovoj-shkaf--elektricheskij-ili-gazovyj,-vstraivaemyj-ili-net/000-photo.jpg/000-photo.jpg 2x",
            "views": 15138,
            "total_comment": 4,
            "is_video": false,
            "likes": 14,
            "id": "648aca1438aced40254f220a"
        },
        {
            "title": "Как вешать кухонные шкафы: на какой высоте, какой крепёж использовать",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.09.2022",
            "link": "kak-veshat-kuhonnye-shkafy-na-kakoy-vysote-kakoy-krepezh-ispolzovat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-veshat'-kuhonnye-shkafy--na-kakoj-vysote,-kakoj-krepyozh-ispol'zovat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-veshat'-kuhonnye-shkafy--na-kakoj-vysote,-kakoj-krepyozh-ispol'zovat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 15130,
            "total_comment": 4,
            "is_video": false,
            "likes": 11,
            "id": "648aca1438aced40254f220b"
        },
        {
            "title": "Что такое писсуар, как выбрать и установить писсуар",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "21.09.2022",
            "link": "chto-takoe-pissuar-kak-vybrat-i-ustanovit-pissuar",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-pissuar,-kak-vybrat'-i-ustanovit'-pissuar/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-pissuar,-kak-vybrat'-i-ustanovit'-pissuar/000-photo.jpg/000-photo.jpg 2x",
            "views": 6615,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca1438aced40254f220c"
        },
        {
            "title": "Как часто нужно менять постельное бельё взрослым и детям",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "21.09.2022",
            "link": "kak-chasto-nuzhno-menyat-postelnoe-bele-vzroslym-i-detyam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-chasto-nuzhno-menyat'-postel'noe-bel'e-vzroslym-i-detyam/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-chasto-nuzhno-menyat'-postel'noe-bel'e-vzroslym-i-detyam/000-photo.jpg/000-photo.jpg 2x",
            "views": 16664,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1538aced40254f220d"
        },
        {
            "title": "Как стирать и отбеливать постельное бельё в стиральной машине",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "22.09.2022",
            "link": "kak-stirat-i-otbelivat-postelnoe-bele-v-stiralnoy-mashine",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-stirat'-i-otbelivat'-postel'noe-bel'e-v-stiral'noj-mashine/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-stirat'-i-otbelivat'-postel'noe-bel'e-v-stiral'noj-mashine/000-photo.jpg/000-photo.jpg 2x",
            "views": 11642,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca1538aced40254f220e"
        },
        {
            "title": "Как клеить солнцезащитную плёнку на окно правильно?",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "21.09.2022",
            "link": "kak-kleit-solncezashchitnuyu-plenku-na-okno-pravilno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit'-solncezashchitnuyu-plyonku-na-okno-pravil'no-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit'-solncezashchitnuyu-plyonku-na-okno-pravil'no-/000-photo.jpg/000-photo.jpg 2x",
            "views": 7677,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca1538aced40254f220f"
        },
        {
            "title": "Что такое алмазная мозаика, и как её собирать?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "23.09.2022",
            "link": "chto-takoe-almaznaya-mozaika-i-kak-ee-sobirat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-almaznaya-mozaika,-i-kak-eyo-sobirat'-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-almaznaya-mozaika,-i-kak-eyo-sobirat'-/000-photo.jpg/000-photo.jpg 2x",
            "views": 13994,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca1538aced40254f2210"
        },
        {
            "title": "Как установить варочную панель в столешницу своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "23.09.2022",
            "link": "kak-ustanovit-varochnuyu-panel-v-stoleshnicu-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit'-varochnuyu-panel'-v-stoleshnicu-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-ustanovit'-varochnuyu-panel'-v-stoleshnicu-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 10416,
            "total_comment": 4,
            "is_video": false,
            "likes": 11,
            "id": "648aca1538aced40254f2211"
        },
        {
            "title": "Как повесить гамак на даче и в квартире, на деревья или столбы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "23.09.2022",
            "link": "kak-povesit-gamak-na-dache-i-v-kvartire-na-derevya-ili-stolby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-povesit'-gamak-na-dache-i-v-kvartire,-na-derev'ya-ili-stolby/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-povesit'-gamak-na-dache-i-v-kvartire,-na-derev'ya-ili-stolby/000-photo.jpg/000-photo.jpg 2x",
            "views": 4587,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca1638aced40254f2212"
        },
        {
            "title": "Как установить унитаз в квартире, подключить его и отрегулировать",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "23.09.2022",
            "link": "kak-ustanovit-unitaz-v-kvartire-podklyuchit-ego-i-otregulirovat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-unitaz-v-kvartire,-podklyuchit'-ego-i-otregulirovat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-unitaz-v-kvartire,-podklyuchit'-ego-i-otregulirovat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 13233,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca1638aced40254f2213"
        },
        {
            "title": "Как выбрать практичный и удобный кухонный стол",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "25.09.2022",
            "link": "kak-vybrat-praktichnyy-i-udobnyy-kuhonnyy-stol",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-praktichnyj-i-udobnyj-kuhonnyj-stol/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-praktichnyj-i-udobnyj-kuhonnyj-stol/000-hero.jpg/000-hero.jpg 2x",
            "views": 13358,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca1638aced40254f2214"
        },
        {
            "title": "Как подшить тюль ровно и красиво в домашних условиях",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "23.09.2022",
            "link": "kak-podshit-tyul-rovno-i-krasivo-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-podshit'-tyul'-rovno-i-krasivo-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-podshit'-tyul'-rovno-i-krasivo-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 10747,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1638aced40254f2215"
        },
        {
            "title": "Как и какую электрическую зубную щётку выбрать взрослому и ребёнку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "25.09.2022",
            "link": "kak-i-kakuyu-elektricheskuyu-zubnuyu-shchetku-vybrat-vzroslomu-i-rebenku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakuyu-elektricheskuyu-zubnuyu-shchyotku-vybrat'-vzroslomu-i-rebyonku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-kakuyu-elektricheskuyu-zubnuyu-shchyotku-vybrat'-vzroslomu-i-rebyonku/000-photo.jpg/000-photo.jpg 2x",
            "views": 4372,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca1638aced40254f2216"
        },
        {
            "title": "Как повесить собранный пазл на стену с рамкой и без неё",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "25.09.2022",
            "link": "kak-povesit-sobrannyy-pazl-na-stenu-s-ramkoy-i-bez-nee",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit'-na-stenu-sobrannyj-pazl-s-ramkoj-i-bez/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit'-na-stenu-sobrannyj-pazl-s-ramkoj-i-bez/000-photo.jpg/000-photo.jpg 2x",
            "views": 13367,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648aca1738aced40254f2217"
        },
        {
            "title": "Сатин и страйп-сатин — что это за ткань, состав материала и его разновидности",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.09.2022",
            "link": "satin-i-strayp-satin-chto-eto-za-tkan-sostav-materiala-i-ego-raznovidnosti",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/satin-i-strajp-satin----chto-eto-za-tkan',-sostav-materiala-i-ego-raznovidnosti/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/satin-i-strajp-satin----chto-eto-za-tkan',-sostav-materiala-i-ego-raznovidnosti/000-photo.jpg/000-photo.jpg 2x",
            "views": 14773,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1738aced40254f2218"
        },
        {
            "title": "ОСБ-плита – что это такое, чем она лучше фанеры и где она применяется",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "10.11.2022",
            "link": "osb-plita-chto-eto-takoe-chem-ona-luchshe-fanery-i-gde-ona-primenyaetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/osb-plita-chto-ehto-takoe-chem-ona-luchshe-fanery-i-gde-ona-primenyaetsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/osb-plita-chto-ehto-takoe-chem-ona-luchshe-fanery-i-gde-ona-primenyaetsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 10275,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1738aced40254f2219"
        },
        {
            "title": "МДФ: что это за материал, расшифровка",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "14.11.2022",
            "link": "mdf-chto-eto-za-material-rasshifrovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/mdf-chto-eto-za-material-rasshifrovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/mdf-chto-eto-za-material-rasshifrovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 5363,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca1738aced40254f221a"
        },
        {
            "title": "Что такое торфяные таблетки и как ими пользоваться",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "14.11.2022",
            "link": "chto-takoe-torfyanye-tabletki-i-kak-imi-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-torphyanie-tabletki-i-kak-imi-pol'zovat'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-torphyanie-tabletki-i-kak-imi-pol'zovat'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 8663,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1838aced40254f221b"
        },
        {
            "title": "Как отремонтировать повреждённый пластиковый подоконник",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "14.11.2022",
            "link": "kak-otremontirovat-povrezhdennyy-plastikovyy-podokonnik",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otremontirovat'-povrezhdennii-plastikovii-podokonnik/kak-otremontiravat'-povrezhdenni-plastikovii-podokonnik.jpg/kak-otremontiravat'-povrezhdenni-plastikovii-podokonnik.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otremontirovat'-povrezhdennii-plastikovii-podokonnik/kak-otremontiravat'-povrezhdenni-plastikovii-podokonnik.jpg/kak-otremontiravat'-povrezhdenni-plastikovii-podokonnik.jpg 2x",
            "views": 7919,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1838aced40254f221c"
        },
        {
            "title": "Как установить смеситель на ванну и на раковину",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "08.11.2022",
            "link": "kak-ustanovit-smesitel-na-vannu-i-na-rakovinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-smesitel'-na-vannu-i-na-rakovinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit'-smesitel'-na-vannu-i-na-rakovinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 14942,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca1838aced40254f221d"
        },
        {
            "title": "Рейтинг мясорубок по соотношению цена / качество",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "08.11.2022",
            "link": "reyting-myasorubok-po-sootnosheniyu-cena-kachestvo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-myasorubok-po-sootnosheniyu-cena-kachestvo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-myasorubok-po-sootnosheniyu-cena-kachestvo/000-photo.jpg/000-photo.jpg 2x",
            "views": 6407,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca1838aced40254f221e"
        },
        {
            "title": "Как выбрать плиткорез и как им пользоваться правильно",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "09.11.2022",
            "link": "kak-vybrat-plitkorez-i-kak-im-polzovatsya-pravilno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-plitkorez-i-kak-im-pol'zovat'sya-pravil'no/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-plitkorez-i-kak-im-pol'zovat'sya-pravil'no/000-photo.jpg/000-photo.jpg 2x",
            "views": 11693,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca1838aced40254f221f"
        },
        {
            "title": "Класс прочности болтов",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "07.11.2022",
            "link": "klass-prochnosti-boltov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/klass-prochnosti-boltov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/klass-prochnosti-boltov/000-photo.jpg/000-photo.jpg 2x",
            "views": 8872,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca1938aced40254f2220"
        },
        {
            "title": "Как выбрать насосную станцию для дома и как она работает?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "07.11.2022",
            "link": "kak-vybrat-nasosnuyu-stanciyu-dlya-doma-i-kak-ona-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-nasosnuyu-stanciyu-dlya-doma,-i-kak-ona-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-nasosnuyu-stanciyu-dlya-doma,-i-kak-ona-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 4526,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1938aced40254f2221"
        },
        {
            "title": "Рейтинг кухонных ножей хорошего качества",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "08.11.2022",
            "link": "reyting-kuhonnyh-nozhey-horoshego-kachestva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kuhonnyh-nozhej-horoshego-kachestva/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kuhonnyh-nozhej-horoshego-kachestva/000-photo.jpg/000-photo.jpg 2x",
            "views": 12177,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca1938aced40254f2222"
        },
        {
            "title": "Рейтинг морозильных камер для дома по качеству и надёжности",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "11.11.2022",
            "link": "reyting-morozilnyh-kamer-dlya-doma-po-kachestvu-i-nadezhnosti",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-morosil'nih-kamer-dlya-doma-po-kachestvu-i-nadezhnosti/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-morosil'nih-kamer-dlya-doma-po-kachestvu-i-nadezhnosti/000-photo.jpg/000-photo.jpg 2x",
            "views": 9073,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1938aced40254f2223"
        },
        {
            "title": "Как выбрать и подключить датчик движения для освещения",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "17.11.2022",
            "link": "kak-vybrat-i-podklyuchit-datchik-dvizheniya-dlya-osveshcheniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-i-podkluchit-datchik-dvizheniya-dlya-osvecheniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-i-podkluchit-datchik-dvizheniya-dlya-osvecheniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6561,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1938aced40254f2224"
        },
        {
            "title": "Как выбрать межкомнатные двери в квартиру",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "21.11.2022",
            "link": "kak-vybrat-mezhkomnatnye-dveri-v-kvartiru",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru.jpg/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru.jpg/kak-vibrat'-mezhkomnatnie-dveri-v-kvartiru.jpg 2x",
            "views": 9791,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1a38aced40254f2225"
        },
        {
            "title": "Что такое ДВП (оргалит), отличие от других материалов",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "10.11.2022",
            "link": "chto-takoe-dvp-orgalit-otlichie-ot-drugih-materialov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-dvp-orgalit-otlichie-ot-drugih-materialov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-dvp-orgalit-otlichie-ot-drugih-materialov/000-photo.jpg/000-photo.jpg 2x",
            "views": 4801,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca1a38aced40254f2226"
        },
        {
            "title": "Как сшить шторы на люверсах и установить люверсы своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.11.2022",
            "link": "kak-sshit-shtory-na-lyuversah-i-ustanovit-lyuversy-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ssht'-shtori-na-luversah-i-ustanovit'-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ssht'-shtori-na-luversah-i-ustanovit'-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 7787,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1a38aced40254f2227"
        },
        {
            "title": "Рейтинг кухонных планетарных миксеров",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "15.11.2022",
            "link": "reyting-kuhonnyh-planetarnyh-mikserov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kuhonnyh-planetarnyh-mikserov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kuhonnyh-planetarnyh-mikserov/000-photo.jpg/000-photo.jpg 2x",
            "views": 14711,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1a38aced40254f2228"
        },
        {
            "title": "Как отбелить и постирать тюль, чтобы вернуть белоснежный вид",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "08.11.2022",
            "link": "kak-otbelit-i-postirat-tyul-chtoby-vernut-belosnezhnyy-vid",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-otbelit-i-postirat-tyul-chtoby-vernut-belosnezhnyy-vid/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-otbelit-i-postirat-tyul-chtoby-vernut-belosnezhnyy-vid/000-photo.jpg/000-photo.jpg 2x",
            "views": 11297,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca1a38aced40254f2229"
        },
        {
            "title": "Как и чем подклеить стыки обоев на стенах",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.11.2022",
            "link": "kak-i-chem-podkleit-styki-oboev-na-stenah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-i-chem-podkleit-styki-oboev-na-stenah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-i-chem-podkleit-styki-oboev-na-stenah/000-photo.jpg/000-photo.jpg 2x",
            "views": 4622,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca1b38aced40254f222a"
        },
        {
            "title": "ХДФ: что это за материал?",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "15.11.2022",
            "link": "hdf-chto-eto-za-material",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/hdf-chto-za-material/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/hdf-chto-za-material/000-photo.jpg/000-photo.jpg 2x",
            "views": 6808,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1b38aced40254f222b"
        },
        {
            "title": "Как открутить сорванный болт",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "15.11.2022",
            "link": "kak-otkrutit-sorvannyy-bolt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-otkrutit'-sorvannyj-bolt/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-otkrutit'-sorvannyj-bolt/000-photo.jpg/000-photo.jpg 2x",
            "views": 5573,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca1b38aced40254f222c"
        },
        {
            "title": "Что такое запорная арматура и для чего она предназначена",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.11.2022",
            "link": "chto-takoe-zapornaya-armatura-i-dlya-chego-ona-prednaznachena",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-zapornaya-armatura-i-dlya-chego-ona-prednaznachena/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-zapornaya-armatura-i-dlya-chego-ona-prednaznachena/000-photo.jpg/000-photo.jpg 2x",
            "views": 13712,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1b38aced40254f222d"
        },
        {
            "title": "Как установить входную дверь в квартиру",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "11.11.2022",
            "link": "kak-ustanovit-vhodnuyu-dver-v-kvartiru",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-vhodnuyu-dver-v-kvartiru/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-vhodnuyu-dver-v-kvartiru/000-hero.jpg/000-hero.jpg 2x",
            "views": 12205,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca1b38aced40254f222e"
        },
        {
            "title": "Рейтинг хлебопечек для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "15.11.2022",
            "link": "reyting-hlebopechek-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-hlebopechek-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-hlebopechek-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 14486,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1c38aced40254f222f"
        },
        {
            "title": "Как сшить римскую штору своими руками в домашних условиях",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.11.2022",
            "link": "kak-sshit-rimskuyu-shtoru-svoimi-rukami-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sshit-rimskuyu-shtoru-svoimi-rukami-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sshit-rimskuyu-shtoru-svoimi-rukami-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 5765,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648aca1c38aced40254f2230"
        },
        {
            "title": "Ранфорс — что это за ткань, состав материала и его применение",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.11.2022",
            "link": "ranfors-chto-eto-za-tkan-sostav-materiala-i-ego-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/ranfors-chto-ehto-za-tkan-sostav-materiala-i-ego-primenenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/ranfors-chto-ehto-za-tkan-sostav-materiala-i-ego-primenenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 5234,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648aca1c38aced40254f2231"
        },
        {
            "title": "Что за ткань лиоцелл, плюсы и минусы материала",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.11.2022",
            "link": "chto-za-tkan-liocell-plyusy-i-minusy-materiala",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-za-tkan'-liocell-plusi-i-minusi-materiala/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-za-tkan'-liocell-plusi-i-minusi-materiala/000-photo.jpg/000-photo.jpg 2x",
            "views": 14493,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca1c38aced40254f2232"
        },
        {
            "title": "Как и чем обработать вагонку в бане",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "18.11.2022",
            "link": "kak-i-chem-obrabotat-vagonku-v-bane",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-obrabotat'-vagonku-v-bane/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-obrabotat'-vagonku-v-bane/000-photo.jpg/000-photo.jpg 2x",
            "views": 11524,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1c38aced40254f2233"
        },
        {
            "title": "Что такое флисовая ткань и где она применяется",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.11.2022",
            "link": "chto-takoe-flisovaya-tkan-i-gde-ona-primenyaetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-flisovaya-tkan'-i-gde-ona-primenyaet'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-flisovaya-tkan'-i-gde-ona-primenyaet'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 12195,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca1d38aced40254f2234"
        },
        {
            "title": "Рейтинг микроволновых печей по параметрам и надёжности",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.11.2022",
            "link": "reyting-mikrovolnovyh-pechey-po-parametram-i-nadezhnosti",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-mikrovolnovih-pechei-po-parametram-i-nadezhnosti/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-mikrovolnovih-pechei-po-parametram-i-nadezhnosti/000-photo.jpg/000-photo.jpg 2x",
            "views": 14439,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1d38aced40254f2235"
        },
        {
            "title": "Рейтинг встраиваемых варочных панелей",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "21.11.2022",
            "link": "reyting-vstraivaemyh-varochnyh-paneley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-vstraevaemih-varochnih-paneley/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-vstraevaemih-varochnih-paneley/000-photo.jpg/000-photo.jpg 2x",
            "views": 6886,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1d38aced40254f2236"
        },
        // {
        //     "title": "Как укладывать настенную плитку",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Плитка",
        //     "dept_slug": "plitka",
        //     "date_publish": "22.11.2021",
        //     "link": "kak-ukladyvat-nastennuyu-plitku",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukladyvat-nastennuyu-plitku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukladyvat-nastennuyu-plitku/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 15515,
        //     "total_comment": 0,
        //     "is_video": true,
        //     "likes": 12,
        //     "id": "648aca1d38aced40254f2237"
        // },
        {
            "title": "Обзор двухсторонних радиаторов Equation",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "21.11.2022",
            "link": "obzor-dvuhstoronnih-radiatorov-equation",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obzor-dvuhstoronnih-radiatorov-equation/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obzor-dvuhstoronnih-radiatorov-equation/000-hero.jpg/000-hero.jpg 2x",
            "views": 13059,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca1d38aced40254f2238"
        },
        {
            "title": "Как мыть стиральную машину, почистить фильтр и избавиться от запаха",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "21.11.2022",
            "link": "kak-myt-stiralnuyu-mashinu-pochistit-filtr-i-izbavitsya-ot-zapaha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-mit'-stiral'nuy-mashinu-pochistit'-filter-i-izbavit'sya-ot-zapaha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-mit'-stiral'nuy-mashinu-pochistit'-filter-i-izbavit'sya-ot-zapaha/000-photo.jpg/000-photo.jpg 2x",
            "views": 6613,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca1e38aced40254f2239"
        },
        {
            "title": "Сумка-холодильник: как выбрать, как пользоваться, лучшие термосумки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "17.10.2022",
            "link": "sumka-holodilnik-kak-vybrat-kak-polzovatsya-luchshie-termosumki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/sumka-holodil'nik--kak-vybrat',-kak-pol'zovat'sya,-luchshie-termosumki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/sumka-holodil'nik--kak-vybrat',-kak-pol'zovat'sya,-luchshie-termosumki/000-photo.jpg/000-photo.jpg 2x",
            "views": 8407,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca1e38aced40254f223a"
        },
        {
            "title": "Как правильно сделать слив воды в бане",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "17.10.2022",
            "link": "kak-pravilno-sdelat-sliv-vody-v-bane",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-pravil'no-sdelat'-sliv-vody-v-bane/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-pravil'no-sdelat'-sliv-vody-v-bane/000-photo.jpg/000-photo.jpg 2x",
            "views": 5597,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1e38aced40254f223b"
        },
        {
            "title": "Как выбрать прочный и лёгкий чемодан для долгих поездок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "18.10.2022",
            "link": "kak-vybrat-prochnyy-i-legkiy-chemodan-dlya-dolgih-poezdok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat-prochnii-i-legkii-chemodan-dly-dolgih-poezdok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat-prochnii-i-legkii-chemodan-dly-dolgih-poezdok/000-photo.jpg/000-photo.jpg 2x",
            "views": 11175,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca1e38aced40254f223c"
        },
        {
            "title": "Как выбрать плитку для ванной комнаты и туалета",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "19.10.2022",
            "link": "kak-vybrat-plitku-dlya-vannoy-komnaty-i-tualeta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vibrat-plitke-dlya-vannoi-i-tualeta/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vibrat-plitke-dlya-vannoi-i-tualeta/000-photo.jpg/000-photo.jpg 2x",
            "views": 9987,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1e38aced40254f223d"
        },
        {
            "title": "Как промыть радиатор отопления внутри и снаружи",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.10.2022",
            "link": "kak-promyt-radiator-otopleniya-vnutri-i-snaruzhi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-promyt'-radiator-otopleniya-vnutri-i-snaruzhi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-promyt'-radiator-otopleniya-vnutri-i-snaruzhi/000-photo.jpg/000-photo.jpg 2x",
            "views": 15032,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca1f38aced40254f223e"
        },
        {
            "title": "Как исправить повреждённый линолеум",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "17.10.2022",
            "link": "kak-ispravit-povrezhdennyy-linoleum",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ispravit'-povrezhdyonnyj-linoleum/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ispravit'-povrezhdyonnyj-linoleum/000-photo.jpg/000-photo.jpg 2x",
            "views": 5733,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca1f38aced40254f223f"
        },
        {
            "title": "Как стирать одеяла из разных тканей",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.10.2022",
            "link": "kak-stirat-odeyala-iz-raznyh-tkaney",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-stirat'-odeyala-iz-raznyh-tkanej/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-stirat'-odeyala-iz-raznyh-tkanej/000-photo.jpg/000-photo.jpg 2x",
            "views": 6918,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca1f38aced40254f2240"
        },
        {
            "title": "Праздник к нам приходит: идеи новогоднего декора",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "prazdnik-k-nam-prihodit-idei-novogodnego-dekora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/prazdnik-k-nam-prihodit-idei-novogodnego-dekora/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/prazdnik-k-nam-prihodit-idei-novogodnego-dekora/000-hero.jpg/000-hero.jpg 2x",
            "views": 6230,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca1f38aced40254f2241"
        },
        {
            "title": "Как украсить окно к новому году",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-ukrasit-okno-k-novomu-godu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukrasit-okno-k-novomu-godu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukrasit-okno-k-novomu-godu/000-photo.jpg/000-photo.jpg 2x",
            "views": 9643,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca1f38aced40254f2242"
        },
        {
            "title": "Как рассчитать расход ткани на оконные шторы",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-rasschitat-rashod-tkani-na-okonnye-shtory",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-rasschitat-rashod-tkani-na-okonnye-shtory/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-rasschitat-rashod-tkani-na-okonnye-shtory/000-photo.jpg/000-photo.jpg 2x",
            "views": 13665,
            "total_comment": 1,
            "is_video": false,
            "likes": 9,
            "id": "648aca2038aced40254f2243"
        },
        {
            "title": "Как клеить потолочную плитку",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-kleit-potolochnuyu-plitku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-potolochnuyu-plitku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-potolochnuyu-plitku/000-photo.jpg/000-photo.jpg 2x",
            "views": 16630,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca2038aced40254f2244"
        },
        {
            "title": "Как клеить обои",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-kleit-oboi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-oboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-oboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 9913,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2038aced40254f2245"
        },
        {
            "title": "Декорирование шторами, пошив",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "dekorirovanie-shtorami-poshiv",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/dekorirovanie-shtorami-poshiv/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/dekorirovanie-shtorami-poshiv/000-photo.jpg/000-photo.jpg 2x",
            "views": 5407,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2038aced40254f2246"
        },
        {
            "title": "Как выбрать клей и поклеить обои",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-vybrat-kley-i-pokleit-oboi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-kley-i-pokleit-oboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-kley-i-pokleit-oboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 4602,
            "total_comment": 0,
            "is_video": true,
            "likes": 5,
            "id": "648aca2038aced40254f2247"
        },
        {
            "title": "Как установить карнизы для штор",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "kak-ustanovit-karnizy-dlya-shtor",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ustanovit-karnizy-dlya-shtor/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ustanovit-karnizy-dlya-shtor/000-photo.jpg/000-photo.jpg 2x",
            "views": 8984,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2138aced40254f2248"
        },
        {
            "title": "Кухня «Леда Серая»: современная классика в спокойных тонах",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "19.10.2021",
            "link": "kuhnya-leda-seraya-sovremennaya-klassika-v-spokoynyh-tonah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhnya-leda-seraya-sovremennaya-klassika-v-spokoynyh-tonah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kuhnya-leda-seraya-sovremennaya-klassika-v-spokoynyh-tonah/000-photo.jpg/000-photo.jpg 2x",
            "views": 14260,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca2138aced40254f2249"
        },
        {
            "title": "Бязь – что это за материал, состав и сравнение с другим постельным бельём",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.10.2022",
            "link": "byaz-chto-eto-za-material-sostav-i-sravnenie-s-drugim-postelnym-belem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/byaz-chto-eto-za-material-sostav-i-sravnenie-s-drugim-postelnym-belem/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/byaz-chto-eto-za-material-sostav-i-sravnenie-s-drugim-postelnym-belem/000-hero.jpg/000-hero.jpg 2x",
            "views": 16055,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca2138aced40254f224a"
        },
        {
            "title": "Как затирать швы на плитке на полу и на стене, на керамической и клинкерной плитке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "18.10.2022",
            "link": "kak-zatirat-shvy-na-plitke-na-polu-i-na-stene-na-keramicheskoy-i-klinkernoy-plitke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-zatirat'-shvy-na-plitke-na-polu-i-na-stene,-na-keramicheskoj-i-klinkernoj-plitke/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-zatirat'-shvy-na-plitke-na-polu-i-na-stene,-na-keramicheskoj-i-klinkernoj-plitke/000-photo.jpg/000-photo.jpg 2x",
            "views": 14364,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca2138aced40254f224b"
        },
        {
            "title": "Как выбрать лучшую настольную лампу для школьника",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "17.10.2022",
            "link": "kak-vybrat-luchshuyu-nastolnuyu-lampu-dlya-shkolnika",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat'-luchshuyu-nastol'nuyu-lampu-dlya-shkol'nika/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat'-luchshuyu-nastol'nuyu-lampu-dlya-shkol'nika/000-photo.jpg/000-photo.jpg 2x",
            "views": 8699,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca2138aced40254f224c"
        },
        {
            "title": "Как поменять лампочку в светильнике в натяжном потолке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "19.10.2022",
            "link": "kak-pomenyat-lampochku-v-svetilnike-v-natyazhnom-potolke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-pomenyat'-lampochku-v-svetil'nike-v-natyazhnom-potolke/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-pomenyat'-lampochku-v-svetil'nike-v-natyazhnom-potolke/000-photo.jpg/000-photo.jpg 2x",
            "views": 8347,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2238aced40254f224d"
        },
        {
            "title": "Как правильно сделать потолок в бане своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "11.10.2022",
            "link": "kak-pravilno-sdelat-potolok-v-bane-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-pravil'no-sdelat'-potolok-v-bane-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-pravil'no-sdelat'-potolok-v-bane-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 4528,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2238aced40254f224e"
        },
        {
            "title": "Как заточить сверло по металлу",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.10.2022",
            "link": "kak-zatochit-sverlo-po-metallu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-zatochit'-sverlo-po-metallu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-zatochit'-sverlo-po-metallu/000-photo.jpg/000-photo.jpg 2x",
            "views": 7570,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2238aced40254f224f"
        },
        {
            "title": "Как выбрать электрическую вафельницу для венских и бельгийских вафель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "29.11.2022",
            "link": "kak-vybrat-elektricheskuyu-vafelnicu-dlya-venskih-i-belgiyskih-vafel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-vafel'nicu-dlya-venskih-i-bel'gijskih-vafel'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-vybrat'-elektricheskuyu-vafel'nicu-dlya-venskih-i-bel'gijskih-vafel'/000-photo.jpg/000-photo.jpg 2x",
            "views": 6878,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca2238aced40254f2250"
        },
        {
            "title": "Как и чем отмыть душевую кабину – все возможные способы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2022",
            "link": "kak-i-chem-otmyt-dushevuyu-kabinu-vse-vozmozhnye-sposoby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-chem-otmyt'-dushevuyu-kabinu---vse-vozmozhnye-sposoby/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-i-chem-otmyt'-dushevuyu-kabinu---vse-vozmozhnye-sposoby/000-photo.jpg/000-photo.jpg 2x",
            "views": 11652,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2238aced40254f2251"
        },
        {
            "title": "Как мыть натяжные потолки: матовые и глянцевые",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2022",
            "link": "kak-myt-natyazhnye-potolki-matovye-i-glyancevye",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-myt'-natyazhnye-potolki--matovye-i-glyancevye/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-myt'-natyazhnye-potolki--matovye-i-glyancevye/000-photo.jpg/000-photo.jpg 2x",
            "views": 11882,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2338aced40254f2252"
        },
        {
            "title": "Гигиенический душ: преимущества, функции, способы установки",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.10.2021",
            "link": "gigienicheskiy-dush-preimushchestva-funkcii-sposoby-ustanovki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gigienicheskiy-dush-preimushchestva-funkcii-sposoby-ustanovki/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gigienicheskiy-dush-preimushchestva-funkcii-sposoby-ustanovki/000-hero.jpg/000-hero.jpg 2x",
            "views": 13050,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca2338aced40254f2253"
        },
        {
            "title": "Оформление окна и способы крепления штор",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.07.2022",
            "link": "oformlenie-okna-i-sposoby-krepleniya-shtor",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oformlenie-okna-i-sposoby-krepleniya-shtor/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oformlenie-okna-i-sposoby-krepleniya-shtor/000-photo.jpg/000-photo.jpg 2x",
            "views": 12267,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca2338aced40254f2254"
        },
        // {
        //     "title": "Виды декоративных наклеек",
        //     "description": "",
        //     "type": "Вдохновиться",
        //     "type_slug": "be-inspired",
        //     "dept": "Декор",
        //     "dept_slug": "dekor",
        //     "date_publish": "22.12.2021",
        //     "link": "vidy-dekorativnyh-nakleek",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vidy-dekorativnykh-nakleek/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vidy-dekorativnykh-nakleek/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 5638,
        //     "total_comment": 3,
        //     "is_video": false,
        //     "likes": 13,
        //     "id": "648aca2338aced40254f2255"
        // },
        // {
        //     "title": "Как сделать электропроводку",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Электротовары",
        //     "dept_slug": "elektrotovary",
        //     "date_publish": "22.12.2021",
        //     "link": "kak-sdelat-elektroprovodku",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-sdelat-elektroprovodku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-sdelat-elektroprovodku/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 9515,
        //     "total_comment": 1,
        //     "is_video": false,
        //     "likes": 9,
        //     "id": "648aca2338aced40254f2256"
        // },
        {
            "title": "Как выбрать бытовой фонарь",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "11.01.2022",
            "link": "kak-vybrat-bytovoy-fonar",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-bytovoy-fonar/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-bytovoy-fonar/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15657,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca2438aced40254f2257"
        },
        {
            "title": "Как выбрать бризер для квартиры",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "17.01.2022",
            "link": "kak-vybrat-brizer-dlya-kvartiry",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/osveshtenie/kak-vybrat-brizer-dlya-kvartiry/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/osveshtenie/kak-vybrat-brizer-dlya-kvartiry/000-photo.jpg/000-photo.jpg 2x",
            "views": 14654,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648aca2438aced40254f2259"
        },
        {
            "title": "Варианты использования осветителя на удлинителе",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "11.01.2022",
            "link": "varianty-ispolzovaniya-osvetitelya-na-udlinitele-",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/varianty-ispolzovaniya-osvetitelya-na-udlinitele/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/varianty-ispolzovaniya-osvetitelya-na-udlinitele/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13944,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca2438aced40254f225a"
        },
        {
            "title": "Как выбрать профессиональный фонарь",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "11.01.2022",
            "link": "kak-vybrat-professionalnyy-fonar",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-professionalnyy-fonar/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-professionalnyy-fonar/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14817,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2438aced40254f225b"
        },
        {
            "title": "Как починить шланг от душа своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "11.10.2022",
            "link": "kak-pochinit-shlang-ot-dusha-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-pochinit'-shlang-ot-dusha-svoimi-rukami/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-pochinit'-shlang-ot-dusha-svoimi-rukami/000-hero.jpg/000-hero.jpg 2x",
            "views": 7514,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca2438aced40254f225c"
        },
        // {
        //     "title": "Как сделать тротуарную плитку своими руками?",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Стройматериалы",
        //     "dept_slug": "stroymaterialy",
        //     "date_publish": "12.10.2022",
        //     "link": "kak-sdelat-trotuarnuyu-plitku-svoimi-rukami",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat'-trotuarnuyu-plitku-svoimi-rukami-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat'-trotuarnuyu-plitku-svoimi-rukami-/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 5405,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 13,
        //     "id": "648aca2538aced40254f225d"
        // },
        // {
        //     "title": "Что такое метизы и какие они бывают",
        //     "description": "",
        //     "type": "Как использовать",
        //     "type_slug": "how-to-use",
        //     "dept": "Скобяные изделия",
        //     "dept_slug": "skobyanye-izdeliya",
        //     "date_publish": "11.10.2022",
        //     "link": "chto-takoe-metizy-i-kakie-oni-byvayut",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-takoe-metizy-i-kakie-oni-byvayut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-takoe-metizy-i-kakie-oni-byvayut/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 13548,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 9,
        //     "id": "648aca2538aced40254f225e"
        // },
        // {
        //     "title": "Как обжать витую пару 8 и 4 жил в домашних условиях",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Электротовары",
        //     "dept_slug": "elektrotovary",
        //     "date_publish": "12.10.2022",
        //     "link": "kak-obzhat-vituyu-paru-8-i-4-zhil-v-domashnih-usloviyah",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-obzhat'-vituyu-paru-8-i-4-zhil-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-obzhat'-vituyu-paru-8-i-4-zhil-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 6192,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 11,
        //     "id": "648aca2538aced40254f225f"
        // },
        {
            "title": "Что такое коаксиальный дымоход, и как его правильно установить",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "07.10.2022",
            "link": "chto-takoe-koaksialnyy-dymohod-i-kak-ego-pravilno-ustanovit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-koaksial'nyj-dymohod,-i-kak-ego-pravil'no-ustanovit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-koaksial'nyj-dymohod,-i-kak-ego-pravil'no-ustanovit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 9009,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2538aced40254f2260"
        },
        {
            "title": "Как правильно рисовать картины по номерам – подробная инструкция",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.10.2022",
            "link": "kak-pravilno-risovat-kartiny-po-nomeram-podrobnaya-instrukciya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravil'no-risovat'-kartiny-po-nomeram-–-podrobnaya-instrukciya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravil'no-risovat'-kartiny-po-nomeram-–-podrobnaya-instrukciya/000-photo.jpg/000-photo.jpg 2x",
            "views": 5831,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca2638aced40254f2261"
        },
        {
            "title": "Как выбрать удобный и красивый диван",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "13.10.2022",
            "link": "kak-vybrat-udobnyy-i-krasivyy-divan",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat'-udobnyj-i-krasivyj-divan/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat'-udobnyj-i-krasivyj-divan/000-photo.jpg/000-photo.jpg 2x",
            "views": 12758,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca2638aced40254f2262"
        },
        {
            "title": "Что такое ЛДСП, плюсы и минусы, отличия от МДФ",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "14.10.2022",
            "link": "chto-takoe-ldsp-plyusy-i-minusy-otlichiya-ot-mdf",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/chto-takoe-ldsp,-plyusy-i-minusy,-otlichiya-ot-mdf/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/chto-takoe-ldsp,-plyusy-i-minusy,-otlichiya-ot-mdf/000-photo.jpg/000-photo.jpg 2x",
            "views": 4221,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2638aced40254f2263"
        },
        {
            "title": "Как выбрать валик для покраски потолка, стен или мебели",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.10.2022",
            "link": "kak-vybrat-valik-dlya-pokraski-potolka-sten-ili-mebeli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat'-valik-dlya-pokraski-potolka,-sten-ili-mebeli/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat'-valik-dlya-pokraski-potolka,-sten-ili-mebeli/000-photo.jpg/000-photo.jpg 2x",
            "views": 15738,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2638aced40254f2264"
        },
        {
            "title": "Как сделать светильник из труб",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.01.2022",
            "link": "kak-sdelat-svetilnik-iz-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sdelat-svetilnik-iz-trub/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sdelat-svetilnik-iz-trub/000-hero.jpg/000-hero.jpg 2x",
            "views": 9765,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca2638aced40254f2265"
        },
        {
            "title": "Как использовать светодиодную ленту",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "01.06.2022",
            "link": "kak-ispolzovat-svetodiodnuyu-lentu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-podklyuchit-svetodiodnuyu-lentu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-podklyuchit-svetodiodnuyu-lentu/000-photo.jpg/000-photo.jpg 2x",
            "views": 16236,
            "total_comment": 0,
            "is_video": true,
            "likes": 15,
            "id": "648aca2738aced40254f2266"
        },
        {
            "title": "Выбираем радиатор отопления",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "14.01.2022",
            "link": "vybiraem-radiator-otopleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vybiraem-radiator-otopleniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vybiraem-radiator-otopleniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 5081,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca2738aced40254f2267"
        },
        {
            "title": "Как правильно подключить двухклавишный выключатель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "15.01.2022",
            "link": "kak-pravilno-podklyuchit-dvuhklavishnyy-vyklyuchatel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravilno-podklyuchit-dvuhklavishnyy-vyklyuchatel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravilno-podklyuchit-dvuhklavishnyy-vyklyuchatel/000-photo.jpg/000-photo.jpg 2x",
            "views": 12568,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca2738aced40254f2269"
        },
        {
            "title": "Виды москитных сеток",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "08.07.2022",
            "link": "vidy-moskitnyh-setok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vidy-moskitnyh-setok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vidy-moskitnyh-setok/000-photo.jpg/000-photo.jpg 2x",
            "views": 14322,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2738aced40254f226a"
        },
        {
            "title": "Как ухаживать за орхидеями",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "17.01.2022",
            "link": "kak-uhazhivat-za-orhideyami-peresazhivat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-uhazhivat-za-orhideyami-peresazhivat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-uhazhivat-za-orhideyami-peresazhivat/000-photo.jpg/000-photo.jpg 2x",
            "views": 8450,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2738aced40254f226b"
        },
        {
            "title": "Кольцевые лампы со штативом",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "30.05.2022",
            "link": "kolcevye-lampy-so-shtativom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/svetilniki-kolcevye-lampy-so-shtativom/000_hero.jpg/000_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/svetilniki-kolcevye-lampy-so-shtativom/000_hero.jpg/000_hero.jpg 2x",
            "views": 6476,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2838aced40254f226c"
        },
        {
            "title": "Чем отличается шуруп от самореза – в чём разница?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "14.10.2022",
            "link": "chem-otlichaetsya-shurup-ot-samoreza-v-chem-raznica",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chem-otlichaetsya-shurup-ot-samoreza---v-chyom-raznica-/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chem-otlichaetsya-shurup-ot-samoreza---v-chyom-raznica-/000-hero.jpg/000-hero.jpg 2x",
            "views": 10309,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2838aced40254f226d"
        },
        {
            "title": "Гид по веникам для бани: какие бывают, как выбирать и пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.10.2022",
            "link": "gid-po-venikam-dlya-bani-kakie-byvayut-kak-vybirat-i-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gid-po-venikam-dlya-bani-kakie-byvayut-kak-vybirat-i-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gid-po-venikam-dlya-bani-kakie-byvayut-kak-vybirat-i-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6473,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2838aced40254f226e"
        },
        {
            "title": "Что такое резиновая краска и что ей можно красить",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.10.2022",
            "link": "chto-takoe-rezinovaya-kraska-i-chto-ey-mozhno-krasit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-rezinovaya-kraska-i-chto-ej-mozhno-krasit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-rezinovaya-kraska-i-chto-ej-mozhno-krasit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 9372,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca2838aced40254f226f"
        },
        {
            "title": "Что такое бойлер и как выбрать бойлер для дома?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.10.2022",
            "link": "chto-takoe-boyler-i-kak-vybrat-boyler-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-bojler-i-kak-vybrat'-bojler-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-bojler-i-kak-vybrat'-bojler-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 15847,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca2838aced40254f2270"
        },
        {
            "title": "Как сделать забор из профнастила своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "07.10.2022",
            "link": "kak-sdelat-zabor-iz-profnastila-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-zabor-iz-profnastila-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-zabor-iz-profnastila-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 4696,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2938aced40254f2271"
        },
        {
            "title": "Чем отделать стены на кухне: варианты отделки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "07.10.2022",
            "link": "chem-otdelat-steny-na-kuhne-varianty-otdelki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chem-otdelat'-steny-na-kuhne--varianty-otdelki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chem-otdelat'-steny-na-kuhne--varianty-otdelki/000-photo.jpg/000-photo.jpg 2x",
            "views": 13713,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2938aced40254f2272"
        },
        {
            "title": "Что такое алкидная краска, и чем она отличается от акриловой",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "10.10.2022",
            "link": "chto-takoe-alkidnaya-kraska-i-chem-ona-otlichaetsya-ot-akrilovoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-alkidnaya-kraska-i-chem-ona-otlichaetsya-ot-akrilovoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-alkidnaya-kraska-i-chem-ona-otlichaetsya-ot-akrilovoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 7051,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2938aced40254f2273"
        },
        {
            "title": "Что такое раклетница, и как ею пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "10.10.2022",
            "link": "chto-takoe-rakletnica-i-kak-eyu-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-rakletnica-i-kak-eyu-pol'zovat'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-rakletnica-i-kak-eyu-pol'zovat'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 14845,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca2938aced40254f2274"
        },
        // {
        //     "title": "Как и из какого материала сделать тёплый и долговечный пол в бане",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Столярные изделия",
        //     "dept_slug": "stolyarnye-izdeliya",
        //     "date_publish": "12.10.2022",
        //     "link": "kak-i-iz-kakogo-materiala-sdelat-teplyy-i-dolgovechnyy-pol-v-bane",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat'-trotuarnuyu-plitku-svoimi-rukami-kak-i-iz-kakogo-materiala-sdelat'-tyoplyj-i-dolgovechnyj-pol-v-bane/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat'-trotuarnuyu-plitku-svoimi-rukami-kak-i-iz-kakogo-materiala-sdelat'-tyoplyj-i-dolgovechnyj-pol-v-bane/000-hero.jpg/000-hero.jpg 2x",
        //     "views": 5585,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 9,
        //     "id": "648aca2a38aced40254f2275"
        // },
        // {
        //     "title": "Что такое ондулин, отличия ондулина от профнастила и металлочерепицы",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Стройматериалы",
        //     "dept_slug": "stroymaterialy",
        //     "date_publish": "12.10.2022",
        //     "link": "chto-takoe-ondulin-otlichiya-ondulina-ot-profnastila-i-metallocherepicy",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chto-takoe-ondulin,-otlichiya-ondulina-ot-profnastila-i-metallocherepicy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chto-takoe-ondulin,-otlichiya-ondulina-ot-profnastila-i-metallocherepicy/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 10569,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 11,
        //     "id": "648aca2a38aced40254f2276"
        // },
        // {
        //     "title": "Как выбрать и ухаживать за машинкой для стрижки волос дома",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Сантехника",
        //     "dept_slug": "santehnika",
        //     "date_publish": "12.10.2022",
        //     "link": "kak-vybrat-i-uhazhivat-za-mashinkoy-dlya-strizhki-volos-doma",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-i-uhazhivat'-za-mashinkoj-dlya-strizhki-volos-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-i-uhazhivat'-za-mashinkoj-dlya-strizhki-volos-doma/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 4504,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 5,
        //     "id": "648aca2a38aced40254f2277"
        // },
        {
            "title": "Как снять жалюзи (вертикальные и горизонтальные) и рулонные шторы, чтобы помыть",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.10.2022",
            "link": "kak-snyat-zhalyuzi-vertikalnye-i-gorizontalnye-i-rulonnye-shtory-chtoby-pomyt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-snyat-zhaluzi-i-rulonnie-shtory-chtoby-pomit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-snyat-zhaluzi-i-rulonnie-shtory-chtoby-pomit/000-photo.jpg/000-photo.jpg 2x",
            "views": 8756,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2a38aced40254f2278"
        },
        {
            "title": "Как пользоваться индикаторной отвёрткой",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.10.2022",
            "link": "kak-polzovatsya-indikatornoy-otvertkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pol'zovat'sya-indikatornoj-otvyortkoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pol'zovat'sya-indikatornoj-otvyortkoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 13844,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca2a38aced40254f2279"
        },
        {
            "title": "Как повесить телевизор на стену: на какой высоте, с кронштейном и без, на гипсокартон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "26.10.2022",
            "link": "kak-povesit-televizor-na-stenu-na-kakoy-vysote-s-kronshteynom-i-bez-na-gipsokarton",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-povesit'-televizor-na-stenu--na-kakoj-vysote,-s-kronshtejnom-i-bez,-na-gipsokarton/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-povesit'-televizor-na-stenu--na-kakoj-vysote,-s-kronshtejnom-i-bez,-na-gipsokarton/000-photo.jpg/000-photo.jpg 2x",
            "views": 4371,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2b38aced40254f227a"
        },
        {
            "title": "Что такое уайт-спирит и где он применяется?",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "25.10.2022",
            "link": "chto-takoe-uayt-spirit-i-gde-on-primenyaetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-uajt-spirit-i-gde-on-primenyaetsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-uajt-spirit-i-gde-on-primenyaetsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 11197,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca2b38aced40254f227b"
        },
        {
            "title": "Как пользоваться жидкими гвоздями с пистолетом и без него",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "26.10.2022",
            "link": "kak-polzovatsya-zhidkimi-gvozdyami-s-pistoletom-i-bez-nego",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pol'zovat'sya-zhidkimi-gvozdyami-s-pistoletom-i-bez-nego/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pol'zovat'sya-zhidkimi-gvozdyami-s-pistoletom-i-bez-nego/000-photo.jpg/000-photo.jpg 2x",
            "views": 7378,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2b38aced40254f227c"
        },
        {
            "title": "Плюсы и минусы обоев под покраску, и можно ли их не красить?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "18.10.2022",
            "link": "plyusy-i-minusy-oboev-pod-pokrasku-i-mozhno-li-ih-ne-krasit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/plyusy-i-minusy-oboev-pod-pokrasku,-i-mozhno-li-ih-ne-krasit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/plyusy-i-minusy-oboev-pod-pokrasku,-i-mozhno-li-ih-ne-krasit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 11273,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca2b38aced40254f227d"
        },
        {
            "title": "Как визуально увеличить высоту потолка",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "10.05.2022",
            "link": "kak-vizualno-uvelichit-vysotu-potolka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vizualno-uvelichit-vysotu-potolka/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vizualno-uvelichit-vysotu-potolka/000-hero.jpg/000-hero.jpg 2x",
            "views": 11719,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca2b38aced40254f227e"
        },
        {
            "title": "Как снять старые обои",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.07.2022",
            "link": "kak-snyat-starye-oboi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-snyat-starye-oboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-snyat-starye-oboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 6667,
            "total_comment": 2,
            "is_video": false,
            "likes": 6,
            "id": "648aca2c38aced40254f227f"
        },
        {
            "title": "Самоклеящаяся пленка: классификация и использование",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "10.05.2022",
            "link": "samokleyashchayasya-plenka-klassifikatsiya-ispolzovanie-i-ukhod",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/samokleyashchayasya-plenka-klassifikatsiya-ispolzovanie-i-ukhod/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/samokleyashchayasya-plenka-klassifikatsiya-ispolzovanie-i-ukhod/000-photo.jpg/000-photo.jpg 2x",
            "views": 5200,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca2c38aced40254f2280"
        },
        {
            "title": "Постельное бельё: материалы, размеры, правила ухода, тренды",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "postelnoe-bele-materialy-razmery-pravila-uhoda-trendy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/postelnoe-bele-materialy-razmery-pravila-uhoda-trendy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/postelnoe-bele-materialy-razmery-pravila-uhoda-trendy/000-photo.jpg/000-photo.jpg 2x",
            "views": 9848,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca2c38aced40254f2281"
        },
        {
            "title": "Вне времени: выбираем обои, которые не выйдут из моды",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "vne-vremeni-vybiraem-oboi-kotorye-ne-vyydut-iz-mody",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vne-vremeni-vybiraem-oboi-kotorye-ne-vyydut-iz-mody/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vne-vremeni-vybiraem-oboi-kotorye-ne-vyydut-iz-mody/000-photo.jpg/000-photo.jpg 2x",
            "views": 5235,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca2c38aced40254f2282"
        },
        {
            "title": "Большой гид по рулонным шторам",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "05.06.2023",
            "link": "bolshoy-gid-po-rulonnym-shtoram",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/bolshoy-gid-po-rulonnym-shtoram/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/bolshoy-gid-po-rulonnym-shtoram/000-photo.jpg/000-photo.jpg 2x",
            "views": 6319,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca2c38aced40254f2283"
        },
        {
            "title": "Расставляем акценты: как выделить стену с помощью обоев",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "rasstavlyaem-akcenty-kak-vydelit-stenu-s-pomoshchyu-oboev",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/rasstavlyaem-akcenty-kak-vydelit-stenu-s-pomoshchyu-oboev/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/rasstavlyaem-akcenty-kak-vydelit-stenu-s-pomoshchyu-oboev/000-photo.jpg/000-photo.jpg 2x",
            "views": 7599,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca2d38aced40254f2284"
        },
        {
            "title": "И тепло, и красиво: как покрасить батареи",
            "description": "И тепло, и красиво: как покрасить батареи",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "09.08.2022",
            "link": "i-teplo-i-krasivo-kak-pokrasit-batarei",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/i-teplo-i-krasivo-kak-pokrasit-batarei/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/i-teplo-i-krasivo-kak-pokrasit-batarei/000-photo.jpg/000-photo.jpg 2x",
            "views": 7735,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2d38aced40254f2285"
        },
        {
            "title": "Обои: как комбинировать и зонировать пространство",
            "description": "Обои: как комбинировать и зонировать пространство",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.07.2022",
            "link": "oboi-kak-kombinirovat-i-zonirovat-prostranstvo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oboi-kak-kombinirovat-i-zonirovat-prostranstvo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oboi-kak-kombinirovat-i-zonirovat-prostranstvo/000-photo.jpg/000-photo.jpg 2x",
            "views": 14139,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca2d38aced40254f2286"
        },
        {
            "title": "Интенсивность цвета в интерьере: как соблюсти баланс",
            "description": "Интенсивность цвета в интерьере: как соблюсти баланс",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.08.2022",
            "link": "intensivnost-tsveta-v-interere-kak-soblyusti-balans",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/intensivnost-tsveta-v-interere-kak-soblyusti-balans/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/intensivnost-tsveta-v-interere-kak-soblyusti-balans/000-photo.jpg/000-photo.jpg 2x",
            "views": 8245,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2d38aced40254f2288"
        },
        {
            "title": "Проекты клиентов: все, что нужно знать о первом ремонте",
            "description": "Проекты клиентов: все, что нужно знать о первом ремонте",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.08.2022",
            "link": "proekty-klientov-vse-chto-nuzhno-znat-o-pervom-remonte",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-vse-chto-nuzhno-znat-o-pervom-remonte/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/proekty-klientov-vse-chto-nuzhno-znat-o-pervom-remonte/000-photo.jpg/000-photo.jpg 2x",
            "views": 9390,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca2e38aced40254f2289"
        },
        {
            "title": "В темноте: защищаем помещение от солнца",
            "description": "В темноте: защищаем помещение от солнца",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "v-temnote-zashchishchaem-pomeshchenie-ot-solntsa",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/v-temnote-zashchishchaem-pomeshchenie-ot-solntsa/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/v-temnote-zashchishchaem-pomeshchenie-ot-solntsa/000-photo.jpg/000-photo.jpg 2x",
            "views": 11277,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca2e38aced40254f228a"
        },
        {
            "title": "Как выбрать тиски",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "kak-vybrat-tiski",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-tiski/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-tiski/000-photo.png/000-photo.png 2x",
            "views": 14363,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2e38aced40254f228b"
        },
        {
            "title": "Как выбрать стремянку",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "kak-vybrat-stremyanku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-stremyanku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-stremyanku/000-photo.jpg/000-photo.jpg 2x",
            "views": 6177,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2e38aced40254f228c"
        },
        {
            "title": "Как выбрать слесарные тиски",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "kak-vybrat-slesarnye-tiski",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-slesarnye-tiski/001.png/001.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-slesarnye-tiski/001.png/001.png 2x",
            "views": 7225,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca2e38aced40254f228d"
        },
        {
            "title": "Как открутить ржавую гайку",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.02.2022",
            "link": "kak-otkrutit-rzhavuyu-gayku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-otkrutit-rzhavuyu-gayku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-otkrutit-rzhavuyu-gayku/000-photo.jpg/000-photo.jpg 2x",
            "views": 11538,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca2f38aced40254f228e"
        },
        {
            "title": "Какой смеситель для ванной подойдёт именно вам?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "26.10.2022",
            "link": "kakoy-smesitel-dlya-vannoy-podoydet-imenno-vam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kakoj-smesitel'-dlya-vannoj-podojdyot-imenno-vam-/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kakoj-smesitel'-dlya-vannoj-podojdyot-imenno-vam-/000-hero.jpg/000-hero.jpg 2x",
            "views": 7702,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca2f38aced40254f228f"
        },
        {
            "title": "Биты для шуруповёрта: как снять, если застряла, как надеть, и что делать, если бита выпадает",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "26.10.2022",
            "link": "bity-dlya-shurupoverta-kak-snyat-esli-zastryala-kak-nadet-i-chto-delat-esli-bita-vypadaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/bity-dlya-shrupoverta--kak-snyat',-esli-zastryala,-kak-odet',-i-chto-delat',-esli-bita-vypadaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/bity-dlya-shrupoverta--kak-snyat',-esli-zastryala,-kak-odet',-i-chto-delat',-esli-bita-vypadaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 12954,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca2f38aced40254f2290"
        },
        // {
        //     "title": "Какие обои выбрать для кухни: тренды современного дизайна",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Декор",
        //     "dept_slug": "dekor",
        //     "date_publish": "26.10.2022",
        //     "link": "kakie-oboi-vybrat-dlya-kuhni-trendy-sovremennogo-dizayna",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kakie-oboi-vybrat'-dlya-kuhni--trendy-sovremennogo-dizajna/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kakie-oboi-vybrat'-dlya-kuhni--trendy-sovremennogo-dizajna/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 6971,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 8,
        //     "id": "648aca2f38aced40254f2291"
        // },
        {
            "title": "Что такое шторы блэкаут, зачем они нужны и как за ними ухаживать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.10.2022",
            "link": "chto-takoe-shtory-blekaut-zachem-oni-nuzhny-i-kak-za-nimi-uhazhivat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-shtory-blekaut,-zachem-oni-nuzhny-i-kak-za-nimi-uhazhivat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-shtory-blekaut,-zachem-oni-nuzhny-i-kak-za-nimi-uhazhivat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 13917,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca2f38aced40254f2292"
        },
        {
            "title": "Что такое суперфосфат и что можно подкормить суперфосфатом",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "27.10.2022",
            "link": "chto-takoe-superfosfat-i-chto-mozhno-podkormit-superfosfatom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-superfosfat-i-chto-mozhno-podkormit'-superfosfatom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-superfosfat-i-chto-mozhno-podkormit'-superfosfatom/000-photo.jpg/000-photo.jpg 2x",
            "views": 13342,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca3038aced40254f2293"
        },
        {
            "title": "Как пользоваться лазерным уровнем (нивелиром)",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "27.10.2022",
            "link": "kak-polzovatsya-lazernym-urovnem-nivelirom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pol'zovat'sya-lazernym-urovnem-(nivelirom)/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-pol'zovat'sya-lazernym-urovnem-(nivelirom)/000-photo.jpg/000-photo.jpg 2x",
            "views": 4707,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3038aced40254f2294"
        },
        {
            "title": "Как выбрать стильный и комфортный рюкзак",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "20.10.2022",
            "link": "kak-vybrat-stilnyy-i-komfortnyy-ryukzak",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat'-stil'nyj-i-komfortnyj-ryukzak/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat'-stil'nyj-i-komfortnyj-ryukzak/000-photo.jpg/000-photo.jpg 2x",
            "views": 13748,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3038aced40254f2295"
        },
        {
            "title": "Что такое ротанг и где он используется",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "26.10.2022",
            "link": "chto-takoe-rotang-i-gde-on-ispolzuetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-rotang-i-gde-on-ispol'zuetsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-rotang-i-gde-on-ispol'zuetsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 11909,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3038aced40254f2296"
        },
        {
            "title": "Как выбрать бензопилу для дома и дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "27.10.2022",
            "link": "kak-vybrat-benzopilu-dlya-doma-i-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-benzopilu-dlya-doma-i-dachi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-benzopilu-dlya-doma-i-dachi/000-photo.jpg/000-photo.jpg 2x",
            "views": 9223,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3038aced40254f2297"
        },
        {
            "title": "Браширование дерева своими руками — как состарить дерево",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "27.10.2022",
            "link": "brashirovanie-dereva-svoimi-rukami-kak-sostarit-derevo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/brashirovanie-dereva-svoimi-rukami---kak-sostarit'-derevo/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/brashirovanie-dereva-svoimi-rukami---kak-sostarit'-derevo/000-hero.jpg/000-hero.jpg 2x",
            "views": 7168,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3138aced40254f2298"
        },
        {
            "title": "Что такое азотные удобрения и как их правильно применять для подкормки",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "27.10.2022",
            "link": "chto-takoe-azotnye-udobreniya-i-kak-ih-pravilno-primenyat-dlya-podkormki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-azotnye-udobreniya-i-kak-ih-pravil'no-primenyat'-dlya-podkormki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-azotnye-udobreniya-i-kak-ih-pravil'no-primenyat'-dlya-podkormki/000-photo.jpg/000-photo.jpg 2x",
            "views": 15510,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3138aced40254f2299"
        },
        {
            "title": "Канвас – что это за ткань, состав материала и его применение",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.10.2022",
            "link": "kanvas-chto-eto-za-tkan-sostav-materiala-i-ego-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kanvas---chto-eto-za-tkan',-sostav-materiala-i-ego-primenenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kanvas---chto-eto-za-tkan',-sostav-materiala-i-ego-primenenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 12128,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3138aced40254f229a"
        },
        {
            "title": "Чем и как покрасить шифер, какую выбрать краску?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "27.10.2022",
            "link": "chem-i-kak-pokrasit-shifer-kakuyu-vybrat-krasku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-i-kak-pokrasit'-shifer,-kakuyu-vybrat'-krasku-/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-i-kak-pokrasit'-shifer,-kakuyu-vybrat'-krasku-/000-photo.jpg/000-photo.jpg 2x",
            "views": 10934,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3138aced40254f229b"
        },
        {
            "title": "Как приклеить тюль на оконное стекло",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.10.2022",
            "link": "kak-prikleit-tyul-na-okonnoe-steklo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-prikleit'-tyul'-na-okonnoe-steklo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-prikleit'-tyul'-na-okonnoe-steklo/000-photo.jpg/000-photo.jpg 2x",
            "views": 14969,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca3138aced40254f229c"
        },
        {
            "title": "Что такое дальномер, как его выбрать и как пользоваться дальномером",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "28.10.2022",
            "link": "chto-takoe-dalnomer-kak-ego-vybrat-i-kak-polzovatsya-dalnomerom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-dal'nomer,-kak-ego-vybrat'-i-kak-pol'zovat'sya-dal'nomerom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-dal'nomer,-kak-ego-vybrat'-i-kak-pol'zovat'sya-dal'nomerom/000-photo.jpg/000-photo.jpg 2x",
            "views": 4206,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca3238aced40254f229d"
        },
        {
            "title": "Чем покрасить вагонку внутри и снаружи дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "28.10.2022",
            "link": "chem-pokrasit-vagonku-vnutri-i-snaruzhi-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit'-vagonku-vnutri-i-snaruzhi-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit'-vagonku-vnutri-i-snaruzhi-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 11777,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca3238aced40254f229e"
        },
        {
            "title": "Забор из металлического штакетника своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "31.10.2022",
            "link": "zabor-iz-metallicheskogo-shtaketnika-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zabor-iz-metallicheskogo-shtaketnika-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zabor-iz-metallicheskogo-shtaketnika-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 5249,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3238aced40254f229f"
        },
        {
            "title": "Как подобрать плитку для фартука на кухню",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "08.11.2022",
            "link": "kak-podobrat-plitku-dlya-fartuka-na-kuhnyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-podobrat'-plitku-dlya-fartuka-na-kuhnyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-podobrat'-plitku-dlya-fartuka-na-kuhnyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 15939,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3238aced40254f22a0"
        },
        {
            "title": "Какие характеристики нужно учесть при выборе снегоуборочной техники",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "10.11.2022",
            "link": "kakie-harakteristiki-nuzhno-uchest-pri-vybore-snegouborochnoy-mashiny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kakie-harakteristiki-nuzhno-uchest'-pri-vybore-snegouborochnoj-mashiny/kakie-harakteristiki-nuzhno-uchest'-pri-vibore-snegouborochnoi-mashini.jpg/kakie-harakteristiki-nuzhno-uchest'-pri-vibore-snegouborochnoi-mashini.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kakie-harakteristiki-nuzhno-uchest'-pri-vybore-snegouborochnoj-mashiny/kakie-harakteristiki-nuzhno-uchest'-pri-vibore-snegouborochnoi-mashini.jpg/kakie-harakteristiki-nuzhno-uchest'-pri-vibore-snegouborochnoi-mashini.jpg 2x",
            "views": 7445,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3238aced40254f22a1"
        },
        {
            "title": "Рейтинг электрических чайников",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "10.11.2022",
            "link": "reyting-elektricheskih-chaynikov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-electricheskih-chainikov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-electricheskih-chainikov/000-photo.jpg/000-photo.jpg 2x",
            "views": 12557,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca3338aced40254f22a2"
        },
        {
            "title": "Как крепить балясины к перилам и ступеням лестницы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "14.11.2022",
            "link": "kak-krepit-balyasiny-k-perilam-i-stupenyam-lestnicy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-krepit-balyasiny-k-perilam-i-stupenyam-lestnicy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-krepit-balyasiny-k-perilam-i-stupenyam-lestnicy/000-photo.jpg/000-photo.jpg 2x",
            "views": 8213,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca3338aced40254f22a3"
        },
        {
            "title": "Как выбрать входную дверь: в квартиру и в частный дом",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "15.11.2022",
            "link": "kak-vybrat-vhodnuyu-dver-v-kvartiru-i-v-chastnyy-dom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat'-vhodnuy-dver'-v-kvartiru-i-v-chastnii-dom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat'-vhodnuy-dver'-v-kvartiru-i-v-chastnii-dom/000-photo.jpg/000-photo.jpg 2x",
            "views": 8889,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca3338aced40254f22a4"
        },
        {
            "title": "Вискоза — что это за ткань, сравнение с хлопком и полиэстером",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.11.2022",
            "link": "viskoza-chto-eto-za-tkan-sravnenie-s-hlopkom-i-poliesterom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/viskoza-chto-eto-za-tkan'-sravnenie-s-hlopkom-i-poliestrom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/viskoza-chto-eto-za-tkan'-sravnenie-s-hlopkom-i-poliestrom/000-photo.jpg/000-photo.jpg 2x",
            "views": 14775,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca3338aced40254f22a5"
        },
        {
            "title": "Как установить пластиковый подоконник на окно ПВХ",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "10.11.2022",
            "link": "kak-ustanovit-plastikovyy-podokonnik-na-okno-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-plastikovyj-podokonnik-na-okno-pvh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-plastikovyj-podokonnik-na-okno-pvh/000-photo.jpg/000-photo.jpg 2x",
            "views": 16093,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3338aced40254f22a6"
        },
        {
            "title": "Что такое двухуровневые натяжные потолки",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.11.2022",
            "link": "chto-takoe-dvuhurovnevye-natyazhnye-potolki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-dvuhurovnevye-natyazhnye-potolki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-dvuhurovnevye-natyazhnye-potolki/000-photo.jpg/000-photo.jpg 2x",
            "views": 4083,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3438aced40254f22a7"
        },
        {
            "title": "Что такое молотковая краска, как её разводить и наносить",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "07.11.2022",
            "link": "chto-takoe-molotkovaya-kraska-kak-ee-razvodit-i-nanosit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-molotkovaya-kraska-kak-eyo-razvodit-i-nanosit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-molotkovaya-kraska-kak-eyo-razvodit-i-nanosit/000-photo.jpg/000-photo.jpg 2x",
            "views": 15170,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca3438aced40254f22a8"
        },
        {
            "title": "Как выбрать гидромассажную ванну",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "09.11.2022",
            "link": "kak-vybrat-gidromassazhnuyu-vannu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-vannu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat'-vannu/000-photo.jpg/000-photo.jpg 2x",
            "views": 8726,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3438aced40254f22a9"
        },
        {
            "title": "Какие вещи должны быть в доме?",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.10.2022",
            "link": "nuzhnye-veshchi-dlya-doma-spisok-ot-lerua-merlen",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/nuzhnye-veshchi-dlya-doma--spisok-ot-lerua-merlen/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/nuzhnye-veshchi-dlya-doma--spisok-ot-lerua-merlen/000-hero.jpg/000-hero.jpg 2x",
            "views": 12087,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3438aced40254f22aa"
        },
        {
            "title": "Как выбрать снегоуборщик для частного дома и дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "10.11.2022",
            "link": "kak-vybrat-snegouborshchik-dlya-chastnogo-doma-i-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-snegouborshchik-dlya-chastnogo-doma-i-dachi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat'-snegouborshchik-dlya-chastnogo-doma-i-dachi/000-photo.jpg/000-photo.jpg 2x",
            "views": 4154,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca3538aced40254f22ab"
        },
        {
            "title": "Как работать УШМ (болгаркой) правильно и безопасно",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "08.11.2022",
            "link": "kak-rabotat-ushm-bolgarkoy-pravilno-i-bezopasno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/v1667631198/f_auto,q_auto,w_375,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-rabotat'-ushm-(bolgarkoj)-pravil'no-i-bezopasno/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/v1667631198/f_auto,q_auto,w_375,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-rabotat'-ushm-(bolgarkoj)-pravil'no-i-bezopasno/000-photo.jpg/000-photo.jpg 2x",
            "views": 6060,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3538aced40254f22ac"
        },
        {
            "title": "Что такое озонатор для воды?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "08.11.2022",
            "link": "chto-takoe-ozonator-dlya-vody",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-ozonator-dlya-vodi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-ozonator-dlya-vodi/000-photo.jpg/000-photo.jpg 2x",
            "views": 8022,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca3538aced40254f22ad"
        },
        {
            "title": "Как клеить плитку на гипсокартон и можно ли это делать",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "07.11.2022",
            "link": "kak-kleit-plitku-na-gipsokarton-i-mozhno-li-eto-delat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-kleit'-plitu-na-gipsokarton-i-mozhno-li-eto-delat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-kleit'-plitu-na-gipsokarton-i-mozhno-li-eto-delat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 13290,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca3538aced40254f22ae"
        },
        {
            "title": "Как выбрать стабилизатор напряжения для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "07.11.2022",
            "link": "kak-vybrat-stabilizator-napryazheniya-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-stabilizator-napryazheniya-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat'-stabilizator-napryazheniya-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 13680,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3538aced40254f22af"
        },
        {
            "title": "Как повесить и закрепить римские шторы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "09.11.2022",
            "link": "kak-povesit-i-zakrepit-rimskie-shtory",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit-i-zakrepit-rimskie-shtory/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-povesit-i-zakrepit-rimskie-shtory/000-photo.jpg/000-photo.jpg 2x",
            "views": 5388,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca3638aced40254f22b0"
        },
        {
            "title": "Как правильно красить валиком стены и потолок",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "09.11.2022",
            "link": "kak-pravilno-krasit-valikom-steny-i-potolok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-krasit-valikom-steny-i-potolok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-krasit-valikom-steny-i-potolok/000-photo.jpg/000-photo.jpg 2x",
            "views": 10007,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648aca3638aced40254f22b1"
        },
        {
            "title": "Что такое стеклохолст и как его правильно клеить на стены под покраску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.11.2022",
            "link": "chto-takoe-stekloholst-i-kak-ego-pravilno-kleit-na-steny-pod-pokrasku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-stekloholst-i-kak-ego-pravil'no-kleit'-na-steni-pod-pokrasku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-stekloholst-i-kak-ego-pravil'no-kleit'-na-steni-pod-pokrasku/000-photo.jpg/000-photo.jpg 2x",
            "views": 8807,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3638aced40254f22b2"
        },
        {
            "title": "Что такое виброплита, как она работает и как её выбрать, чтобы служила долго",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "16.11.2022",
            "link": "chto-takoe-vibroplita-kak-ona-rabotaet-i-kak-ee-vybrat-chtoby-sluzhila-dolgo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-vibroplita,-kak-ona-rabotaet-i-kak-eyo-vybrat',-chtoby-sluzhila-dolgo/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-vibroplita,-kak-ona-rabotaet-i-kak-eyo-vybrat',-chtoby-sluzhila-dolgo/000-hero.jpg/000-hero.jpg 2x",
            "views": 6326,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca3638aced40254f22b3"
        },
        {
            "title": "Как подключить светодиодную лампу вместо люминесцентной: схема",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "16.11.2022",
            "link": "kak-podklyuchit-svetodiodnuyu-lampu-vmesto-lyuminescentnoy-shema",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-podklyuchit-svetodiodnuyu-lampu-vmesto-lyuminescentnoj-skhema/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-podklyuchit-svetodiodnuyu-lampu-vmesto-lyuminescentnoj-skhema/000-photo.jpg/000-photo.jpg 2x",
            "views": 5236,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca3638aced40254f22b4"
        },
        {
            "title": "Что за материал спанбонд и чем он отличается от геотекстиля",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "21.11.2022",
            "link": "chto-za-material-spanbond-i-chem-on-otlichaetsya-ot-geotekstilya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-za-material-spanbond-i-chem-on-otlichaetsya-ot-geotekstilya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-za-material-spanbond-i-chem-on-otlichaetsya-ot-geotekstilya/000-photo.jpg/000-photo.jpg 2x",
            "views": 13249,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3738aced40254f22b5"
        },
        {
            "title": "Как отрегулировать металлическую входную дверь",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "21.11.2022",
            "link": "kak-otregulirovat-metallicheskuyu-vhodnuyu-dver",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat-metallicheskuyu-vhodnuyu-dver/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat-metallicheskuyu-vhodnuyu-dver/000-photo.jpg/000-photo.jpg 2x",
            "views": 11014,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3738aced40254f22b6"
        },
        {
            "title": "Вздулся ламинат: что делать и как исправить",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "24.11.2022",
            "link": "vzdulsya-laminat-chto-delat-i-kak-ispravit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vzdulsya-laminat-chto-delat'-i-mozhno-li-ispravit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vzdulsya-laminat-chto-delat'-i-mozhno-li-ispravit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 8698,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3738aced40254f22b7"
        },
        {
            "title": "Как поменять замки на входной двери",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "22.11.2022",
            "link": "kak-pomenyat-zamki-na-vhodnoj-dveri",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-pomenyat-zamki-na-vhodnoj-dveri/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-pomenyat-zamki-na-vhodnoj-dveri/000-photo.jpg/000-photo.jpg 2x",
            "views": 9127,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3738aced40254f22b8"
        },
        {
            "title": "Что такое заклёпочник и как им пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "25.11.2022",
            "link": "chto-takoe-zaklepochnik-i-kak-im-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-zaklyopochnik-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-zaklyopochnik-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 8104,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3738aced40254f22b9"
        },
        {
            "title": "Стиль прованс в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "29.11.2022",
            "link": "stil-provans-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil'-provans-v-inter'ere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil'-provans-v-inter'ere/000-photo.jpg/000-photo.jpg 2x",
            "views": 12694,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca3838aced40254f22ba"
        },
        {
            "title": "Как правильно заделать щель между ванной и стеной",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "29.11.2022",
            "link": "kak-pravilno-zadelat-shchel-mezhdu-vannoy-i-stenoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-zadelat-shchel-mezhdu-vannoj-i-stenoj/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-zadelat-shchel-mezhdu-vannoj-i-stenoj/000-photo.jpg/000-photo.jpg 2x",
            "views": 10812,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3838aced40254f22bb"
        },
        {
            "title": "Что такое сидераты и как их правильно сеять",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "29.11.2022",
            "link": "chto-takoe-sideraty-i-kak-ih-pravilno-seyat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-sideraty-i-kak-ih-pravilno-seyat/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-sideraty-i-kak-ih-pravilno-seyat/000-hero.jpg/000-hero.jpg 2x",
            "views": 14907,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3838aced40254f22bc"
        },
        {
            "title": "Что делать, если унитаз подтекает, и как починить другие поломки бачка",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "23.11.2022",
            "link": "chto-delat-esli-unitaz-podtekaet-i-kak-pochinit-drugie-polomki-bachka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-delat-esli-unitaz-podtekaet-i-kak-pochinit-drugie-polomki-bachka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-delat-esli-unitaz-podtekaet-i-kak-pochinit-drugie-polomki-bachka/000-photo.jpg/000-photo.jpg 2x",
            "views": 16598,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3838aced40254f22bd"
        },
        {
            "title": "Как установить доводчик на дверь своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "24.11.2022",
            "link": "kak-ustanovit-dovodchik-na-dver-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dovodchik-na-dver-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dovodchik-na-dver-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 13216,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3938aced40254f22be"
        },
        {
            "title": "Как и какую выбрать кофемолку: рейтинг кофемолок для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "24.11.2022",
            "link": "kak-i-kakuyu-vybrat-kofemolku-reyting-kofemolok-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-i-kakuyu-vybrat-kofemolku-rejting-kofemolok-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-i-kakuyu-vybrat-kofemolku-rejting-kofemolok-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 15598,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3938aced40254f22bf"
        },
        {
            "title": "Рейтинг встраиваемых вытяжек для кухни",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "24.11.2022",
            "link": "reyting-vstraivaemyh-vytyazhek-dlya-kuhni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-vstraivaemyh-vytyazhek-dlya-kuhni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-vstraivaemyh-vytyazhek-dlya-kuhni/000-photo.jpg/000-photo.jpg 2x",
            "views": 13159,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca3938aced40254f22c0"
        },
        {
            "title": "Что такое латунь, ржавеет ли она и лучше ли нержавейки в смесителях",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "28.11.2022",
            "link": "chto-takoe-latun-rzhaveet-li-ona-i-luchshe-li-nerzhaveyki-v-smesitelyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-latun'-rzhaveet-li-ona-i-luchshe-li-ona-nerzhaveiki-v-smesitelyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-latun'-rzhaveet-li-ona-i-luchshe-li-ona-nerzhaveiki-v-smesitelyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 11217,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3938aced40254f22c1"
        },
        {
            "title": "Чем покрасить пенопласт",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "28.11.2022",
            "link": "chem-pokrasit-penoplast",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit-penoplast/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit-penoplast/000-photo.jpg/000-photo.jpg 2x",
            "views": 7202,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3938aced40254f22c2"
        },
        {
            "title": "Что такое штакетник и каких он бывает видов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "23.11.2022",
            "link": "chto-takoe-shtaketnik-i-kakih-on-byvaet-vidov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-shtaketnik-i-kakih-on-byvaet-vidov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-shtaketnik-i-kakih-on-byvaet-vidov/000-photo.jpg/000-photo.jpg 2x",
            "views": 10888,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3a38aced40254f22c3"
        },
        {
            "title": "Что такое гидрофобизатор? Зачем и как его применяют",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "23.11.2022",
            "link": "chto-takoe-gidrofobizator-zachem-i-kak-ego-primenyayut",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-gidrofobizator-zachem-i-kak-ego-primenyayut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-gidrofobizator-zachem-i-kak-ego-primenyayut/000-photo.jpg/000-photo.jpg 2x",
            "views": 5793,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3a38aced40254f22c4"
        },
        {
            "title": "Как установить инсталляцию для унитаза",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "22.11.2022",
            "link": "kak-ustanovit-installyaciyu-dlya-unitaza",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit-installyaciyu-dlya-unitaza/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit-installyaciyu-dlya-unitaza/000-hero.jpg/000-hero.jpg 2x",
            "views": 5156,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3a38aced40254f22c5"
        },
        {
            "title": "Рейтинг холодильников по цене и качеству",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "28.11.2022",
            "link": "reyting-holodilnikov-po-cene-i-kachestvu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-hplodil'nikov-po-cene-i-kachestvu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-hplodil'nikov-po-cene-i-kachestvu/000-photo.jpg/000-photo.jpg 2x",
            "views": 9425,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3a38aced40254f22c6"
        },
        {
            "title": "Рейтинг посудомоечных машин",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "28.11.2022",
            "link": "reyting-posudomoechnyh-mashin",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-posudomoechnyh-mashin/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-posudomoechnyh-mashin/000-photo.jpg/000-photo.jpg 2x",
            "views": 13473,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3a38aced40254f22c7"
        },
        {
            "title": "Что такое шпатель, какие они бывают и как их использовать",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "24.11.2022",
            "link": "chto-takoe-shpatel-kakie-oni-byvayut-i-kak-ih-ispolzovat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-shpatel-kakie-oni-byvayut-i-kak-ih-ispolzovat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-shpatel-kakie-oni-byvayut-i-kak-ih-ispolzovat/000-photo.jpg/000-photo.jpg 2x",
            "views": 4911,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca3b38aced40254f22c8"
        },
        {
            "title": "Рейтинг сковородок с антипригарным покрытием",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "28.11.2022",
            "link": "reyting-skovorodok-s-antiprigarnym-pokrytiem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-skovorodok-s-antiprigarnym-pokrytiem/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-skovorodok-s-antiprigarnym-pokrytiem/000-photo.jpg/000-photo.jpg 2x",
            "views": 10435,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3b38aced40254f22c9"
        },
        {
            "title": "Рейтинг встраиваемых духовых шкафов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "28.11.2022",
            "link": "reyting-vstraivaemyh-duhovyh-shkafov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-vstraivaemih-duhovih-shkafov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reiting-vstraivaemih-duhovih-shkafov/000-photo.jpg/000-photo.jpg 2x",
            "views": 12841,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca3b38aced40254f22ca"
        },
        {
            "title": "Рейтинг кофемашин для дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "25.11.2022",
            "link": "reyting-kofemashin-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kofemashin-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-kofemashin-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 10098,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3b38aced40254f22cb"
        },
        {
            "title": "Что такое кран Маевского, как он работает и для чего нужен",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "22.11.2022",
            "link": "chto-takoe-kran-maevskogo-kak-on-rabotaet-i-dlya-chego-nuzhen",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-kran-maevskogo-kak-on-rabotaet-i-dlya-chego-nuzhen/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-kran-maevskogo-kak-on-rabotaet-i-dlya-chego-nuzhen/000-photo.jpg/000-photo.jpg 2x",
            "views": 8855,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca3b38aced40254f22cc"
        },
        {
            "title": "Рейтинг кастрюль из стали",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "22.11.2022",
            "link": "reyting-kastryul-iz-stali",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reitint-kastrul'-iz-stali/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/reitint-kastrul'-iz-stali/000-photo.jpg/000-photo.jpg 2x",
            "views": 8358,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca3c38aced40254f22cd"
        },
        {
            "title": "Как сделать парник для огурцов своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "23.11.2022",
            "link": "kak-sdelat-parnik-dlya-ogurcov-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami.jpg/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami.jpg/kak-sdelat'-parnik-dlya-ogurcov-svoimi-rukami.jpg 2x",
            "views": 8643,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca3c38aced40254f22ce"
        },
        {
            "title": "Чем обработать землю в теплице от вредителей",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "22.11.2022",
            "link": "chem-obrabotat-zemlyu-v-teplice-ot-vrediteley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chem-obrabotat-zemlyu-v-teplice-ot-vreditelej/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chem-obrabotat-zemlyu-v-teplice-ot-vreditelej/000-photo.jpg/000-photo.jpg 2x",
            "views": 12118,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3c38aced40254f22cf"
        },
        {
            "title": "Что такое биогумус, для чего он нужен и как его применять",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "22.11.2022",
            "link": "chto-takoe-biogumus-dlya-chego-on-nuzhen-i-kak-ego-primenyat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-biogumus-dlya-chego-on-nuzhen-i-kak-ego-primenyat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chto-takoe-biogumus-dlya-chego-on-nuzhen-i-kak-ego-primenyat/000-photo.jpg/000-photo.jpg 2x",
            "views": 16062,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3c38aced40254f22d0"
        },
        {
            "title": "Что такое слэб из дерева и где он используется",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "24.11.2022",
            "link": "chto-takoe-sleb-iz-dereva-i-gde-on-ispolzuetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-sleb-iz-dereva-i-gde-on-ispol'zuetsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-sleb-iz-dereva-i-gde-on-ispol'zuetsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 12115,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3c38aced40254f22d1"
        },
        {
            "title": "Как выбрать строительный пылесос и чем он отличается от обычного",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "22.11.2022",
            "link": "kak-vybrat-stroitelnyy-pylesos-i-chem-on-otlichaetsya-ot-obychnogo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-stroitel'nii-pilesos-i-chem-on-otlichaet'sya-ot-obichnogo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-stroitel'nii-pilesos-i-chem-on-otlichaet'sya-ot-obichnogo/000-photo.jpg/000-photo.jpg 2x",
            "views": 14301,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3d38aced40254f22d2"
        },
        {
            "title": "Как и куда спрятать провода от телевизора, кондиционера, компьютера",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "23.11.2022",
            "link": "kak-i-kuda-spryatat-provoda-ot-televizora-kondicionera-kompyutera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-i-kuda-spryatat'-provoda-ot-televizora-kondicuonera-komputera/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-i-kuda-spryatat'-provoda-ot-televizora-kondicuonera-komputera/000-photo.jpg/000-photo.jpg 2x",
            "views": 10526,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3d38aced40254f22d3"
        },
        {
            "title": "Чем обезжирить металл перед покраской",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "23.11.2022",
            "link": "chem-obezzhirit-metall-pered-pokraskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-obezzhirit-metall-pered-pokraskoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-obezzhirit-metall-pered-pokraskoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 13608,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca3d38aced40254f22d4"
        },
        {
            "title": "Что такое серпянка и перфорированная бумажная лента, где их применяют?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "23.11.2022",
            "link": "chto-takoe-serpyanka-i-perforirovannaya-bumazhnaya-lenta-gde-ih-primenyayut",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-serpyanka-i-perfirirovannaya-bumazhnaya-lenta-gde-ih-primenyaut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-serpyanka-i-perfirirovannaya-bumazhnaya-lenta-gde-ih-primenyaut/000-photo.jpg/000-photo.jpg 2x",
            "views": 6993,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3d38aced40254f22d5"
        },
        {
            "title": "Типичные ошибки в ремонте: как все сделать самому и избежать их",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "29.05.2023",
            "link": "tipichnye-oshibki-v-remonte-kak-vse-sdelat-samomu-i-izbezhat-ikh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tipichnye-oshibki-v-remonte-kak-vse-sdelat-samomu-i-izbezhat-ikh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tipichnye-oshibki-v-remonte-kak-vse-sdelat-samomu-i-izbezhat-ikh/000-photo.jpg/000-photo.jpg 2x",
            "views": 12745,
            "total_comment": 1,
            "is_video": false,
            "likes": 13,
            "id": "648aca3d38aced40254f22d6"
        },
        {
            "title": "Как утеплить кровлю",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "28.09.2020",
            "link": "kak-uteplit-krovlyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-krovlyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-krovlyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 10296,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca3e38aced40254f22d7"
        },
        {
            "title": "Как выбрать металлический водосток",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-metallicheskiy-vodostok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-metallicheskiy-vodostok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-metallicheskiy-vodostok/000-photo.jpg/000-photo.jpg 2x",
            "views": 7002,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca3e38aced40254f22d8"
        },
        {
            "title": "Как выбрать монтажную сухую смесь",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-montazhnuyu-sukhuyu-smes",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-montazhnuyu-sukhuyu-smes/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-montazhnuyu-sukhuyu-smes/000-photo.jpg/000-photo.jpg 2x",
            "views": 6021,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca3e38aced40254f22d9"
        },
        {
            "title": "Как выбрать облицовочные материалы для дома из СИП панелей",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-oblitsovochnye-materialy-dlya-doma-iz-sip-paneley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-oblitsovochnye-materialy-dlya-doma-iz-sip-paneley/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-oblitsovochnye-materialy-dlya-doma-iz-sip-paneley/000-photo.jpg/000-photo.jpg 2x",
            "views": 15391,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca3e38aced40254f22da"
        },
        {
            "title": "Как выбрать водосточную систему и комплектующие",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-vodostochnuyu-sistemu-i-komplektuyushchie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-vodostochnuyu-sistemu-i-komplektuyushchie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-vodostochnuyu-sistemu-i-komplektuyushchie/000-photo.jpg/000-photo.jpg 2x",
            "views": 13392,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca3e38aced40254f22db"
        },
        {
            "title": "Технология изготовления полусухой стяжки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "tekhnologiya-izgotovleniya-polusukhoy-styazhki-po-penopolistirolu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/технология-изготовления-полусухой-стяжки/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/технология-изготовления-полусухой-стяжки/000-photo.jpg/000-photo.jpg 2x",
            "views": 5929,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca3f38aced40254f22dc"
        },
        {
            "title": "Как выбрать бетономешалку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-betonomeshalku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-betonomeshalku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-betonomeshalku/000-photo.jpg/000-photo.jpg 2x",
            "views": 10887,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca3f38aced40254f22dd"
        },
        {
            "title": "Технология оклейки потолка потолочными плитами",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "tekhnologiya-okleyki-potolka-potolochnymi-plitami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tekhnologiya-okleyki-potolka-potolochnymi-plitami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tekhnologiya-okleyki-potolka-potolochnymi-plitami/000-photo.jpg/000-photo.jpg 2x",
            "views": 7768,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca3f38aced40254f22df"
        },
        {
            "title": "Как выбрать мягкую черепицу",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-myagkuyu-cherepitsu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-myagkuyu-cherepitsu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-myagkuyu-cherepitsu/000-photo.jpg/000-photo.jpg 2x",
            "views": 16056,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca3f38aced40254f22e0"
        },
        {
            "title": "Три решения для шумоизоляции пола",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "tri-resheniya-dlya-shumoizolyacii-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tri-resheniya-dlya-shumoizolyacii-pola/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tri-resheniya-dlya-shumoizolyacii-pola/Photo.jpg/Photo.jpg 2x",
            "views": 15050,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4038aced40254f22e1"
        },
        {
            "title": "Делаем свайно-винтовой фундамент для частного дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "delaem-svayno-vintovoy-fundament-dlya-chastnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/delaem-svayno-vintovoy-fundament-dlya-chastnogo-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/delaem-svayno-vintovoy-fundament-dlya-chastnogo-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 12755,
            "total_comment": 6,
            "is_video": false,
            "likes": 5,
            "id": "648aca4038aced40254f22e2"
        },
        {
            "title": "Три решения для шумоизоляции потолка",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "tri-resheniya-dlya-shumoizolyacii-potolka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tri-resheniya-dlya-shumoizolyacii-potolka/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/tri-resheniya-dlya-shumoizolyacii-potolka/Photo.jpg/Photo.jpg 2x",
            "views": 9490,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca4038aced40254f22e3"
        },
        {
            "title": "Выбираем тип фундамента для дачи, гаража, хозяйственной постройки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "vybiraem-tip-fundamenta-dlya-dachi-garazha-hozyaystvennoy-postroyki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/vybiraem-tip-fundamenta-dlya-dachi-garazha-hozyaystvennoy-postroyki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/vybiraem-tip-fundamenta-dlya-dachi-garazha-hozyaystvennoy-postroyki/000-photo.jpg/000-photo.jpg 2x",
            "views": 7656,
            "total_comment": 1,
            "is_video": false,
            "likes": 12,
            "id": "648aca4038aced40254f22e4"
        },
        {
            "title": "Как сделать шумоизоляцию в квартире",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-shumoizolyaciyu-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-shumoizolyaciyu-v-kvartire/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-shumoizolyaciyu-v-kvartire/000-photo.jpg/000-photo.jpg 2x",
            "views": 7534,
            "total_comment": 2,
            "is_video": false,
            "likes": 10,
            "id": "648aca4038aced40254f22e5"
        },
        {
            "title": "Как сделать облицовку камина",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-oblitsovku-kamina",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-oblitsovku-kamina/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-oblitsovku-kamina/000-photo.jpg/000-photo.jpg 2x",
            "views": 11067,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca4138aced40254f22e6"
        },
        {
            "title": "Как сделать подвесной потолок из гипсокартона",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-podvesnoy-potolok-iz-gipsokartona",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-podvesnoy-potolok-iz-gipsokartona/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-podvesnoy-potolok-iz-gipsokartona/000-photo.jpg/000-photo.jpg 2x",
            "views": 8924,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca4138aced40254f22e7"
        },
        {
            "title": "Как сделать облицовку печи",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-oblitsovku-pechi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-oblitsovku-pechi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-oblitsovku-pechi/000-photo.jpg/000-photo.jpg 2x",
            "views": 10852,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4138aced40254f22e8"
        },
        {
            "title": "Как сделать цветные растворы для кладки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-tsvetnye-rastvory-dlya-zapolneniya-kladki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-tsvetnye-rastvory-dlya-zapolneniya-kladki/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-tsvetnye-rastvory-dlya-zapolneniya-kladki/000-hero.jpg/000-hero.jpg 2x",
            "views": 14226,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4138aced40254f22e9"
        },
        {
            "title": "Дачный дом за 3 недели",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "dachnyy-dom-za-3-nedeli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/dachnyy-dom-za-3-nedeli/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/dachnyy-dom-za-3-nedeli/000-photo.jpg/000-photo.jpg 2x",
            "views": 13764,
            "total_comment": 0,
            "is_video": true,
            "likes": 15,
            "id": "648aca4138aced40254f22ea"
        },
        {
            "title": "Декор из шпаклёвки",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "29.11.2019",
            "link": "dekor-iz-shpaklevki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/dekor-iz-shpaklevki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/dekor-iz-shpaklevki/000-photo.jpg/000-photo.jpg 2x",
            "views": 6837,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4238aced40254f22ec"
        },
        {
            "title": "Как использовать белый клей для декоративного кирпича",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-ispolzovat-belyy-kley-i-zatirku-dlya-dekorativnogo-kirpicha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ispolzovat-belyy-kley-i-zatirku-dlya-dekorativnogo-kirpicha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ispolzovat-belyy-kley-i-zatirku-dlya-dekorativnogo-kirpicha/000-photo.jpg/000-photo.jpg 2x",
            "views": 4162,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4238aced40254f22ed"
        },
        {
            "title": "Изготовление бетонной плиты",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "izgotovlenie-betonnoy-plity",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/izgotovlenie-betonnoy-plity/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/izgotovlenie-betonnoy-plity/000-photo.jpg/000-photo.jpg 2x",
            "views": 9672,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4238aced40254f22ee"
        },
        {
            "title": "Как выполнить отделку облицовочной плиткой",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vypolnit-otdelku-oblitsovochnoy-plitkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vypolnit-otdelku-oblitsovochnoy-plitkoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vypolnit-otdelku-oblitsovochnoy-plitkoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 15173,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4238aced40254f22ef"
        },
        {
            "title": "Как облицевать дом кирпичом",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-oblitsevat-dom-kirpichom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-oblitsevat-dom-kirpichom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-oblitsevat-dom-kirpichom/000-photo.jpg/000-photo.jpg 2x",
            "views": 11308,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca4238aced40254f22f0"
        },
        {
            "title": "Как согнуть гипсокартон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sognut-gipsokarton",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sognut-gipsokarton/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sognut-gipsokarton/000-photo.jpg/000-photo.jpg 2x",
            "views": 10045,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4338aced40254f22f1"
        },
        {
            "title": "Как выбрать сухую смесь для теплого пола",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-sukhuyu-smes-dlya-teplogo-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-sukhuyu-smes-dlya-teplogo-pola/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vybrat-sukhuyu-smes-dlya-teplogo-pola/000-photo.jpg/000-photo.jpg 2x",
            "views": 15993,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4338aced40254f22f2"
        },
        {
            "title": "Применение мешков для строительного мусора",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "primenenie-meshkov-dlya-stroitelnogo-musora-vo-vremya-remonta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/primenenie-meshkov-dlya-stroitelnogo-musora-vo-vremya-remonta/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/primenenie-meshkov-dlya-stroitelnogo-musora-vo-vremya-remonta/000-photo.jpg/000-photo.jpg 2x",
            "views": 10847,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca4338aced40254f22f3"
        },
        {
            "title": "Как выровнять углы стен",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-vyrovnyat-ugly-sten",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vyrovnyat-ugly-sten/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-vyrovnyat-ugly-sten/000-photo.jpg/000-photo.jpg 2x",
            "views": 5757,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca4338aced40254f22f4"
        },
        {
            "title": "Как сделать крышу из сотового поликарбоната",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-kryshu-iz-sotovogo-polikarbonata",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-kryshu-iz-sotovogo-polikarbonata/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-kryshu-iz-sotovogo-polikarbonata/000-photo.jpg/000-photo.jpg 2x",
            "views": 14333,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4338aced40254f22f5"
        },
        {
            "title": "Как укладывать рубероид",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-ukladyvat-ruberoid",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ukladyvat-ruberoid/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ukladyvat-ruberoid/000-photo.jpg/000-photo.jpg 2x",
            "views": 5231,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4338aced40254f22f6"
        },
        {
            "title": "Как собрать дымоход",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sobrat-dymokhod",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sobrat-dymokhod/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sobrat-dymokhod/000-photo.jpg/000-photo.jpg 2x",
            "views": 15257,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca4438aced40254f22f7"
        },
        {
            "title": "Как установить водосток из пвх",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-vodostok-iz-pvkh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ustanovit-vodostok-iz-pvkh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ustanovit-vodostok-iz-pvkh/000-photo.jpg/000-photo.jpg 2x",
            "views": 5334,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4438aced40254f22f8"
        },
        {
            "title": "Как сделать кровлю из битумных волнистых листов",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-krovlyu-iz-bitumnyh-volnistyh-listov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-krovlyu-iz-bitumnyh-volnistyh-listov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-krovlyu-iz-bitumnyh-volnistyh-listov/000-photo.jpg/000-photo.jpg 2x",
            "views": 8377,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca4438aced40254f22f9"
        },
        {
            "title": "Жизнь в квартире во время ремонта: как быть?",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "zhizn-v-kvartire-vo-vremya-remonta-kak-byt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zhizn-v-kvartire-vo-vremya-remonta-kak-byt/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zhizn-v-kvartire-vo-vremya-remonta-kak-byt/000-photo.jpg/000-photo.jpg 2x",
            "views": 5693,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca4438aced40254f22fa"
        },
        {
            "title": "Затирка стен после шпаклевки",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "zatirka-sten-posle-shpaklevki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zatirka-sten-posle-shpaklevki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zatirka-sten-posle-shpaklevki/000-photo.jpg/000-photo.jpg 2x",
            "views": 4175,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca4438aced40254f22fb"
        },
        {
            "title": "Семь вопросов, которые нужно задать рабочим перед началом ремонта",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "sem-voprosov-kotorye-nuzhno-zadat-rabochim-pered-nachalom-remonta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/sem-voprosov-kotorye-nuzhno-zadat-rabochim-pered-nachalom-remonta/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/sem-voprosov-kotorye-nuzhno-zadat-rabochim-pered-nachalom-remonta/000-photo.jpg/000-photo.jpg 2x",
            "views": 5990,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4538aced40254f22fc"
        },
        {
            "title": "Пять ошибок, которые усложняют ремонт в новостройке",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sokhranit-khoroshie-otnosheniya-s-sosedyami-vo-vremya-remonta1",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pyat-oshibok-kotorye-uslozhnyayut-remont-v-novostroyke/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pyat-oshibok-kotorye-uslozhnyayut-remont-v-novostroyke/000-photo.jpg/000-photo.jpg 2x",
            "views": 7433,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648aca4538aced40254f22fd"
        },
        {
            "title": "Переезд за город: как превратить дачу в полноценное жилье",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "15.02.2020",
            "link": "pereezd-za-gorod-kak-prevratit-dachu-v-polnotsennoe-zhile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pereezd-za-gorod-kak-prevratit-dachu-v-polnotsennoe-zhile/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pereezd-za-gorod-kak-prevratit-dachu-v-polnotsennoe-zhile/000-hero.jpg/000-hero.jpg 2x",
            "views": 10327,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4538aced40254f22fe"
        },
        {
            "title": "Перепланировка: основные правила и полезные советы",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "19.10.2021",
            "link": "pereplanirovka-osnovnye-pravila-i-poleznye-sovety",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pereplanirovka-osnovnye-pravila-i-poleznye-sovety/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/pereplanirovka-osnovnye-pravila-i-poleznye-sovety/000-photo.jpg/000-photo.jpg 2x",
            "views": 9486,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4538aced40254f22ff"
        },
        {
            "title": "Как обшить стены гипсокартоном",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-obshit-steny-gipsokartonom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obshit-steny-gipsokartonom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obshit-steny-gipsokartonom/000-photo.jpg/000-photo.jpg 2x",
            "views": 14099,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648aca4638aced40254f2300"
        },
        {
            "title": "Как облицевать цоколь камнем",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "24.12.2019",
            "link": "kak-oblitsevat-tsokol-kamnem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-oblitsevat-tsokol-kamnem/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-oblitsevat-tsokol-kamnem/000-photo.jpg/000-photo.jpg 2x",
            "views": 9200,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4638aced40254f2301"
        },
        {
            "title": "Монтаж фасадной плитки HAUBERK",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "19.10.2021",
            "link": "montazh-fasadnoy-plitki-hauberk",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/montazh-fasadnoy-plitki-hauberk/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/montazh-fasadnoy-plitki-hauberk/000-photo.jpg/000-photo.jpg 2x",
            "views": 7444,
            "total_comment": 0,
            "is_video": true,
            "likes": 13,
            "id": "648aca4638aced40254f2302"
        },
        {
            "title": "Как обшить дом сайдингом?",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-obshit-dom-saydingom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obshit-dom-saydingom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obshit-dom-saydingom/000-photo.jpg/000-photo.jpg 2x",
            "views": 9584,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca4638aced40254f2303"
        },
        {
            "title": "Устанавливаем плитный фундамент для частного дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "ustanavlivaem-plitnyy-fundament-dlya-chastnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/ustanavlivaem-plitnyy-fundament-dlya-chastnogo-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/ustanavlivaem-plitnyy-fundament-dlya-chastnogo-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 13948,
            "total_comment": 1,
            "is_video": false,
            "likes": 9,
            "id": "648aca4638aced40254f2304"
        },
        {
            "title": "Как правильно приготовить раствор шпаклевки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-pravilno-prigotovit-rastvor-shpaklevki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-pravilno-prigotovit-rastvor-shpaklevki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-pravilno-prigotovit-rastvor-shpaklevki/000-photo.jpg/000-photo.jpg 2x",
            "views": 11099,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca4738aced40254f2305"
        },
        {
            "title": "Как сделать кровлю из битумной черепицы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-krovlyu-iz-bitumnoy-cherepitsy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-krovlyu-iz-bitumnoy-cherepitsy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sdelat-krovlyu-iz-bitumnoy-cherepitsy/000-photo.jpg/000-photo.jpg 2x",
            "views": 6250,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4738aced40254f2306"
        },
        {
            "title": "Как покрыть кровлю металлочерепицей",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-pokryt-krovlyu-metallocherepitsey",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-pokryt-krovlyu-metallocherepitsey/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-pokryt-krovlyu-metallocherepitsey/000-hero.jpg/000-hero.jpg 2x",
            "views": 7243,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca4738aced40254f2307"
        },
        {
            "title": "Как приготовить строительный раствор или бетон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-prigotovit-stroitelnyy-rastvor-ili-beton",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-prigotovit-stroitelnyy-rastvor-ili-beton/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-prigotovit-stroitelnyy-rastvor-ili-beton/000-photo.jpg/000-photo.jpg 2x",
            "views": 7372,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4738aced40254f2308"
        },
        {
            "title": "Виды шпаклевок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "19.10.2021",
            "link": "vidy-shpaklevok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vidy-shpaklevok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vidy-shpaklevok/000-photo.jpg/000-photo.jpg 2x",
            "views": 12691,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca4738aced40254f2309"
        },
        {
            "title": "Свайный фундамент",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "svaynyy-fundament",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/svaynyy-fundament/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/svaynyy-fundament/000-photo.jpg/000-photo.jpg 2x",
            "views": 11879,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4838aced40254f230a"
        },
        {
            "title": "Строительство гипсокартонных перегородок",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "02.06.2023",
            "link": "stroitelstvo-gipsokartonnykh-peregorodok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/stroitelstvo-gipsokartonnykh-peregorodok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/stroitelstvo-gipsokartonnykh-peregorodok/000-photo.jpg/000-photo.jpg 2x",
            "views": 9790,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca4838aced40254f230b"
        },
        {
            "title": "Как утеплить мансарду",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-uteplit-mansardu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-mansardu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-mansardu/000-photo.jpg/000-photo.jpg 2x",
            "views": 16480,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca4838aced40254f230c"
        },
        {
            "title": "Виды грунтовок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "vidy-gruntovok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vidy-gruntovok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vidy-gruntovok/000-photo.jpg/000-photo.jpg 2x",
            "views": 6483,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4838aced40254f230d"
        },
        {
            "title": "Выравнивание стен",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "19.10.2021",
            "link": "vyravnivanie-sten",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vyravnivanie-sten/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/vyravnivanie-sten/000-photo.jpg/000-photo.jpg 2x",
            "views": 15328,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca4838aced40254f230e"
        },
        {
            "title": "Затирка швов клинкерной плитки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "zatirka-shvov-klinkernoy-plitki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zatirka-shvov-klinkernoy-plitki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/zatirka-shvov-klinkernoy-plitki/000-photo.jpg/000-photo.jpg 2x",
            "views": 6779,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4938aced40254f230f"
        },
        {
            "title": "Как сохранить хорошие отношения с соседями во время ремонта",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-sokhranit-khoroshie-otnosheniya-s-sosedyami-vo-vremya-remonta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sokhranit-khoroshie-otnosheniya-s-sosedyami-vo-vremya-remonta/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-sokhranit-khoroshie-otnosheniya-s-sosedyami-vo-vremya-remonta/000-hero.jpg/000-hero.jpg 2x",
            "views": 10892,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca4938aced40254f2310"
        },
        {
            "title": "Как установить металлическую водосточную систему",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-metallicheskuyu-vodostochnuyu-sistemu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ustanovit-metallicheskuyu-vodostochnuyu-sistemu/photo.jpg/photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-ustanovit-metallicheskuyu-vodostochnuyu-sistemu/photo.jpg/photo.jpg 2x",
            "views": 5675,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4938aced40254f2311"
        },
        {
            "title": "Четыре решения для шумоизоляции стен",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "chetyre-resheniya-dlya-shumoizolyacii-sten",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chetyre-resheniya-dlya-shumoizolyacii-sten/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chetyre-resheniya-dlya-shumoizolyacii-sten/Photo.jpg/Photo.jpg 2x",
            "views": 14316,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca4938aced40254f2312"
        },
        {
            "title": "Делаем ленточный фундамент для частного дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "delaem-lentochnyy-fundament-dlya-chastnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/delaem-lentochnyy-fundament-dlya-chastnogo-doma/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/delaem-lentochnyy-fundament-dlya-chastnogo-doma/Photo.jpg/Photo.jpg 2x",
            "views": 9033,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca4938aced40254f2313"
        },
        {
            "title": "Строим дом своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "19.10.2021",
            "link": "stroim-dom-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/stroim-dom-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/stroim-dom-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 16516,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca4a38aced40254f2314"
        },
        {
            "title": "Делаем столбчатый фундамент из блоков",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "delaem-stolbchatyy-fundament-iz-blokov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/delaem-stolbchatyy-fundament-iz-blokov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/stroymaterialy/delaem-stolbchatyy-fundament-iz-blokov/000-photo.jpg/000-photo.jpg 2x",
            "views": 14718,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4a38aced40254f2315"
        },
        {
            "title": "Электропроводка в деревянном доме",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "elektroprovodka-v-derevyannom-dome",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/elektroprovodka-v-derevyannom-dome/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/elektroprovodka-v-derevyannom-dome/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7351,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca4a38aced40254f2316"
        },
        {
            "title": "Назначение суппорта для розетки",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "naznachenie-supporta-dlya-rozetki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/naznachenie-supporta-dlya-rozetki/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/naznachenie-supporta-dlya-rozetki/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4854,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca4a38aced40254f2317"
        },
        {
            "title": "Как выбрать электрический тёплый пол",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-elektricheskiy-teplyy-pol",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-elektricheskiy-teplyy-pol/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-elektricheskiy-teplyy-pol/000-photo.jpg/000-photo.jpg 2x",
            "views": 15566,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca4a38aced40254f2318"
        },
        {
            "title": "Системы антиобледенения: как защитить от наледи крыльцо, крышу и трубы",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "02.06.2023",
            "link": "sistemy-antiobledeneniya-kak-zashchitit-ot-naledi-krylco-kryshu-i-truby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/sistemy-antiobledeneniya-kak-zashchitit-ot-naledi-krylco-kryshu-i-truby/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/sistemy-antiobledeneniya-kak-zashchitit-ot-naledi-krylco-kryshu-i-truby/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 8118,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4b38aced40254f2319"
        },
        {
            "title": "Как ухаживать за плиткой ПВХ",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-uhazhivat-za-plitkoy-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukhazhivat-za-plitkoy-pvkh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukhazhivat-za-plitkoy-pvkh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4530,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca4b38aced40254f231a"
        },
        {
            "title": "Советы по комбинированию напольных покрытий",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "sovety-po-kombinirovaniyu-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-po-kombinirovaniyu-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-po-kombinirovaniyu-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14938,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4b38aced40254f231b"
        },
        {
            "title": "Ламинат с фаской: преимущества, способы укладки, распространённые мифы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "02.06.2023",
            "link": "laminanat-s-faskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminanat-s-faskoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminanat-s-faskoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 8054,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca4b38aced40254f231c"
        },
        {
            "title": "Виды паркета, как выбрать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-parketa-kak-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-parketa-kak-vybrat/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-parketa-kak-vybrat/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10752,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca4b38aced40254f231d"
        },
        {
            "title": "Уход за паркетом",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "uhod-za-parketom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukhod-za-parketom/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukhod-za-parketom/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16532,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4c38aced40254f231e"
        },
        {
            "title": "Уход за коврами",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "uhod-za-kovrami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukhod-za-kovrami/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukhod-za-kovrami/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13682,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4c38aced40254f231f"
        },
        {
            "title": "Очистка воздуха в квартире",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "11.12.2019",
            "link": "ochistka-vozduha-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ochistka-vozduha-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ochistka-vozduha-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 11242,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4c38aced40254f2320"
        },
        {
            "title": "Как избавиться от неприятных и вредных запахов с улицы в квартире",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-izbavitsya-ot-nepriyatnyh-i-vrednyh-zapahov-s-ulicy-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-izbavitsya-ot-nepriyatnyh-i-vrednyh-zapahov-s-ulicy-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-izbavitsya-ot-nepriyatnyh-i-vrednyh-zapahov-s-ulicy-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 8318,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4c38aced40254f2321"
        },
        {
            "title": "Повышенная сухость воздуха в квартире: чем опасна и как бороться?",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "povyshennaya-suhost-vozduha-v-kvartire-chem-opasna-i-kak-borotsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/povyshennaya-suhost-vozduha-v-kvartire-chem-opasna-i-kak-borotsya/ooo_hero.jpg/ooo_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/povyshennaya-suhost-vozduha-v-kvartire-chem-opasna-i-kak-borotsya/ooo_hero.jpg/ooo_hero.jpg 2x",
            "views": 9021,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca4c38aced40254f2322"
        },
        {
            "title": "Как ухаживать за ламинатом",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-uhazhivat-za-laminatom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukhazhivat-za-laminatom/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukhazhivat-za-laminatom/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13612,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca4d38aced40254f2323"
        },
        {
            "title": "Видео-совет: Как правильно уложить ламинат",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "video-sovet-kak-pravilno-ulozhit-laminat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-pravilno-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-pravilno-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7452,
            "total_comment": 0,
            "is_video": true,
            "likes": 8,
            "id": "648aca4d38aced40254f2324"
        },
        {
            "title": "Как уложить ламинат",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "kak-ulozhit-laminat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15096,
            "total_comment": 2,
            "is_video": false,
            "likes": 15,
            "id": "648aca4d38aced40254f2325"
        },
        {
            "title": "Как покрыть лаком деревянный паркет",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-pokryt-lakom-derevyannyy-parket",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-pokryt-lakom-derevyannyy-parket/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-pokryt-lakom-derevyannyy-parket/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12182,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca4d38aced40254f2326"
        },
        {
            "title": "Монтаж плинтуса",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "montazh-plintusa",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/montazh-plintusa/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/montazh-plintusa/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15733,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca4d38aced40254f2327"
        },
        {
            "title": "Как выбрать ламинат",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-laminat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-laminat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-laminat/000-photo.jpg/000-photo.jpg 2x",
            "views": 6142,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca4d38aced40254f2328"
        },
        {
            "title": "Виды плитки ПВХ",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-plitki-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-plitki-pvh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-plitki-pvh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4840,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca4e38aced40254f2329"
        },
        {
            "title": "Как просверлить керамическую плитку",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-prosverlit-keramicheskuyu-plitku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-prosverlit-keramicheskuyu-plitku/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-prosverlit-keramicheskuyu-plitku/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14017,
            "total_comment": 1,
            "is_video": false,
            "likes": 5,
            "id": "648aca4e38aced40254f232a"
        },
        {
            "title": "Уход за керамической плиткой",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "uhod-za-keramicheskoy-plitkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/uhod-za-keramicheskoy-plitkoy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/uhod-za-keramicheskoy-plitkoy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14004,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca4e38aced40254f232b"
        },
        {
            "title": "Как выложить пол плиткой",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-vylozhit-pol-plitkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vylozhit-pol-plitkoy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vylozhit-pol-plitkoy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15815,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca4e38aced40254f232c"
        },
        {
            "title": "Как выбрать грунтовку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-gruntovku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-gruntovku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-gruntovku/000-photo.jpg/000-photo.jpg 2x",
            "views": 11061,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca4e38aced40254f232d"
        },
        {
            "title": "Как выложить мозаику",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "25.05.2023",
            "link": "kak-vylozhit-mozaiku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vylozhit-mozaiku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vylozhit-mozaiku/000-photo.jpg/000-photo.jpg 2x",
            "views": 14855,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca4f38aced40254f232e"
        },
        {
            "title": "Информационные розетки",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "informatsionnye-rozetki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1776274653/fudzi/advice/kak-podkluchit-internet-rozetku-000-photo.jpg/kak-podkluchit-internet-rozetku-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1776274653/fudzi/advice/kak-podkluchit-internet-rozetku-000-photo.jpg/kak-podkluchit-internet-rozetku-000-photo.jpg 2x",
            "views": 5228,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4f38aced40254f232f"
        },
        {
            "title": "Видео-совет: Как уложить ковровое покрытиея",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "video-sovet-kak-ulozhit-kovrovoe-pokrytie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14701,
            "total_comment": 0,
            "is_video": true,
            "likes": 10,
            "id": "648aca4f38aced40254f2330"
        },
        {
            "title": "Как выбрать электрическую газонокосилку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "06.10.2021",
            "link": "kak-vybrat-elektricheskuyu-gazonokosilku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/na-chto-obratit-vnimanie-pri-vybore-elektricheskoy-gazonokosilki/000-square.jpg/000-square.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/na-chto-obratit-vnimanie-pri-vybore-elektricheskoy-gazonokosilki/000-square.jpg/000-square.jpg 2x",
            "views": 8867,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca4f38aced40254f2331"
        },
        {
            "title": "Гид по напольным покрытиям. Ковролин",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "gid-po-napolnym-pokrytiyam-kovrolin",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/gid-po-napolnym-pokrytiyam-kovrolin/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/gid-po-napolnym-pokrytiyam-kovrolin/000-photo.jpg/000-photo.jpg 2x",
            "views": 16327,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca4f38aced40254f2332"
        },
        {
            "title": "Как выбрать вагонку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "kak-vypolnit-obshivku-vagonkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vypolnit-obshivku-vagonkoy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vypolnit-obshivku-vagonkoy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6836,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca4f38aced40254f2333"
        },
        {
            "title": "Инженерная доска для пола: конструкция, преимущества, способы монтажа",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "inzhenernaya-doska-dlya-pola-konstrukciya-preimushchestva-sposoby-montazha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/inzhenernaya-doska-dlya-pola-konstrukciya-preimushchestva-sposoby-montazha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/inzhenernaya-doska-dlya-pola-konstrukciya-preimushchestva-sposoby-montazha/000-photo.jpg/000-photo.jpg 2x",
            "views": 9771,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5038aced40254f2334"
        },
        // {
        //     "title": "Как выбрать грязезащитный коврик в квартиру, загородный дом, офис",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Напольные покрытия",
        //     "dept_slug": "napolnye-pokrytiya",
        //     "date_publish": "19.10.2021",
        //     "link": "kak-vybrat-gryazezashchitnyy-kovrik-v-kvartiru-zagorodnyy-dom-ofis",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-gryazezashchitnyy-kovrik-v-kvartiru-zagorodnyy-dom-v-ofis/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-gryazezashchitnyy-kovrik-v-kvartiru-zagorodnyy-dom-v-ofis/ooo_Photo.jpg/ooo_Photo.jpg 2x",
        //     "views": 7879,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 12,
        //     "id": "648aca5038aced40254f2335"
        // },
        {
            "title": "Монтаж системы противообледенения кровли",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "montazh-sistemy-protivoobledeneniya-krovli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-sistemy-protivoobledeneniya-krovli/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-sistemy-protivoobledeneniya-krovli/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6250,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5038aced40254f2337"
        },
        {
            "title": "Как выбрать отвертку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "02.12.2019",
            "link": "kak-vybrat-otvertku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-otvertku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-otvertku/000-photo.jpg/000-photo.jpg 2x",
            "views": 14239,
            "total_comment": 1,
            "is_video": true,
            "likes": 7,
            "id": "648aca5038aced40254f2338"
        },
        {
            "title": "Как выбрать электроинструмент",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-elektroinstrument",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-elektroinstrument/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-elektroinstrument/000-photo.jpg/000-photo.jpg 2x",
            "views": 4687,
            "total_comment": 0,
            "is_video": true,
            "likes": 14,
            "id": "648aca5138aced40254f2339"
        },
        {
            "title": "Выбираем мойку высокого давления",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "03.02.2020",
            "link": "vybiraem-moiku-vysokogo-davleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/sravnivaem-moyki-vysokogo-davleniya-ot-bosch-gid-po-vyboru/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/sravnivaem-moyki-vysokogo-davleniya-ot-bosch-gid-po-vyboru/000-photo.jpg/000-photo.jpg 2x",
            "views": 12504,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca5138aced40254f233a"
        },
        {
            "title": "Выбираем минимойки и аксессуары к ним",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "05.10.2021",
            "link": "vybiraem-minimoyki-i-aksessuary-k-nim",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-minimoyki-i-aksessuary-k-nim/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vybiraem-minimoyki-i-aksessuary-k-nim/000-photo.jpg/000-photo.jpg 2x",
            "views": 8283,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5138aced40254f233b"
        },
        {
            "title": "Выбираем воздушные компрессоры и аксессуары к ним",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "05.10.2021",
            "link": "vybiraem-vozdushnye-kompressory-i-aksessuary-k-nim",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/выбираем-воздушные-компрессоры-и-аксессуары-к-ним/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/выбираем-воздушные-компрессоры-и-аксессуары-к-ним/000-photo.jpg/000-photo.jpg 2x",
            "views": 9281,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5138aced40254f233c"
        },
        {
            "title": "Как выбрать ковровое покрытие",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-kovrovoe-pokrytie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kovrovoe-pokrytie/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kovrovoe-pokrytie/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9281,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5138aced40254f233d"
        },
        {
            "title": "Как выбрать подложку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-podlozhku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-podlozhku/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-podlozhku/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16085,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5238aced40254f233e"
        },
        {
            "title": "Использование ковров и ковриков в интерьере",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "ispolzovanie-kovrov-i-kovrikov-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ispolzovanie-kovrov-i-kovrikov-v-interere/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ispolzovanie-kovrov-i-kovrikov-v-interere/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14041,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5238aced40254f233f"
        },
        {
            "title": "Как подобрать цвет напольного покрытия",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-podobrat-cvet-napolnogo-pokrytiya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-po-oformleniyu-pola/main-mini.jpg/main-mini.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-po-oformleniyu-pola/main-mini.jpg/main-mini.jpg 2x",
            "views": 15635,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5238aced40254f2340"
        },
        {
            "title": "Аксессуары для напольных покрытий",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "aksessuary-dlya-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/aksessuary-dlya-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/aksessuary-dlya-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9520,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5238aced40254f2341"
        },
        {
            "title": "Виды напольных покрытий",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-kleev-dlya-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-kleev-dlya-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14163,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5238aced40254f2342"
        },
        {
            "title": "Как выбрать придверный коврик",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-pridvernyy-kovrik",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-pridvernyy-kovrik/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-pridvernyy-kovrik/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16143,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5238aced40254f2343"
        },
        {
            "title": "Как правильно расположить розетки и выключатели в квартире",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-pravilno-raspolozhit-rozetki-i-vyklyuchateli-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravilno-raspolozhit-rozetki-i-vyklyuchateli-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravilno-raspolozhit-rozetki-i-vyklyuchateli-v-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15414,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5338aced40254f2344"
        },
        {
            "title": "Как укладывать доску из массива",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-ukladyvat-dosku-iz-massiva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukladyvat-dosku-iz-massiva/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukladyvat-dosku-iz-massiva/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7284,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5338aced40254f2345"
        },
        {
            "title": "Советы профессионалов по необходимости использования ковриков, ковров",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "sovety-professionalov-po-neobhodimosti-ispolzovaniya-kovrikov-kovrov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-professionalov-po-neobhodimosti-ispolzovaniya-kovrikov-kovrov/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-professionalov-po-neobhodimosti-ispolzovaniya-kovrikov-kovrov/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4017,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5338aced40254f2346"
        },
        // {
        //     "title": "Как настелить ковролин и линолеум",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Напольные покрытия",
        //     "dept_slug": "napolnye-pokrytiya",
        //     "date_publish": "05.10.2021",
        //     "link": "kak-nastelit-kovrolin-i-linoleum2",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-nastelit-kovrolin-i-linoleum/2/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-nastelit-kovrolin-i-linoleum/2/ooo_Photo.jpg/ooo_Photo.jpg 2x",
        //     "views": 15554,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 9,
        //     "id": "648aca5338aced40254f2347"
        // },
        {
            "title": "Укладка напольного пробкового покрытия",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "ukladka-napolnogo-probkovogo-pokrytiya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukladka-napolnogo-probkovogo-pokrytiya/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/ukladka-napolnogo-probkovogo-pokrytiya/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15285,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5338aced40254f2348"
        },
        {
            "title": "Как выбрать инструмент для укладки ламината",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-instrument-dlya-ukladki-laminata",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-instrument-dlya-ukladki-laminata/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-instrument-dlya-ukladki-laminata/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13431,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5438aced40254f2349"
        },
        {
            "title": "Уход за массивной доской",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "uhod-za-massivnoy-doskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/uhod-za-massivnoy-doskoy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/uhod-za-massivnoy-doskoy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 11171,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca5438aced40254f234a"
        },
        {
            "title": "Как настелить ковролин и линолеум",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-nastelit-kovrolin-i-linoleum",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-nastelit-kovrolin-i-linoleum/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-nastelit-kovrolin-i-linoleum/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7969,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5438aced40254f234b"
        },
        {
            "title": "Чудо-датчик: как умный дом следит за комфортом и безопасностью",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "chudo-datchik-kak-umnyy-dom-sledit-za-komfortom-i-bezopasnostyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chudo-datchik-kak-umnyy-dom-sledit-za-komfortom-i-bezopasnostyu/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chudo-datchik-kak-umnyy-dom-sledit-za-komfortom-i-bezopasnostyu/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14069,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5438aced40254f234c"
        },
        {
            "title": "Как умный дом помогает следить за безопасностью",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "11.02.2020",
            "link": "kak-umnyy-dom-pomogaet-sledit-za-bezopasnostyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-umnyy-dom-pomogaet-sledit-za-bezopasnostyu/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-umnyy-dom-pomogaet-sledit-za-bezopasnostyu/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10285,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5438aced40254f234d"
        },
        {
            "title": "Источники загрязнения воздуха в доме и квартире",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "istochniki-zagryazneniya-vozduha-v-dome-i-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/istochniki-zagryazneniya-vozduha-v-dome-i-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/istochniki-zagryazneniya-vozduha-v-dome-i-kvartire/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14611,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca5538aced40254f234e"
        },
        {
            "title": "Всё в одном: как сделать умный дом постепенно",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "01.02.2020",
            "link": "vsye-v-odnom-kak-sdelat-umnyy-dom-postepenno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vsye-v-odnom-kak-sdelat-umnyy-dom-postepenno/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vsye-v-odnom-kak-sdelat-umnyy-dom-postepenno/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10893,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5538aced40254f234f"
        },
        {
            "title": "Как использовать холодную сварку",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-ispolzovat-holodnuyu-svarku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ispolzovat-holodnuyu-svarku/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ispolzovat-holodnuyu-svarku/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7413,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5538aced40254f2350"
        },
        {
            "title": "Виды порогов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-porogov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-porogov/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-porogov/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12319,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5538aced40254f2351"
        },
        {
            "title": "Виды клеев для напольных покрытий",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-kleev-dlya-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-kleev-dlya-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-kleev-dlya-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12087,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca5538aced40254f2352"
        },
        {
            "title": "Уход за линолеумом",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "19.10.2021",
            "link": "uhod-za-linoleumom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/uhod-za-linoleumom/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/uhod-za-linoleumom/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10949,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca5638aced40254f2353"
        },
        {
            "title": "Как склеить линолеум встык",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "10.11.2022",
            "link": "kak-skleit-linoleum-vstyk",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-skleit-linoleum-vstyk/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-skleit-linoleum-vstyk/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 11662,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5638aced40254f2354"
        },
        {
            "title": "Видео-совет: Как выбрать мягкие напольные покрытия",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "video-sovet-kak-vybrat-myagkie-napolnye-pokrytiya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-vybrat-myagkie-napolnye-pokrytiya/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-vybrat-myagkie-napolnye-pokrytiya/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9433,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5638aced40254f2356"
        },
        {
            "title": "Как замерить ток мультиметром",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "19.10.2021",
            "link": "kak-zamerit-tok-multimetrom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-zamerit-tok-multimetrom/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-zamerit-tok-multimetrom/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12293,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5638aced40254f2357"
        },
        {
            "title": "Как выбрать трансформатор для галогенных ламп",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-transformator-dlya-galogennykh-lamp",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-transformator-dlya-galogennykh-lamp/ooo_hero.jpg/ooo_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-transformator-dlya-galogennykh-lamp/ooo_hero.jpg/ooo_hero.jpg 2x",
            "views": 5570,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5638aced40254f2358"
        },
        {
            "title": "Как защититься от травм при электромонтажных работах",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "15.01.2020",
            "link": "kak-zashchititsya-ot-travm-pri-elektromontazhnykh-rabotakh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-zashchititsya-ot-travm-pri-elektromontazhnykh-rabotakh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-zashchititsya-ot-travm-pri-elektromontazhnykh-rabotakh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9734,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5738aced40254f2359"
        },
        {
            "title": "Как ухаживать за коврами",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-uhazhivat-za-kovrami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-uhazhivat-za-kovrami/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-uhazhivat-za-kovrami/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6220,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca5738aced40254f235a"
        },
        {
            "title": "Как выбрать ковер",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-kover",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kover/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kover/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14428,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5738aced40254f235b"
        },
        {
            "title": "Как выбрать ковер для детской комнаты",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-kover-dlya-detskoy-komnaty",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kover-dlya-detskoy-komnaty/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-kover-dlya-detskoy-komnaty/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4882,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca5738aced40254f235c"
        },
        {
            "title": "Советы дизайнеров по выбору ковров",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "sovety-dizaynerov-po-vyboru-kovrov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-dizaynerov-po-vyboru-kovrov/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/sovety-dizaynerov-po-vyboru-kovrov/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4423,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5738aced40254f235d"
        },
        {
            "title": "Виды пробковых покрытий",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-probkovyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-probkovyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-probkovyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 5280,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5838aced40254f235e"
        },
        {
            "title": "Виды плинтусов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "vidy-plintusov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-plintusov/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vidy-plintusov/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13680,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5838aced40254f235f"
        },
        {
            "title": "Как выбрать линолеум",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-linoleum",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-linoleum/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-vybrat-linoleum/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7957,
            "total_comment": 3,
            "is_video": false,
            "likes": 13,
            "id": "648aca5838aced40254f2360"
        },
        {
            "title": "Какие инструменты используют для монтажа напольных покрытий",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.10.2021",
            "link": "kakie-instrumenty-ispolzuyut-dlya-montazha-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kakie-instrumenty-ispolzuyut-dlya-montazha-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kakie-instrumenty-ispolzuyut-dlya-montazha-napolnyh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4530,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5838aced40254f2361"
        },
        {
            "title": "Как выбрать клей для плитки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-kley-dlya-plitki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-kley-dlya-plitki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-kley-dlya-plitki/000-photo.jpg/000-photo.jpg 2x",
            "views": 8082,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5838aced40254f2362"
        },
        {
            "title": "Как монтировать ревизионный люк",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-montirovat-revizionnyy-lyuk",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-montirovat-revizionnyy-lyuk/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-montirovat-revizionnyy-lyuk/000-photo.jpg/000-photo.jpg 2x",
            "views": 6427,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5938aced40254f2363"
        },
        {
            "title": "Как выбрать зеркальную плитку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-zerkalnuyu-plitku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-zerkalnuyu-plitku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-zerkalnuyu-plitku/000-photo.jpg/000-photo.jpg 2x",
            "views": 4208,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5938aced40254f2364"
        },
        {
            "title": "Особенности смесителей скрытого монтажа",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "osobennosti-smesiteley-skrytogo-montazha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/osobennosti-smesiteley-skrytogo-montazha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/osobennosti-smesiteley-skrytogo-montazha/000-photo.jpg/000-photo.jpg 2x",
            "views": 8864,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5938aced40254f2365"
        },
        {
            "title": "Как облицевать бассейн керамической плиткой",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-oblicevat-basseyn-keramicheskoy-plitkoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-oblicevat-basseyn-keramicheskoy-plitkoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-oblicevat-basseyn-keramicheskoy-plitkoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 14130,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca5938aced40254f2366"
        },
        {
            "title": "Как облицевать плиткой крыльцо",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-oblicevat-plitkoy-krylco",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-oblicevat-plitkoy-krylco/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-oblicevat-plitkoy-krylco/000-photo.jpg/000-photo.jpg 2x",
            "views": 6870,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5938aced40254f2367"
        },
        {
            "title": "Душевые лейки с различными режимами",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "dushevye-leyki-s-razlichnymi-rezhimami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/dushevye-leyki-s-razlichnymi-rezhimami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/dushevye-leyki-s-razlichnymi-rezhimami/000-photo.jpg/000-photo.jpg 2x",
            "views": 14270,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5a38aced40254f2368"
        },
        {
            "title": "Как бороться с грибком в ванной",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-borotsya-s-gribkom-v-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-borotsya-s-gribkom-v-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-borotsya-s-gribkom-v-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 11725,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5a38aced40254f2369"
        },
        {
            "title": "Выбираем стальную ванну",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "vybiraem-stalnuyu-vannu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/vybiraem-stalnuyu-vannu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/vybiraem-stalnuyu-vannu/000-photo.jpg/000-photo.jpg 2x",
            "views": 7462,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5a38aced40254f236a"
        },
        {
            "title": "Как выбрать ванну исходя из формы, размера и эргономики",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-vannu-ishodya-iz-formy-razmera-i-ergonomiki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-vannu-iskhodya-iz-formy-razmera-i-ergonomiki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-vannu-iskhodya-iz-formy-razmera-i-ergonomiki/000-photo.jpg/000-photo.jpg 2x",
            "views": 15183,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5a38aced40254f236b"
        },
        {
            "title": "Как бороться с плесенью в ванной",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "kak-borotsya-s-plesenyu-v-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-borotsya-s-plesenyu-v-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-borotsya-s-plesenyu-v-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 9197,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5a38aced40254f236c"
        },
        {
            "title": "Гигиенический душ для унитаза",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "27.04.2022",
            "link": "gigienicheskiy-dush-dlya-unitaza",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gigienicheskiy-dush-dlya-unitaza/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/gigienicheskiy-dush-dlya-unitaza/000-photo.jpg/000-photo.jpg 2x",
            "views": 14658,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5a38aced40254f236d"
        },
        {
            "title": "Как установить подвесную тумбу под раковину",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-podvesnuyu-tumbu-pod-rakovinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-podvesnuyu-tumbu-pod-rakovinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-podvesnuyu-tumbu-pod-rakovinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 8592,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5b38aced40254f236e"
        },
        {
            "title": "Как установить душевой поддон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "kak-ustanovit-dushevoy-poddon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak_ustanovit_dushevoy_poddon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak_ustanovit_dushevoy_poddon/000-photo.jpg/000-photo.jpg 2x",
            "views": 13296,
            "total_comment": 0,
            "is_video": true,
            "likes": 9,
            "id": "648aca5b38aced40254f236f"
        },
        {
            "title": "Установка душевой системы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "ustanovka-dushevoy-sistemy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/ustanovka-dushevoy-sistemy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/ustanovka-dushevoy-sistemy/000-photo.jpg/000-photo.jpg 2x",
            "views": 13620,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5b38aced40254f2370"
        },
        {
            "title": "Как установить душевой поддон своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-dushevoy-poddon-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-dushevoy-poddon-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-dushevoy-poddon-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 15959,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5b38aced40254f2371"
        },
        {
            "title": "Как выбрать фильтр кувшинного типа",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.07.2022",
            "link": "kak-vybrat-filtr-kuvshinnogo-tipa",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-filtr-gruboy-ochistki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-filtr-gruboy-ochistki/000-photo.jpg/000-photo.jpg 2x",
            "views": 14523,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5b38aced40254f2372"
        },
        {
            "title": "Как выбрать твердотопливный котел",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-tverdotoplivnyy-kotel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-tverdotoplivnyy-kotel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-tverdotoplivnyy-kotel/000-photo.jpg/000-photo.jpg 2x",
            "views": 8963,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5b38aced40254f2373"
        },
        {
            "title": "Как выбрать уплотнительные материалы",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-uplotnitelnye-materialy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-uplotnitelnye-materialy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-uplotnitelnye-materialy/000-photo.jpg/000-photo.jpg 2x",
            "views": 6125,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca5c38aced40254f2374"
        },
        {
            "title": "Как выбрать радиатор отопления",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-radiator-otopleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-radiator-otopleniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-radiator-otopleniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 7464,
            "total_comment": 2,
            "is_video": false,
            "likes": 13,
            "id": "648aca5c38aced40254f2375"
        },
        {
            "title": "Как выбрать фильтр грубой очистки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-filtr-gruboy-ochistki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-filtr-gruboy-ochistki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-filtr-gruboy-ochistki/000-photo.jpg/000-photo.jpg 2x",
            "views": 14963,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5c38aced40254f2376"
        },
        {
            "title": "Как выбрать теплоизоляцию для труб",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "10.03.2022",
            "link": "kak-vybrat-teploizolyaciyu-dlya-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-teploizolyatsiyu-dlya-trub/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-teploizolyatsiyu-dlya-trub/000-photo.jpg/000-photo.jpg 2x",
            "views": 13154,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca5c38aced40254f2377"
        },
        {
            "title": "Обслуживание отопительного котла",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "obsluzhivanie-otopitelnogo-kotla",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obsluzhivanie-otopitelnogo-kotla/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obsluzhivanie-otopitelnogo-kotla/000-photo.jpg/000-photo.jpg 2x",
            "views": 16334,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5c38aced40254f2378"
        },
        {
            "title": "Как уложить керамогранит",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "20.05.2023",
            "link": "kak-ulozhit-keramogranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-ulozhit-keramogranit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-ulozhit-keramogranit/000-photo.jpg/000-photo.jpg 2x",
            "views": 15001,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5d38aced40254f2379"
        },
        {
            "title": "Как уложить плитку на стену",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "20.05.2023",
            "link": "kak-ulozhit-plitku-na-stenu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-ulozhit-plitku-na-stenu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-ulozhit-plitku-na-stenu/000-photo.jpg/000-photo.jpg 2x",
            "views": 8327,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5d38aced40254f237a"
        },
        {
            "title": "Как ухаживать за облицовкой из натурального камня",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-uhazhivat-za-oblicovkoy-iz-naturalnogo-kamnya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-uhazhivat-za-oblicovkoy-iz-naturalnogo-kamnya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-uhazhivat-za-oblicovkoy-iz-naturalnogo-kamnya/000-photo.jpg/000-photo.jpg 2x",
            "views": 14022,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca5d38aced40254f237b"
        },
        {
            "title": "Как выбрать керамогранит",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "20.05.2023",
            "link": "kak-vybrat-keramogranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-keramogranit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-vybrat-keramogranit/000-photo.jpg/000-photo.jpg 2x",
            "views": 11357,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5d38aced40254f237c"
        },
        {
            "title": "Керамогранит в ванной, прихожей и на кухне",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "20.05.2023",
            "link": "keramogranit-v-vannoy-prihozhey-i-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/keramogranit-v-vannoy-prihozhey-i-na-kuhne/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/keramogranit-v-vannoy-prihozhey-i-na-kuhne/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9143,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5d38aced40254f237d"
        },
        {
            "title": "Четыре варианта, как разместить в маленькой ванной комнате стиральную машинку и систему хранения",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "23.10.2019",
            "link": "kak-razmestit-v-malenkoy-vannoy-komnate-stiralnuyu-mashinku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/000-photo.jpg/000-photo.jpg 2x",
            "views": 5325,
            "total_comment": 2,
            "is_video": false,
            "likes": 7,
            "id": "648aca5e38aced40254f237e"
        },
        {
            "title": "Ремонт чугунной ванны с помощью акрилового вкладыша",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "18.04.2022",
            "link": "remont-chugunnoy-vanny-s-pomoshchyu-akrilovogo-vkladysha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/remont-chugunnoy-vanny-s-pomoshchyu-akrilovogo-vkladysha/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/remont-chugunnoy-vanny-s-pomoshchyu-akrilovogo-vkladysha/000-photo.png/000-photo.png 2x",
            "views": 5961,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5e38aced40254f237f"
        },
        {
            "title": "Идеальная ванная комната своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "idealnaya-vannaya-komnata-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/idealnaya-vannaya-komnata-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/idealnaya-vannaya-komnata-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 5527,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca5e38aced40254f2380"
        },
        {
            "title": "Технология установки акриловой ванны",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "tehnologiya-ustanovki-akrilovoy-vanny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/tekhnologiya-ustanovki-akrilovoy-vanny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/tekhnologiya-ustanovki-akrilovoy-vanny/000-photo.jpg/000-photo.jpg 2x",
            "views": 10627,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca5e38aced40254f2381"
        },
        {
            "title": "Ванная комната: секреты правильного хранения",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "17.10.2019",
            "link": "vannaya-komnata-sekrety-pravilnogo-hraneniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vannaya-komnata-sekrety-pravilnogo-hraneniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vannaya-komnata-sekrety-pravilnogo-hraneniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 14912,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca5e38aced40254f2382"
        },
        {
            "title": "Лайфхаки для ванной комнаты: какая отделка, сантехника и мебель облегчат уборку",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "layfhaki-dlya-vannoy-komnaty-kakaya-otdelka-santehnika-i-mebel-oblegchat-uborku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/layfhaki-dlya-vannoy-komnaty-kakaya-otdelka-santehnika-i-mebel-oblegchat-uborku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/layfhaki-dlya-vannoy-komnaty-kakaya-otdelka-santehnika-i-mebel-oblegchat-uborku/000-photo.jpg/000-photo.jpg 2x",
            "views": 13298,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca5f38aced40254f2383"
        },
        {
            "title": "Как установить ширму на ванну",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-shirmu-na-vannu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-shirmu-na-vannu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-shirmu-na-vannu/000-photo.jpg/000-photo.jpg 2x",
            "views": 6208,
            "total_comment": 1,
            "is_video": false,
            "likes": 13,
            "id": "648aca5f38aced40254f2384"
        },
        {
            "title": "Как выбрать мебель для ванной комнаты",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-mebel-dlya-vannoy-komnaty",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-mebel-dlya-vannoy-komnaty/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-mebel-dlya-vannoy-komnaty/000-photo.jpg/000-photo.jpg 2x",
            "views": 14660,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5f38aced40254f2385"
        },
        {
            "title": "Красота в простоте: ванная в скандинавском стиле",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "20.05.2023",
            "link": "krasota-v-prostote-vannaya-v-skandinavskom-stile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/krasota-v-prostote-vannaya-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/krasota-v-prostote-vannaya-v-skandinavskom-stile/000-photo.jpg/000-photo.jpg 2x",
            "views": 10535,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca5f38aced40254f2386"
        },
        {
            "title": "Маленькая ванная: как грамотно использовать пространство",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "malenkaya-vannaya-kak-gramotno-ispolzovat-prostranstvo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/malenkaya-vannaya-kak-gramotno-ispolzovat-prostranstvo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/malenkaya-vannaya-kak-gramotno-ispolzovat-prostranstvo/000-photo.jpg/000-photo.jpg 2x",
            "views": 11900,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca5f38aced40254f2387"
        },
        {
            "title": "Виды ванн: преимущества и недостатки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "vidy-vann-preimushchestva-i-nedostatki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/vidy-vann-preimushchestva-i-nedostatki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/vidy-vann-preimushchestva-i-nedostatki/000-photo.jpg/000-photo.jpg 2x",
            "views": 4659,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca5f38aced40254f2388"
        },
        {
            "title": "Виды сушилок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "27.07.2022",
            "link": "vidy-sushilok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vidy-sushilok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/vidy-sushilok/000-photo.jpg/000-photo.jpg 2x",
            "views": 5614,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6038aced40254f2389"
        },
        {
            "title": "Как сделать ванную комнату уютной с помощью аксессуаров",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-vannuyu-komnatu-uyutnoy-s-pomoshchyu-aksessuarov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-sdelat-vannuyu-komnatu-uyutnoy-s-pomoshchyu-aksessuarov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-sdelat-vannuyu-komnatu-uyutnoy-s-pomoshchyu-aksessuarov/000-photo.jpg/000-photo.jpg 2x",
            "views": 7423,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca6038aced40254f238a"
        },
        {
            "title": "Как правильно выбрать смеситель для ванной",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-pravilno-vybrat-smesitel-dlya-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-pravilno-vybrat-smesitel-dlya-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-pravilno-vybrat-smesitel-dlya-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 8612,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca6038aced40254f238b"
        },
        {
            "title": "Душевая кабина или душевой уголок: преимущества и особенности установки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "dushevaya-kabina-ili-dushevoy-ugolok-preimushchestva-i-osobennosti-ustanovki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/dushevaya-kabina-ili-dushevoy-ugolok-preimushchestva-i-osobennosti-ustanovki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/dushevaya-kabina-ili-dushevoy-ugolok-preimushchestva-i-osobennosti-ustanovki/000-photo.jpg/000-photo.jpg 2x",
            "views": 11796,
            "total_comment": 0,
            "is_video": true,
            "likes": 10,
            "id": "648aca6038aced40254f238c"
        },
        {
            "title": "Крепление трубопроводов",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kreplenie-truboprovodov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kreplenie-truboprovodov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kreplenie-truboprovodov/000-photo.jpg/000-photo.jpg 2x",
            "views": 8890,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6038aced40254f238d"
        },
        {
            "title": "Основные рекомендации по прокладке трубопроводов",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "osnovnye-rekomendacii-po-prokladke-truboprovodov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/osnovnye-rekomendatsii-po-prokladke-truboprovodov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/osnovnye-rekomendatsii-po-prokladke-truboprovodov/000-photo.jpg/000-photo.jpg 2x",
            "views": 11430,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6038aced40254f238e"
        },
        {
            "title": "Как прочистить засор в унитазе",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-prochistit-zasor-v-unitaze",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-prochistit-zasor-v-unitaze/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-prochistit-zasor-v-unitaze/000-photo.jpg/000-photo.jpg 2x",
            "views": 14816,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6138aced40254f238f"
        },
        {
            "title": "Как рассчитать количество плитки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "05.10.2021",
            "link": "kak-rasschitat-kolichestvo-plitki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-rasschitat-kolichestvo-plitki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/kak-rasschitat-kolichestvo-plitki/000-photo.jpg/000-photo.jpg 2x",
            "views": 13558,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6138aced40254f2390"
        },
        {
            "title": "Как установить ванну",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "kak-ustanovit-vannu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-vannu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit-vannu/000-photo.jpg/000-photo.jpg 2x",
            "views": 15993,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca6138aced40254f2391"
        },
        {
            "title": "Как установить душевую систему с термостатом",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "kak-ustanovit-dushevuyu-sistemu-s-termostatom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit'-dushevuyu-sistemu-s-termostatom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ustanovit'-dushevuyu-sistemu-s-termostatom/000-photo.jpg/000-photo.jpg 2x",
            "views": 5426,
            "total_comment": 0,
            "is_video": true,
            "likes": 14,
            "id": "648aca6138aced40254f2392"
        },
        {
            "title": "Как ванну покрыть эмалью",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vannu-pokryt-emalyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vannu-pokryt-emalyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vannu-pokryt-emalyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 13283,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca6138aced40254f2393"
        },
        {
            "title": "Как сделать экран под ванной",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-ekran-pod-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-sdelat-ekran-pod-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-sdelat-ekran-pod-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 14046,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6138aced40254f2394"
        },
        {
            "title": "Как убрать скол на ванне",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-ubrat-skol-na-vanne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ubrat-skol-na-vanne/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-ubrat-skol-na-vanne/000-photo.jpg/000-photo.jpg 2x",
            "views": 9408,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca6238aced40254f2395"
        },
        {
            "title": "Наливные электрические водонагреватели",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "nalivnye-elektricheskie-vodonagrevateli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/nalivnye-elektricheskie-vodonagrevateli/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/nalivnye-elektricheskie-vodonagrevateli/000-photo.jpg/000-photo.jpg 2x",
            "views": 7603,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca6238aced40254f2396"
        },
        {
            "title": "Как выбрать гидроаккумулятор для водоснабжения",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-gidroakkumulyator-dlya-vodosnabzheniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-membrannyy-bak-dlya-vodosnabzheniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-membrannyy-bak-dlya-vodosnabzheniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 10337,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca6238aced40254f2397"
        },
        {
            "title": "Как подобрать стабилизатор напряжения для газового котла",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-podobrat-stabilizator-napryazheniya-dlya-gazovogo-kotla",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-podobrat-stabilizator-napryazheniya-dlya-gazovogo-kotla/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-podobrat-stabilizator-napryazheniya-dlya-gazovogo-kotla/000-photo.jpg/000-photo.jpg 2x",
            "views": 10294,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6238aced40254f2398"
        },
        {
            "title": "Обслуживание гидроаккумуляторов и расширительных баков",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.03.2022",
            "link": "obsluzhivanie-gidroakkumulyatorov-i-rasshiritelnyh-bakov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obsluzhivanie-gidroakkumulyatorov-i-rasshiritelnykh-bakov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/obsluzhivanie-gidroakkumulyatorov-i-rasshiritelnykh-bakov/000-photo.jpg/000-photo.jpg 2x",
            "views": 16506,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6238aced40254f2399"
        },
        {
            "title": "Как ухаживать за фильтрами грубой очистки",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.03.2022",
            "link": "kak-uhazhivat-za-filtrami-gruboy-ochistki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-ukhazhivat-za-filtrami-gruboy-ochistki/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-ukhazhivat-za-filtrami-gruboy-ochistki/000-photo.png/000-photo.png 2x",
            "views": 14526,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6338aced40254f239a"
        },
        {
            "title": "Как выбрать современный водонагреватель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-sovremennyy-vodonagrevatel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-sovremennyy-vodonagrevatel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-sovremennyy-vodonagrevatel/000-photo.jpg/000-photo.jpg 2x",
            "views": 9092,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca6338aced40254f239b"
        },
        {
            "title": "Разновидности фильтров для очистки воды",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "raznovidnosti-filtrov-dlya-ochistki-vody",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/raznovidnosti-filtrov-dlya-ochistki-vody/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/raznovidnosti-filtrov-dlya-ochistki-vody/000-photo.jpg/000-photo.jpg 2x",
            "views": 13209,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6338aced40254f239c"
        },
        {
            "title": "Солнце в руках: ванная в средиземноморском стиле",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "19.10.2021",
            "link": "solnce-v-rukah-vannaya-v-sredizemnomorskom-stile",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/solntse-v-rukakh-vannaya-v-sredizemnomorskom-stile/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/solntse-v-rukakh-vannaya-v-sredizemnomorskom-stile/000-photo.jpg/000-photo.jpg 2x",
            "views": 16337,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6338aced40254f239d"
        },
        {
            "title": "Как выбрать напольные аксессуары для ванной",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-napolnye-aksessuary-dlya-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-napolnye-aksessuary-dlya-vannoy/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-napolnye-aksessuary-dlya-vannoy/000-hero.jpg/000-hero.jpg 2x",
            "views": 8755,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6338aced40254f239e"
        },
        {
            "title": "Как выбрать унитаз",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-unitaz",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-unitaz/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-unitaz/000-photo.jpg/000-photo.jpg 2x",
            "views": 9248,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6438aced40254f239f"
        },
        {
            "title": "Какой унитаз выбрать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kakoy-unitaz-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kakoy-unitaz-vybrat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kakoy-unitaz-vybrat/000-photo.jpg/000-photo.jpg 2x",
            "views": 6238,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6438aced40254f23a0"
        },
        {
            "title": "Как выбрать ванну",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "17.08.2022",
            "link": "kak-vybrat-vannu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak_vubrat_vanny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak_vubrat_vanny/000-photo.jpg/000-photo.jpg 2x",
            "views": 8902,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6438aced40254f23a1"
        },
        {
            "title": "Как выбрать раковину",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-rakovinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-rakovinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/santehnika/kak-vybrat-rakovinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 10755,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6438aced40254f23a2"
        },
        {
            "title": "Модульная мебель для ванной СМАРТ",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "modulnaya-mebel-dlya-vannoy-smart",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/modulnaya-mebel-dlya-vannoy-smart/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/modulnaya-mebel-dlya-vannoy-smart/000-photo.jpg/000-photo.jpg 2x",
            "views": 15043,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6438aced40254f23a3"
        },
        {
            "title": "Как выбрать смеситель для ванной",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-smesitel-dlya-vannoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-smesitel-dlya-vannoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-smesitel-dlya-vannoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 12005,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6538aced40254f23a4"
        },
        // {
        //     "title": "10 трендов в отделке ванной комнаты — 2020",
        //     "description": "",
        //     "type": "Вдохновиться",
        //     "type_slug": "be-inspired",
        //     "dept": "Сантехника",
        //     "dept_slug": "santehnika",
        //     "date_publish": "05.10.2021",
        //     "link": "10-trendov-v-otdelke-vannoy-komnaty-2020br-",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/10-trendov-v-otdelke-vannoy-komnaty-2020/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/10-trendov-v-otdelke-vannoy-komnaty-2020/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 12574,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 11,
        //     "id": "648aca6538aced40254f23a5"
        // },
        {
            "title": "Как выбрать качественный и удобный унитаз",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "20.05.2023",
            "link": "kak-vybrat-kachestvennyy-i-udobnyy-unitaz",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-kachestvennyy-i-udobnyy-unitaz/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-kachestvennyy-i-udobnyy-unitaz/000-photo.jpg/000-photo.jpg 2x",
            "views": 10814,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6538aced40254f23a6"
        },
        {
            "title": "Как выбрать фитинги",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-fitingi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-fitingi/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-fitingi/000-hero.jpg/000-hero.jpg 2x",
            "views": 8981,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca6538aced40254f23a7"
        },
        {
            "title": "Как использовать гофротрубу для раковины",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-ispolzovat-gofrotrubu-dlya-rakoviny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ispolzovat-gofrotrubu-dlya-rakoviny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ispolzovat-gofrotrubu-dlya-rakoviny/000-photo.jpg/000-photo.jpg 2x",
            "views": 8176,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6538aced40254f23a8"
        },
        {
            "title": "Как установить котел",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "20.08.2022",
            "link": "kak-ustanovit-kotel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kotly_otoplenya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kotly_otoplenya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6752,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6638aced40254f23a9"
        },
        {
            "title": "Как выбрать циркуляционный насос",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.03.2022",
            "link": "kak-vybrat-cirkulyacionnyy-nasos",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-tsirkulyatsionnyy-nasos/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-tsirkulyatsionnyy-nasos/000-photo.jpg/000-photo.jpg 2x",
            "views": 6638,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6638aced40254f23aa"
        },
        {
            "title": "Применение ДВП при строительстве и отделке",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "primenenie-dvp-pri-stroitelstve-i-otdelke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/primenenie-dvp-v-stroitelstve-dachnogo-doma/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/primenenie-dvp-v-stroitelstve-dachnogo-doma/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 8073,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca6638aced40254f23ac"
        },
        {
            "title": "Решения для выравнивания стен",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "resheniya-dlya-vyravnivaniya-sten",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/resheniya-dlya-vyravnivaniya-sten/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/resheniya-dlya-vyravnivaniya-sten/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14499,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6638aced40254f23ad"
        },
        {
            "title": "Как обшить стены панелями ПВХ",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "20.05.2023",
            "link": "kak-obshit-steny-panelyami-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-obshit-steny-panelyami-pvh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-obshit-steny-panelyami-pvh/000-photo.jpg/000-photo.jpg 2x",
            "views": 11953,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6638aced40254f23ae"
        },
        {
            "title": "Как выбрать террасную доску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-terrasnuyu-dosku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat-terrasnuyu-dosku/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vibrat-terrasnuyu-dosku/Photo.jpg/Photo.jpg 2x",
            "views": 11013,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6738aced40254f23af"
        },
        {
            "title": "Советы по внутренней отделке бани",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "sovety-po-vnutrenney-otdelke-bani",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-vnutrenney-otdelke-bani/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-vnutrenney-otdelke-bani/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13715,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca6738aced40254f23b0"
        },
        {
            "title": "Как установить розетки при скрытой электропроводке",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-rozetki-i-vyklyuchateli-pri-skrytoy-elektroprovodke",
            "preview_srcset": " https://cdn.lemanapro.ru/lmru/image/upload/v1776272150/fudzi/advice/montazh-skritoy-elektroprovodki-ustanovka-rozetok-000-photo.jpg/montazh-skritoy-elektroprovodki-ustanovka-rozetok-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/v1776272150/fudzi/advice/montazh-skritoy-elektroprovodki-ustanovka-rozetok-000-photo.jpg/montazh-skritoy-elektroprovodki-ustanovka-rozetok-000-photo.jpg 2x",
            "views": 8385,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6738aced40254f23b1"
        },
        // {
        //     "title": "Как выбрать вагонку",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Столярные изделия",
        //     "dept_slug": "stolyarnye-izdeliya",
        //     "date_publish": "05.10.2021",
        //     "link": "kak-vybrat-vagonku",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vybrat-vagonku/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vybrat-vagonku/Photo.jpg/Photo.jpg 2x",
        //     "views": 9252,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 9,
        //     "id": "648aca6738aced40254f23b2"
        // },
        {
            "title": "Этапы чернового ремонта в квартире новостройки",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "etapy-chernovogo-remonta-v-kvartire-novostroyki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/etapy-chernovogo-remonta-v-kvartire-novostroyki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/etapy-chernovogo-remonta-v-kvartire-novostroyki/000-photo.jpg/000-photo.jpg 2x",
            "views": 4736,
            "total_comment": 3,
            "is_video": false,
            "likes": 14,
            "id": "648aca6838aced40254f23b3"
        },
        {
            "title": "Установка розеток и выключателей при открытой электропроводке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "ustanovka-rozetok-i-vyklyuchateley-pri-otkrytoy-elektroprovodke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13351,
            "total_comment": 0,
            "is_video": true,
            "likes": 12,
            "id": "648aca6838aced40254f23b4"
        },
        {
            "title": "Как подключить счетчик электроэнергии",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-podklyuchit-schetchik-elektroenergii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1777390822/fudzi/advice/kak-podkluchit-schetchik-elektroeenergii-000-photo.jpg/kak-podkluchit-schetchik-elektroeenergii-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1777390822/fudzi/advice/kak-podkluchit-schetchik-elektroeenergii-000-photo.jpg/kak-podkluchit-schetchik-elektroeenergii-000-photo.jpg 2x",
            "views": 14245,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6838aced40254f23b5"
        },
        {
            "title": "Как правильно установить видеодомофон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-pravilno-ustanovit-videodomofon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/-kak-pravilno-ustanovit-videodomofon/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/-kak-pravilno-ustanovit-videodomofon/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14663,
            "total_comment": 0,
            "is_video": true,
            "likes": 13,
            "id": "648aca6838aced40254f23b6"
        },
        {
            "title": "Как смонтировать кабель для обогрева труб",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-smontirovat-kabel-dlya-obogreva-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-smontirovat-kabel-dlya-obogreva-trub/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-smontirovat-kabel-dlya-obogreva-trub/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 5111,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6838aced40254f23b7"
        },
        {
            "title": "Виды соединения проводов",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "vidy-soedineniya-provodov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidy-soedineniya-provodov/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidy-soedineniya-provodov/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10790,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca6838aced40254f23b8"
        },
        {
            "title": "Выбор деревянных и пластиковых подоконников",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "23.03.2022",
            "link": "vybor-derevyannyh-i-plastikovyh-podokonnikov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-derevyannyh-i-plastikovyh-podokonnikov/ooo_hero.jpg/ooo_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-derevyannyh-i-plastikovyh-podokonnikov/ooo_hero.jpg/ooo_hero.jpg 2x",
            "views": 10490,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca6938aced40254f23b9"
        },
        {
            "title": "Как смонтировать окно ПВХ",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "22.03.2022",
            "link": "kak-smontirovat-okno-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-smontirovat-okno-pvh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-smontirovat-okno-pvh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10847,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6938aced40254f23ba"
        },
        {
            "title": "Виды деревянных оконных блоков для загородного дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "vidy-derevyannyh-okonnyh-blokov-dlya-zagorodnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vidy-derevyannyh-okonnyh-blokov-dlya-zagorodnogo-doma/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vidy-derevyannyh-okonnyh-blokov-dlya-zagorodnogo-doma/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13213,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca6938aced40254f23bb"
        },
        {
            "title": "Как отрегулировать пластиковые окна",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "19.10.2021",
            "link": "kak-otregulirovat-plastikovye-okna",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat-plastikovye-okna/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat-plastikovye-okna/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6848,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6938aced40254f23bc"
        },
        {
            "title": "Укладка террасной доски из ДПК",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "ukladka-terrasnoy-doski-iz-dpk",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ukladka-terrasnoy-doski-iz-dpk/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ukladka-terrasnoy-doski-iz-dpk/Photo.jpg/Photo.jpg 2x",
            "views": 15089,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6938aced40254f23bd"
        },
        {
            "title": "Как установить мансардное окно",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-mansardnoe-okno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-mansardnoe-okno/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-mansardnoe-okno/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7240,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6a38aced40254f23be"
        },
        {
            "title": "Инструкции по замеру окон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "instrukcii-po-zameru-okon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/instrukcii-po-zameru-okon/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/instrukcii-po-zameru-okon/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13567,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca6a38aced40254f23bf"
        },
        {
            "title": "Как уложить террасную доску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ulozhit-terrasnuyu-dosku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ulozhit-terrasnuyu-dosku/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ulozhit-terrasnuyu-dosku/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9773,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6a38aced40254f23c0"
        },
        {
            "title": "Как сделать полок в бане",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-polok-v-bane",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat-polok-v-bane/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat-polok-v-bane/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4208,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6a38aced40254f23c1"
        },
        {
            "title": "Ежегодный уход за ступенями лестницы",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "ezhegodnyy-uhod-za-stupenyami-lestnicy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ezhegodnyy-uhod-za-stupenyami-lestnicy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ezhegodnyy-uhod-za-stupenyami-lestnicy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14337,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca6a38aced40254f23c2"
        },
        {
            "title": "Как обустроить дачную мансарду своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-obustroit-dachnuyu-mansardu-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obustroit-dachnuyu-mansardu-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-obustroit-dachnuyu-mansardu-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 8718,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca6b38aced40254f23c3"
        },
        {
            "title": "Как отремонтировать кровлю дачного дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.10.2021",
            "link": "kak-otremontirovat-krovlyu-dachnogo-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-otremontirovat-krovlyu-dachnogo-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-otremontirovat-krovlyu-dachnogo-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 10861,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6b38aced40254f23c4"
        },
        // {
        //     "title": "Как установить гардеробную систему",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Столярные изделия",
        //     "dept_slug": "stolyarnye-izdeliya",
        //     "date_publish": "05.10.2021",
        //     "link": "kak-vybrat-material-dlya-otdelki-sten",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/preview-for-video/preview-kak-ustanovit-garderobnuyu-sistemu-01.jpg/preview-kak-ustanovit-garderobnuyu-sistemu-01.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/preview-for-video/preview-kak-ustanovit-garderobnuyu-sistemu-01.jpg/preview-kak-ustanovit-garderobnuyu-sistemu-01.jpg 2x",
        //     "views": 11844,
        //     "total_comment": 0,
        //     "is_video": true,
        //     "likes": 5,
        //     "id": "648aca6b38aced40254f23c5"
        // },
        {
            "title": "Термодревесина: особенности и варианты использования",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "termodrevesina-osobennosti-i-varianty-ispolzovaniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/termodrevesina-osobennosti-i-varianty-ispolzovaniya/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/termodrevesina-osobennosti-i-varianty-ispolzovaniya/Photo.jpg/Photo.jpg 2x",
            "views": 14509,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6c38aced40254f23c8"
        },
        {
            "title": "Как выполнить обшивку вагонкой из ПВХ",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-vypolnit-obshivku-vagonkoy-iz-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vypolnit-obshivku-vagonkoy-iz-pvkh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-vypolnit-obshivku-vagonkoy-iz-pvkh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 5904,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca6c38aced40254f23ca"
        },
        {
            "title": "Как смонтировать гаражные ворота",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-smontirovat-garazhnye-vorota",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-smontirovat-garazhnye-vorota/ooo_hero.jpg/ooo_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-smontirovat-garazhnye-vorota/ooo_hero.jpg/ooo_hero.jpg 2x",
            "views": 5313,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca6c38aced40254f23cb"
        },
        {
            "title": "Выбор фанеры и ее применение",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "19.10.2021",
            "link": "vybor-fanery-i-ee-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-fanery-i-ee-primenenie/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-fanery-i-ee-primenenie/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 10496,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca6c38aced40254f23cc"
        },
        {
            "title": "Укладка на пол террасной и палубной доски из дерева",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "ukladka-na-pol-terrasnoy-i-palubnoy-doski-iz-dereva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ukladka-terrasnoy-i-palubnoy-doski-iz-dereva/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/ukladka-terrasnoy-i-palubnoy-doski-iz-dereva/Photo.jpg/Photo.jpg 2x",
            "views": 7574,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca6d38aced40254f23cd"
        },
        {
            "title": "Монтаж электрического теплого пола",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "montazh-elektricheskogo-teplogo-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-elektricheskogo-teplogo-pola/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-elektricheskogo-teplogo-pola/Photo.jpg/Photo.jpg 2x",
            "views": 4173,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca6d38aced40254f23ce"
        },
        {
            "title": "Как сделать открытую электропроводку",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "kak-sdelat-otkrytuyu-elektroprovodku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1777393677/fudzi/advice/kak-sdelat-otkrituy-elektroprovodku-000-photo.jpg/kak-sdelat-otkrituy-elektroprovodku-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1777393677/fudzi/advice/kak-sdelat-otkrituy-elektroprovodku-000-photo.jpg/kak-sdelat-otkrituy-elektroprovodku-000-photo.jpg 2x",
            "views": 15542,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca6d38aced40254f23cf"
        },
        {
            "title": "Установка розеток и выключателей при скрытой электропроводке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "ustanovka-rozetok-i-vyklyuchateley-pri-skrytoy-elektroprovodke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ustanovka-rozetok-i-vyklyuchateley-pri-skrytoy-elektroprovodke/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ustanovka-rozetok-i-vyklyuchateley-pri-skrytoy-elektroprovodke/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16034,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6d38aced40254f23d0"
        },
        {
            "title": "Обогреватель или электрокамин",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "obogrevatel-ili-elektrokamin",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/obogrevatel-ili-elektrokamin/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/obogrevatel-ili-elektrokamin/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16598,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca6e38aced40254f23d2"
        },
        {
            "title": "Монтаж теплого пленочного пола",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "montazh-plenochnogo-teplogo-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-plenochnogo-teplogo-pola/Photo.jpg/Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/montazh-plenochnogo-teplogo-pola/Photo.jpg/Photo.jpg 2x",
            "views": 15537,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6e38aced40254f23d3"
        },
        {
            "title": "Тёплые полы",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "teplye-poly",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/teplye-poly/hero.jpg/hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/teplye-poly/hero.jpg/hero.jpg 2x",
            "views": 5161,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6e38aced40254f23d4"
        },
        {
            "title": "Как выбрать стабилизатор",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-stabilizator",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-stabilizator/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-stabilizator/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12261,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca6e38aced40254f23d5"
        },
        {
            "title": "Как выбрать увлажнитель воздуха",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-uvlazhnitel-vozduha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-uvlazhnitel-vozduha/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-uvlazhnitel-vozduha/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14827,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca6e38aced40254f23d6"
        },
        {
            "title": "Чем отличаются переключатели от выключателей",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "19.10.2021",
            "link": "chem-otlichayutsya-pereklyuchateli-ot-vyklyuchateley",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichayutsya-pereklyuchateli-ot-vyklyuchateley/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichayutsya-pereklyuchateli-ot-vyklyuchateley/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4900,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6f38aced40254f23d7"
        },
        {
            "title": "Использование розетки с таймером (реле времени)",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "ispolzovanie-rozetki-s-taymerom-rele-vremeni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ispolzovanie-rozetki-s-taymerom/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ispolzovanie-rozetki-s-taymerom/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16119,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca6f38aced40254f23d8"
        },
        {
            "title": "Как использовать влагостойкие широкоформатные панели МДФ",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "19.10.2021",
            "link": "kak-ispolzovat-vlagostoykie-shirokoformatnye-paneli-mdf",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ispolzovat-vlagostoykie-shirokoformatnye-paneli-mdf/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ispolzovat-vlagostoykie-shirokoformatnye-paneli-mdf/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16370,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca6f38aced40254f23d9"
        },
        {
            "title": "Выбор окон ПВХ для квартиры и дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "vybor-okon-pvh-dlya-kvartiry-i-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-okon-pvh-dlya-kvartiry-i-doma/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/vybor-okon-pvh-dlya-kvartiry-i-doma/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 7033,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6f38aced40254f23da"
        },
        {
            "title": "Советы по строительству бани",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "sovety-po-stroitelstvu-bani",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-stroitelstvu-bani/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-stroitelstvu-bani/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 13018,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca6f38aced40254f23db"
        },
        {
            "title": "Как установить откосы на окнах",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-otkosy-na-oknah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-otkosy-na-oknah/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-otkosy-na-oknah/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 11652,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7038aced40254f23dc"
        },
        {
            "title": "Как установить балконную дверь ПВХ",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-balkonnuyu-dver-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-balkonnuyu-dver-pvh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-balkonnuyu-dver-pvh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 8743,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7038aced40254f23dd"
        },
        {
            "title": "Советы по выбору пластиковых окон",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "22.03.2022",
            "link": "sovety-po-vyboru-plastikovyh-okon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-vyboru-plastikovyh-okon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/sovety-po-vyboru-plastikovyh-okon/000-photo.jpg/000-photo.jpg 2x",
            "views": 10573,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7038aced40254f23de"
        },
        {
            "title": "Периодический уход за механизмами окон ПВХ",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "periodicheskiy-uhod-za-mehanizmami-okon-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/periodicheskiy-uhod-za-mehanizmami-okon-pvh/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/periodicheskiy-uhod-za-mehanizmami-okon-pvh/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16656,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7038aced40254f23df"
        },
        {
            "title": "Виды термоусадочных трубок",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "vidy-i-primenenie-termousadochnykh-trubok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidy-i-primenenie-termousadochnykh-trubok/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidy-i-primenenie-termousadochnykh-trubok/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 9447,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7038aced40254f23e0"
        },
        {
            "title": "Использование удлинителей по параметрам",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.10.2021",
            "link": "ispolzovanie-udliniteley-v-sootvetstvii-s-ikh-elektronnymi-parametrami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ispolzovanie-udliniteley-v-sootvetstvii-s-ikh-elektronnymi-parametrami/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/ispolzovanie-udliniteley-v-sootvetstvii-s-ikh-elektronnymi-parametrami/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15428,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7138aced40254f23e1"
        },
        {
            "title": "Как собрать ПНД трубы (фитинги)",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-sobrat-pnd-truby-fitingi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sobrat-pnd-truby-fitingi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sobrat-pnd-truby-fitingi/000-photo.jpg/000-photo.jpg 2x",
            "views": 13876,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7138aced40254f23e2"
        },
        {
            "title": "Виды труб",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "vidy-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-trub/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-trub/000-photo.jpg/000-photo.jpg 2x",
            "views": 15144,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca7138aced40254f23e3"
        },
        {
            "title": "Как установить санитарный насос",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-sanitarnyy-nasos",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-ustanovit-sanitarnyy-nasos/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-ustanovit-sanitarnyy-nasos/000-photo.jpg/000-photo.jpg 2x",
            "views": 10834,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7138aced40254f23e4"
        },
        {
            "title": "Как выбрать водонагреватель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-vodonagrevatel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-vodonagrevatel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-vodonagrevatel/000-photo.jpg/000-photo.jpg 2x",
            "views": 12122,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7138aced40254f23e5"
        },
        {
            "title": "Шесть способов спрятать радиаторы отопления",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "shest-sposobov-spryatat-radiatory-otopleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/shest-sposobov-spryatat-radiatory-otopleniya/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/shest-sposobov-spryatat-radiatory-otopleniya/000-hero.jpg/000-hero.jpg 2x",
            "views": 6797,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7238aced40254f23e6"
        },
        {
            "title": "Требования к отбору проб воды",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "trebovaniya-k-otboru-prob-vody",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/trebovaniya-k-otboru-prob-vody/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/trebovaniya-k-otboru-prob-vody/000-photo.jpg/000-photo.jpg 2x",
            "views": 5375,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7238aced40254f23e7"
        },
        {
            "title": "Виды проточных фильтров",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "19.10.2021",
            "link": "vidy-protochnyh-filtrov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-protochnykh-filtrov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-protochnykh-filtrov/000-photo.jpg/000-photo.jpg 2x",
            "views": 12613,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7238aced40254f23e8"
        },
        {
            "title": "Методы борьбы с цветением водоема",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "22.08.2022",
            "link": "metody-borby-s-cveteniem-vodoema",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/metody-borby-s-tsveteniem-vodoema/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/metody-borby-s-tsveteniem-vodoema/000-photo.jpg/000-photo.jpg 2x",
            "views": 5521,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca7238aced40254f23e9"
        },
        {
            "title": "Как самостоятельно собрать готовое решение по автополиву",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-samostoyatelno-sobrat-gotovoe-reshenie-po-avtopolivu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-samostoyatelno-sobrat-gotovoe-reshenie-po-avtopolivu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-samostoyatelno-sobrat-gotovoe-reshenie-po-avtopolivu/000-photo.jpg/000-photo.jpg 2x",
            "views": 9900,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca7238aced40254f23ea"
        },
        {
            "title": "Как продлить жизнь срезанным цветам",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "13.02.2023",
            "link": "kak-prodlit-zhizn-srezannym-cvetam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-prodlit-zhizn-srezannym-cvetam/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-prodlit-zhizn-srezannym-cvetam/000-photo.jpg/000-photo.jpg 2x",
            "views": 15828,
            "total_comment": 1,
            "is_video": false,
            "likes": 11,
            "id": "648aca7238aced40254f23eb"
        },
        {
            "title": "Уход за садовой мебелью, зимнее хранение",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "uhod-za-sadovoy-mebelyu-zimnee-hranenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/ukhod-za-sadovoy-mebelyu-zimnee-khranenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/ukhod-za-sadovoy-mebelyu-zimnee-khranenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 7382,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7338aced40254f23ec"
        },
        {
            "title": "Техника безопасности при работе с садовым измельчителем",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "29.07.2022",
            "link": "tehnika-bezopasnosti-pri-rabote-s-sadovym-izmelchitelem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/tekhnika-bezopasnosti-pri-rabote-s-sadovym-izmelchitelem/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/tekhnika-bezopasnosti-pri-rabote-s-sadovym-izmelchitelem/000-photo.jpg/000-photo.jpg 2x",
            "views": 5652,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7338aced40254f23ed"
        },
        {
            "title": "Как сделать грядки своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "14.02.2023",
            "link": "kak-sdelat-gryadki-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-stelat'-gryadki-svoimi-rukami-sterl/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-stelat'-gryadki-svoimi-rukami-sterl/000-photo.jpg/000-photo.jpg 2x",
            "views": 11471,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7338aced40254f23ee"
        },
        {
            "title": "Материалы для сооружения теплицы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "materialy-dlya-sooruzheniya-teplicy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/materialy-dlya-sooruzheniya-teplicy/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/materialy-dlya-sooruzheniya-teplicy/000-hero.jpg/000-hero.jpg 2x",
            "views": 6388,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7338aced40254f23ef"
        },
        {
            "title": "Советы эксперта: как правильно подстричь газон",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "03.10.2022",
            "link": "sovety-eksperta-kak-pravilno-podstrich-gazon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/sovety-eksperta-kak-pravilno-podstrich-gazon/main.png/main.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/sovety-eksperta-kak-pravilno-podstrich-gazon/main.png/main.png 2x",
            "views": 7357,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7338aced40254f23f0"
        },
        {
            "title": "Как подготовить сад к зиме",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-podgotovit-sad-k-zime",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-podgotovit-sad-k-zime/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-podgotovit-sad-k-zime/000-photo.jpg/000-photo.jpg 2x",
            "views": 14248,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7438aced40254f23f1"
        },
        // {
        //     "title": "Пять способов украсить окно с помощью комнатных растений",
        //     "description": "",
        //     "type": "Вдохновиться",
        //     "type_slug": "be-inspired",
        //     "dept": "Сад",
        //     "dept_slug": "sad",
        //     "date_publish": "29.05.2023",
        //     "link": "pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnyh-rasteniy1",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnykh-rasteniy/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnykh-rasteniy/main.jpg/main.jpg 2x",
        //     "views": 7704,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 10,
        //     "id": "648aca7438aced40254f23f2"
        // },
        {
            "title": "Как обрезать ветки или спилить дерево",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "14.11.2022",
            "link": "kak-obrezat-vetki-ili-spilit-derevo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-obrezat-vetki-ili-spilit-derevo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-obrezat-vetki-ili-spilit-derevo/000-photo.jpg/000-photo.jpg 2x",
            "views": 11279,
            "total_comment": 1,
            "is_video": false,
            "likes": 14,
            "id": "648aca7438aced40254f23f3"
        },
        {
            "title": "Как выбрать ножницы для живой изгороди",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "27.04.2022",
            "link": "kak-vybrat-nozhnicy-dlya-zhivoy-izgorodi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nozhnitsy-dlya-zhivoy-izgorodi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nozhnitsy-dlya-zhivoy-izgorodi/000-photo.jpg/000-photo.jpg 2x",
            "views": 13432,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7438aced40254f23f4"
        },
        {
            "title": "Ёлочные украшения: виды и советы по использованию",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "16.11.2022",
            "link": "elochnye-ukrasheniya-vidy-i-sovety-po-ispolzovaniyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/elochnye-ukrasheniya-vidy-i-sovety-po-ispolzovaniyu/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/elochnye-ukrasheniya-vidy-i-sovety-po-ispolzovaniyu/main.jpg/main.jpg 2x",
            "views": 5807,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7438aced40254f23f5"
        },
        {
            "title": "Выбор травы для газона",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "17.08.2022",
            "link": "vybor-travy-dlya-gazona",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybor-travy-dlya-gazona/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybor-travy-dlya-gazona/000-hero.jpg/000-hero.jpg 2x",
            "views": 5335,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7438aced40254f23f6"
        },
        {
            "title": "Как выбрать аэратор и вертикуттер",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-aerator-i-vertikutter",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-aerator-i-vertikutter/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-aerator-i-vertikutter/main.jpg/main.jpg 2x",
            "views": 8115,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7538aced40254f23f7"
        },
        {
            "title": "Как выбрать и сажать хвойники?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "14.02.2023",
            "link": "kak-vybrat-i-sazhat-hvoyniki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-i-sazhat-hvojniki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-i-sazhat-hvojniki/000-photo.jpg/000-photo.jpg 2x",
            "views": 13133,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7538aced40254f23f8"
        },
        {
            "title": "Видео-совет: Как содержать газон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "video-sovet-kak-soderzhat-gazon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovetpodgotovka-k-rabote-i-obsluzhivanie-gazonokosilki/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovetpodgotovka-k-rabote-i-obsluzhivanie-gazonokosilki/000-hero.jpg/000-hero.jpg 2x",
            "views": 9449,
            "total_comment": 0,
            "is_video": true,
            "likes": 12,
            "id": "648aca7538aced40254f23f9"
        },
        {
            "title": "Как выбрать цилиндр",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-cilindr",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-tsilindr/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-tsilindr/000-photo.jpg/000-photo.jpg 2x",
            "views": 8666,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7538aced40254f23fa"
        },
        {
            "title": "Как выбрать дверные петли",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-dvernye-petli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-dvernye-petli/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-dvernye-petli/000-photo.jpg/000-photo.jpg 2x",
            "views": 10345,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7538aced40254f23fb"
        },
        {
            "title": "Использование дюбеля в гипсокартоне",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "19.10.2021",
            "link": "ispolzovanie-dyubelya-v-gipsokartone",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/ispolzovanie-dyubelya-v-gipsokartone/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/ispolzovanie-dyubelya-v-gipsokartone/000-photo.jpg/000-photo.jpg 2x",
            "views": 8496,
            "total_comment": 0,
            "is_video": true,
            "likes": 15,
            "id": "648aca7638aced40254f23fc"
        },
        {
            "title": "Установка дверных замков",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "ustanovka-dvernyh-zamkov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/ustanovka-dvernykh-zamkov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/ustanovka-dvernykh-zamkov/000-photo.jpg/000-photo.jpg 2x",
            "views": 7149,
            "total_comment": 0,
            "is_video": true,
            "likes": 12,
            "id": "648aca7638aced40254f23fd"
        },
        {
            "title": "Как выбрать дверную ручку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "19.08.2022",
            "link": "kak-vybrat-dvernuyu-ruchku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-dvernuyu-ruchku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-dvernuyu-ruchku/000-photo.jpg/000-photo.jpg 2x",
            "views": 12366,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7638aced40254f23fe"
        },
        {
            "title": "Видео-совет: Как правильно заготовить компост",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "video-sovet-kak-pravilno-zagotovit-kompost",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-kak-pravilno-zagotovit-kompost/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-kak-pravilno-zagotovit-kompost/000-photo.jpg/000-photo.jpg 2x",
            "views": 8385,
            "total_comment": 0,
            "is_video": true,
            "likes": 10,
            "id": "648aca7638aced40254f23ff"
        },
        {
            "title": "Видео-совет: Подготовка к работе и обслуживание триммера",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "video-sovet-podgotovka-k-rabote-i-obsluzhivanie-trimmera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-podgotovka-k-rabote-i-obsluzhivanie-trimmera/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-podgotovka-k-rabote-i-obsluzhivanie-trimmera/000-photo.jpg/000-photo.jpg 2x",
            "views": 10236,
            "total_comment": 0,
            "is_video": true,
            "likes": 12,
            "id": "648aca7638aced40254f2400"
        },
        {
            "title": "Как сажать розы и ухаживать за ними",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "07.04.2022",
            "link": "kak-sazhat-rozy-i-uhazhivat-za-nimi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sazhat-rozy-i-uhazhivat-za-nimi/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sazhat-rozy-i-uhazhivat-za-nimi/000-photo.png/000-photo.png 2x",
            "views": 15205,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648aca7638aced40254f2402"
        },
        {
            "title": "Видео-совет: Как правильно подготовить и засеять газон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "video-sovet-kak-pravilno-podgotovit-i-zaseyat-gazon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-kak-pravilno-podgotovit-i-zaseyat-gazon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/video-sovet-kak-pravilno-podgotovit-i-zaseyat-gazon/000-photo.jpg/000-photo.jpg 2x",
            "views": 13969,
            "total_comment": 0,
            "is_video": true,
            "likes": 7,
            "id": "648aca7738aced40254f2403"
        },
        {
            "title": "Как установить дверную ручку на розетке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-dvernuyu-ruchku-na-rozetke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dvernuyu-ruchku-na-rozetke/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dvernuyu-ruchku-na-rozetke/000-photo.jpg/000-photo.jpg 2x",
            "views": 11452,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7738aced40254f2404"
        },
        {
            "title": "Как прикрепить тяжелые предметы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-prikrepit-tyazhelye-predmety",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1774432055/fudzi/advice/kak-prikrepit-tyazhelye-predmety-000-photo.jpg/kak-prikrepit-tyazhelye-predmety-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1774432055/fudzi/advice/kak-prikrepit-tyazhelye-predmety-000-photo.jpg/kak-prikrepit-tyazhelye-predmety-000-photo.jpg 2x",
            "views": 12475,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7738aced40254f2405"
        },
        {
            "title": "Как обеспечить безопасность в доме для ребенка",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "07.09.2022",
            "link": "kak-obespechit-bezopasnost-v-dome-dlya-rebenka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-obespechit-bezopasnost-v-dome-dlya-rebenka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-obespechit-bezopasnost-v-dome-dlya-rebenka/000-photo.jpg/000-photo.jpg 2x",
            "views": 7523,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca7738aced40254f2406"
        },
        {
            "title": "Выбираем дверные ручки исходя из материала, формы и конструкции",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "vybiraem-dvernye-ruchki-ishodya-iz-materiala-formy-i-konstrukcii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vybiraem-dvernye-ruchki-iskhodya-iz-materiala/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vybiraem-dvernye-ruchki-iskhodya-iz-materiala/000-photo.jpg/000-photo.jpg 2x",
            "views": 8561,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7738aced40254f2407"
        },
        {
            "title": "Защита окон от детей и домашних животных",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "19.08.2022",
            "link": "zashchita-okon-ot-detey-i-domashnih-zhivotnyh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/zashchita-okon-ot-detey-i-domashnikh-zhivotnykh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/zashchita-okon-ot-detey-i-domashnikh-zhivotnykh/000-photo.jpg/000-photo.jpg 2x",
            "views": 10856,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7838aced40254f2408"
        },
        {
            "title": "Как разбить газон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-razbit-gazon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-razbit-gazon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-razbit-gazon/000-photo.jpg/000-photo.jpg 2x",
            "views": 4346,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7838aced40254f2409"
        },
        {
            "title": "Как выбрать садовый измельчитель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-sadovyy-izmelchitel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-sadovyy-izmelchitel/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-sadovyy-izmelchitel/000-hero.jpg/000-hero.jpg 2x",
            "views": 8847,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca7838aced40254f240a"
        },
        {
            "title": "Как подобрать цветочный горшок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "06.04.2022",
            "link": "kak-podobrat-cvetochnyy-gorshok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-podobrat-tsvetochnyy-gorshok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-podobrat-tsvetochnyy-gorshok/000-photo.jpg/000-photo.jpg 2x",
            "views": 14140,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7838aced40254f240b"
        },
        {
            "title": "Как выбрать ёлку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "16.11.2022",
            "link": "kak-vybrat-elku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-novogodnyuyu-elku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-novogodnyuyu-elku/000-photo.jpg/000-photo.jpg 2x",
            "views": 5577,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7838aced40254f240c"
        },
        {
            "title": "Как выбрать садовый тент",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-sadovyy-tent",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-sadovyy-tent/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-sadovyy-tent/000-photo.jpg/000-photo.jpg 2x",
            "views": 5208,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7938aced40254f240d"
        },
        {
            "title": "Виды дюбелей и их применение",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "vidy-dyubeley-i-ih-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidy-dubeley-i-ih-primenenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidy-dubeley-i-ih-primenenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 6174,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7938aced40254f240e"
        },
        {
            "title": "Как бороться с гололедом эффективно и безопасно",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-borotsya-s-gololedom-effektivno-i-bezopasno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-borotsya-s-gololedom-effektivno-i-bezopasno/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-borotsya-s-gololedom-effektivno-i-bezopasno/000-hero.jpg/000-hero.jpg 2x",
            "views": 9089,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7938aced40254f2410"
        },
        {
            "title": "Как выбрать навесной замок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-navesnoy-zamok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-navesnoy-zamok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-navesnoy-zamok/000-photo.jpg/000-photo.jpg 2x",
            "views": 8260,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7938aced40254f2411"
        },
        {
            "title": "Выбираем новогоднюю ёлку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vybiraem-novogodnyuyu-elku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-novogodnyuyu-elku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-novogodnyuyu-elku/000-photo.jpg/000-photo.jpg 2x",
            "views": 9080,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7938aced40254f2412"
        },
        {
            "title": "Как выбрать насос для полива участка",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-nasos-dlya-poliva-uchastka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nasos-dlya-poliva-uchastka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nasos-dlya-poliva-uchastka/000-photo.jpg/000-photo.jpg 2x",
            "views": 7467,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7a38aced40254f2413"
        },
        {
            "title": "Ковка: как сделать проект?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "04.07.2022",
            "link": "kovka-kak-sdelat-proekt",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kovka-kak-sdelat-proekt/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kovka-kak-sdelat-proekt/000-photo.png/000-photo.png 2x",
            "views": 15258,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca7a38aced40254f2414"
        },
        {
            "title": "Как установить дверную ручку-кноб",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-ustanovit-dvernuyu-ruchku-knob",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dvernuyu-ruchku-knob/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-ustanovit-dvernuyu-ruchku-knob/000-photo.jpg/000-photo.jpg 2x",
            "views": 15590,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7a38aced40254f2415"
        },
        {
            "title": "Флюгер — оригинальное украшение дома",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "flyuger-originalnoe-ukrashenie-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/flyuger-originalnoe-ukrashenie-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/flyuger-originalnoe-ukrashenie-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 13571,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca7a38aced40254f2416"
        },
        {
            "title": "Как собрать мебель",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "26.07.2022",
            "link": "kak-sobrat-mebel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sobrat-mebel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sobrat-mebel/000-photo.jpg/000-photo.jpg 2x",
            "views": 7483,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7a38aced40254f2417"
        },
        {
            "title": "Виды канализационных труб",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.03.2022",
            "link": "vidy-kanalizacionnyh-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-kanalizatsionnykh-trub/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-kanalizatsionnykh-trub/000-photo.jpg/000-photo.jpg 2x",
            "views": 7511,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7b38aced40254f2419"
        },
        {
            "title": "Технология подключения проточного водонагревателя",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.03.2022",
            "link": "tehnologiya-podklyucheniya-protochnogo-vodonagrevatelya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/tekhnologiya-podklyucheniya-protochnogo-vodonagrevatelya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/tekhnologiya-podklyucheniya-protochnogo-vodonagrevatelya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6390,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7b38aced40254f241a"
        },
        {
            "title": "Виды коллекторов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "vidy-kollektorov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-kollektorov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-kollektorov/000-photo.jpg/000-photo.jpg 2x",
            "views": 10339,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7b38aced40254f241b"
        },
        {
            "title": "Виды электрических отопительных котлов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.03.2022",
            "link": "vidy-elektricheskih-otopitelnyh-kotlov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-elektricheskikh-otopitelnykh-kotlov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-elektricheskikh-otopitelnykh-kotlov/000-photo.jpg/000-photo.jpg 2x",
            "views": 7396,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca7b38aced40254f241c"
        },
        {
            "title": "Как выбрать и подключить радиатор отопления. Материал, количество секций, схемы монтажа",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-i-podklyuchit-radiator-otopleniya-material-kolichestvo-sekciy-shemy-montazha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-i-podklyuchit-radiator-otopleniya-material-kolichestvo-sekciy-shemy-montazha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-i-podklyuchit-radiator-otopleniya-material-kolichestvo-sekciy-shemy-montazha/000-photo.jpg/000-photo.jpg 2x",
            "views": 12737,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648aca7c38aced40254f241d"
        },
        {
            "title": "Клуб мастеров. Делаем подсвечник в стиле лофт из медных труб",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "klub-masterov-delaem-podsvechnik-v-stile-loft-iz-mednyh-trub",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/klub-masterov-delaem-podsvechnik-v-stile-loft-iz-mednyh-trub/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/klub-masterov-delaem-podsvechnik-v-stile-loft-iz-mednyh-trub/000-photo.jpg/000-photo.jpg 2x",
            "views": 5614,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca7c38aced40254f241e"
        },
        {
            "title": "Как выбрать полотенцесушитель",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.03.2022",
            "link": "kak-vybrat-polotencesushitel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-polotentsesushitel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-polotentsesushitel/000-photo.jpg/000-photo.jpg 2x",
            "views": 5222,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca7c38aced40254f241f"
        },
        {
            "title": "Как выбрать и установить фонтан в садовом пруду",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-i-ustanovit-fontan-v-sadovom-prudu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-i-ustanovit-fontan-v-sadovom-prudu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-i-ustanovit-fontan-v-sadovom-prudu/000-photo.jpg/000-photo.jpg 2x",
            "views": 13645,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca7c38aced40254f2420"
        },
        {
            "title": "Как выбрать качели",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "07.04.2022",
            "link": "kak-vybrat-kacheli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-kacheli/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-kacheli/000-photo.png/000-photo.png 2x",
            "views": 15444,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca7c38aced40254f2421"
        },
        {
            "title": "Выбираем растения для балкона и лоджии",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vybiraem-rasteniya-dlya-balkona-i-lodzhii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-rasteniya-dlya-balkona-i-lodzhii/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-rasteniya-dlya-balkona-i-lodzhii/000-photo.jpg/000-photo.jpg 2x",
            "views": 12289,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7d38aced40254f2422"
        },
        {
            "title": "Как выбрать гамак",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-gamak",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-gamak/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-gamak/000-photo.jpg/000-photo.jpg 2x",
            "views": 13189,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca7d38aced40254f2423"
        },
        {
            "title": "Голубое опрыскивание, или опрыскивание бордоской жидкостью",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "goluboe-opryskivanie-ili-opryskivanie-bordoskoy-zhidkostyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/goluboe-opryskivanie-ili-opryskivanie-bordoskoy-zhidkostyu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/goluboe-opryskivanie-ili-opryskivanie-bordoskoy-zhidkostyu/000-photo.jpg/000-photo.jpg 2x",
            "views": 6662,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7d38aced40254f2424"
        },
        {
            "title": "Как выбрать мангал",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-mangal",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-mangal/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-mangal/000-hero.jpg/000-hero.jpg 2x",
            "views": 8383,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7d38aced40254f2425"
        },
        {
            "title": "Как выбрать котел отопления",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-kotel-otopleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-kotel-otopleniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-kotel-otopleniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15610,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca7d38aced40254f2426"
        },
        // {
        //     "title": "Как выбрать гибкую подводку",
        //     "description": "",
        //     "type": "Как выбрать",
        //     "type_slug": "how-to-choose",
        //     "dept": "Водоснабжение",
        //     "dept_slug": "vodosnabzhenie",
        //     "date_publish": "05.04.2022",
        //     "link": "kak-vybrat-gibkuyu-podvodku1",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-gibkuyu-podvodku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-gibkuyu-podvodku/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 15348,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 7,
        //     "id": "648aca7e38aced40254f2427"
        // },
        {
            "title": "Старт дачного сезона. Как вырастить здоровую рассаду",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "12.01.2022",
            "link": "start-dachnogo-sezona-kak-vyrastit-zdorovuyu-rassadu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/start-dachnogo-sezona-kak-vyrastit-zdorovuyu-rassadu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/start-dachnogo-sezona-kak-vyrastit-zdorovuyu-rassadu/000-photo.jpg/000-photo.jpg 2x",
            "views": 12531,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca7e38aced40254f2428"
        },
        {
            "title": "Как выбрать навесное оборудование для культиватора и мотоблока",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-navesnoe-oborudovanie-dlya-kultivatora-i-motobloka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-navesnoe-oborudovanie-dlya-kultivatora-i-motobloka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-navesnoe-oborudovanie-dlya-kultivatora-i-motobloka/000-photo.jpg/000-photo.jpg 2x",
            "views": 4886,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca7e38aced40254f2429"
        },
        {
            "title": "Как выбрать насос для откачки воды",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-nasos-dlya-otkachki-vody",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nasos-dlya-otkachki-vody/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-nasos-dlya-otkachki-vody/000-photo.jpg/000-photo.jpg 2x",
            "views": 12300,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7e38aced40254f242a"
        },
        {
            "title": "Как нарядить елку к Новому году: 4 примера оформления",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "16.11.2022",
            "link": "kak-naryadit-elku-k-novomu-godu-4-primera-oformleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/kak-naryadit-elku-k-novomu-godu-4-primera-oformleniya/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/kak-naryadit-elku-k-novomu-godu-4-primera-oformleniya/main.jpg/main.jpg 2x",
            "views": 13787,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca7e38aced40254f242b"
        },
        {
            "title": "Видео-совет: Обслуживание бензопилы",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "10.11.2022",
            "link": "video-sovet-obsluzhivanie-benzopily",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-pravilno-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/preview-for-video/video-sovet-kak-pravilno-ulozhit-laminat/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6135,
            "total_comment": 0,
            "is_video": true,
            "likes": 10,
            "id": "648aca7e38aced40254f242c"
        },
        {
            "title": "Зимняя сказка своими руками: 6 способов преобразить интерьер к Новому году",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "16.11.2022",
            "link": "zimnyaya-skazka-svoimi-rukami-6-sposobov-preobrazit-interer-k-novomu-godu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zimnyaya-skazka-svoimi-rukami-6-sposobov-preobrazit-interer-k-novomu-godu/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zimnyaya-skazka-svoimi-rukami-6-sposobov-preobrazit-interer-k-novomu-godu/main.jpg/main.jpg 2x",
            "views": 13409,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca7f38aced40254f242d"
        },
        {
            "title": "Пять способов украсить окно с помощью комнатных растений",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "06.06.2023",
            "link": "pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnyh-rasteniy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnyh-rasteniy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/pyat-sposobov-ukrasit-okno-s-pomoshchyu-komnatnyh-rasteniy/000-photo.jpg/000-photo.jpg 2x",
            "views": 10621,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca7f38aced40254f242e"
        },
        {
            "title": "Делаем вместе: как обустроить зимний сад на балконе",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "delaem-vmeste-kak-obustroit-zimniy-sad-na-balkone",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/delaem-vmeste-kak-obustroit-zimniy-sad-na-balkone/main.png/main.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/delaem-vmeste-kak-obustroit-zimniy-sad-na-balkone/main.png/main.png 2x",
            "views": 10971,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca7f38aced40254f242f"
        },
        {
            "title": "Виды навесного оборудования для культиватора",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vidy-navesnogo-oborudovaniya-dlya-kultivatora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vidy-navesnogo-oborudovaniya-dlya-kultivatora/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vidy-navesnogo-oborudovaniya-dlya-kultivatora/000-photo.jpg/000-photo.jpg 2x",
            "views": 9103,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7f38aced40254f2430"
        },
        {
            "title": "Как организовать мини-сад на кухне",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "12.01.2022",
            "link": "kak-organizovat-mini-sad-na-kuhne",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice/sad/kak-organizovat-mini-sad-na-kuhne/Как_организовать_мини_сад_на_кухне_1500х553.jpg/Как_организовать_мини_сад_на_кухне_1500х553.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice/sad/kak-organizovat-mini-sad-na-kuhne/Как_организовать_мини_сад_на_кухне_1500х553.jpg/Как_организовать_мини_сад_на_кухне_1500х553.jpg 2x",
            "views": 5780,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca7f38aced40254f2431"
        },
        {
            "title": "Как сделать рождественский венок своими руками",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "20.05.2023",
            "link": "kak-sdelat-rozhdestvenskiy-venok-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat-rozhdestvenskiy-venok-svoimi-rukami/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-sdelat-rozhdestvenskiy-venok-svoimi-rukami/main.jpg/main.jpg 2x",
            "views": 7522,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8038aced40254f2432"
        },
        {
            "title": "Как выбрать магистральный фильтр",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-vybrat-magistralnyy-filtr",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-magistralnyy-filtr/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-vybrat-magistralnyy-filtr/000-photo.jpg/000-photo.jpg 2x",
            "views": 6567,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8038aced40254f2433"
        },
        {
            "title": "Альпийская горка",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "alpiyskaya-gorka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/alpiyskaya-gorka/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/alpiyskaya-gorka/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12780,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca8038aced40254f2434"
        },
        {
            "title": "Как выбрать мотоблок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-motoblok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-motoblok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-motoblok/000-photo.jpg/000-photo.jpg 2x",
            "views": 6986,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8038aced40254f2435"
        },
        {
            "title": "Монтируем правильный узел ввода водоснабжения в квартире",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "20.05.2023",
            "link": "montiruem-pravilnyy-uzel-vvoda-vodosnabzheniya-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/montiruem-pravilnyy-uzel-vvoda-vodosnabzheniya-v-kvartire/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/montiruem-pravilnyy-uzel-vvoda-vodosnabzheniya-v-kvartire/000-photo.jpg/000-photo.jpg 2x",
            "views": 10984,
            "total_comment": 5,
            "is_video": false,
            "likes": 5,
            "id": "648aca8038aced40254f2436"
        },
        {
            "title": "Подготовка к работе и обслуживание бензиновых триммеров",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "podgotovka-k-rabote-i-obsluzhivanie-benzinovyh-trimmerov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/preview-for-video/ooo_hero.jpg/ooo_hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/preview-for-video/ooo_hero.jpg/ooo_hero.jpg 2x",
            "views": 5748,
            "total_comment": 0,
            "is_video": true,
            "likes": 7,
            "id": "648aca8038aced40254f2437"
        },
        {
            "title": "Как продлить жизнь живой ели",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-prodlit-zhizn-zhivoy-eli",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-prodlit-zhizn-zhivoy-eli/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-prodlit-zhizn-zhivoy-eli/000-photo.jpg/000-photo.jpg 2x",
            "views": 5475,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca8138aced40254f2438"
        },
        {
            "title": "Как правильно организовать автополив в теплице",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "27.04.2022",
            "link": "kak-pravilno-organizovat-avtopoliv-v-teplice",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-organizovat-avtopoliv-v-teplice/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-organizovat-avtopoliv-v-teplice/000-photo.jpg/000-photo.jpg 2x",
            "views": 15626,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8138aced40254f2439"
        },
        {
            "title": "Как спланировать и установить уличные новогодние гирлянды",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-splanirovat-i-ustanovit-ulichnye-novogodnie-girlyandy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-splanirovat-i-ustanovit-ulichnye-novogodnie-girlyandy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-splanirovat-i-ustanovit-ulichnye-novogodnie-girlyandy/000-photo.jpg/000-photo.jpg 2x",
            "views": 15855,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8138aced40254f243a"
        },
        {
            "title": "Как правильно обрабатывать фруктовые деревья весной",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "20.02.2023",
            "link": "kak-pravilno-obrabatyvat-fruktovye-derevya-vesnoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravil'no-obrabativat'-fruktovie-derev'ya-vesnoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravil'no-obrabativat'-fruktovie-derev'ya-vesnoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 13193,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8138aced40254f243b"
        },
        {
            "title": "Как правильно использовать удобрения для растений",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-pravilno-ispolzovat-udobreniya-dlya-rasteniy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-ispolzovat-udobreniya-dlya-rasteniy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-ispolzovat-udobreniya-dlya-rasteniy/000-photo.jpg/000-photo.jpg 2x",
            "views": 5734,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8138aced40254f243c"
        },
        {
            "title": "Виды жидкотопливных котлов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "14.03.2022",
            "link": "vidy-zhidkotoplivnyh-kotlov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-zhidkotoplivnykh-kotlov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/vidy-zhidkotoplivnykh-kotlov/000-photo.jpg/000-photo.jpg 2x",
            "views": 15563,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca8138aced40254f243d"
        },
        {
            "title": "Как подключить водонагреватель",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "18.07.2022",
            "link": "kak-podklyuchit-vodonagrevatel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-podklyuchit-vodonagrevatel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-podklyuchit-vodonagrevatel/000-photo.jpg/000-photo.jpg 2x",
            "views": 11269,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca8238aced40254f243e"
        },
        {
            "title": "Что нужно знать, выбирая систему обратного осмоса",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "21.04.2022",
            "link": "chto-nuzhno-znat-vybiraya-sistemu-obratnogo-osmosa",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-nuzhno-znat-vybiraya-sistemu-obratnogo-osmosa/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-nuzhno-znat-vybiraya-sistemu-obratnogo-osmosa/000-photo.jpg/000-photo.jpg 2x",
            "views": 10148,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8238aced40254f243f"
        },
        {
            "title": "Как устранить протечку трубы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-ustranit-protechku-truby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustranit-protechku-truby/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustranit-protechku-truby/000-photo.jpg/000-photo.jpg 2x",
            "views": 5783,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8238aced40254f2440"
        },
        {
            "title": "Как спроектировать водяной теплый пол",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "05.10.2021",
            "link": "kak-sproektirovat-vodyanoy-teplyy-pol",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sproektirovat-vodyanoy-teplyy-pol/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-sproektirovat-vodyanoy-teplyy-pol/000-photo.jpg/000-photo.jpg 2x",
            "views": 10079,
            "total_comment": 1,
            "is_video": false,
            "likes": 7,
            "id": "648aca8238aced40254f2441"
        },
        {
            "title": "Как выбрать газонокосилку для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-gazonokosilku-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-gazonokosilku-dlya-dachi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-gazonokosilku-dlya-dachi/000-photo.jpg/000-photo.jpg 2x",
            "views": 5792,
            "total_comment": 1,
            "is_video": false,
            "likes": 15,
            "id": "648aca8238aced40254f2442"
        },
        {
            "title": "Как выбрать триммер для дачи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "20.05.2023",
            "link": "kak-vybrat-trimmer-dlya-dachi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-trimmer-dlya-dachi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-vybrat-trimmer-dlya-dachi/000-photo.jpg/000-photo.jpg 2x",
            "views": 15685,
            "total_comment": 0,
            "is_video": true,
            "likes": 11,
            "id": "648aca8338aced40254f2443"
        },
        {
            "title": "Выбираем мебель для дачи, террасы и балкона: материалы",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vybiraem-mebel-dlya-dachi-terrasy-i-balkona-materialy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-mebel-dlya-dachi-terrasy-i-balkona-materialy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-mebel-dlya-dachi-terrasy-i-balkona-materialy/000-photo.jpg/000-photo.jpg 2x",
            "views": 6133,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8338aced40254f2444"
        },
        {
            "title": "Выбираем мебель для дачи, террасы и балкона: виды мебели для различных территорий",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vybiraem-mebel-dlya-dachi-terrasy-i-balkona-vidy-mebeli-dlya-razlichnyh-territoriy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-mebel-dlya-dachi-terrasy-i-balkona-vidy-mebeli-dlya-razlichnyh-territoriy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vybiraem-mebel-dlya-dachi-terrasy-i-balkona-vidy-mebeli-dlya-razlichnyh-territoriy/000-photo.jpg/000-photo.jpg 2x",
            "views": 7042,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8338aced40254f2445"
        },
        {
            "title": "Восемь советов для дачников: как превратить огород в произведение искусства",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "vosem-sovetov-dlya-dachnikov-kak-prevratit-ogorod-v-proizvedenie-iskusstva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vosem-sovetov-dlya-dachnikov-kak-prevratit-ogorod-v-proizvedenie-iskusstva/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/vosem-sovetov-dlya-dachnikov-kak-prevratit-ogorod-v-proizvedenie-iskusstva/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14701,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8338aced40254f2446"
        },
        {
            "title": "Уход за газоном после зимы",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "uhod-za-gazonom-posle-zimy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/uhod-za-gazonom-posle-zimy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/uhod-za-gazonom-posle-zimy/000-photo.jpg/000-photo.jpg 2x",
            "views": 14593,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8338aced40254f2447"
        },
        {
            "title": "Как правильно точить цепь бензопилы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "kak-pravilno-tochit-cep-benzopily",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-tochit-cep-benzopily/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-pravilno-tochit-cep-benzopily/000-photo.jpg/000-photo.jpg 2x",
            "views": 5102,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8438aced40254f2448"
        },
        {
            "title": "Лучшие растения для ваших комнат",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "20.05.2023",
            "link": "luchshie-rasteniya-dlya-vashih-komnat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/luchshie-rasteniya-dlya-vashikh-komnat/main.png/main.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/luchshie-rasteniya-dlya-vashikh-komnat/main.png/main.png 2x",
            "views": 14390,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8438aced40254f2449"
        },
        {
            "title": "Новый год на даче: готовимся к зимним праздникам",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "novyy-god-na-dache-gotovimsya-k-zimnim-prazdnikam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/novyy-god-na-dache-gotovimsya-k-zimnim-prazdnikam/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/novyy-god-na-dache-gotovimsya-k-zimnim-prazdnikam/main.jpg/main.jpg 2x",
            "views": 9547,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8438aced40254f244a"
        },
        {
            "title": "Как уложить садовый паркет",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "14.02.2023",
            "link": "kak-ulozhit-sadovyy-parket",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ulozhit-sadovyj-parket/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ulozhit-sadovyj-parket/000-photo.jpg/000-photo.jpg 2x",
            "views": 6196,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca8438aced40254f244b"
        },
        {
            "title": "Новогодние гирлянды для елки и внутреннего интерьера",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "19.10.2021",
            "link": "novogodnie-girlyandy-dlya-elki-i-vnutrennego-interera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zimnyaya-skazka-svoimi-rukami-6-sposobov-preobrazit-interer-k-novomu-godu/main.jpg/main.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/zimnyaya-skazka-svoimi-rukami-6-sposobov-preobrazit-interer-k-novomu-godu/main.jpg/main.jpg 2x",
            "views": 6700,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8438aced40254f244c"
        },
        {
            "title": "Монтажная пена: как выбрать и использовать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "montazhnaya-pena-kak-vybrat-i-ispolzovat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/preview-for-video/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 4162,
            "total_comment": 0,
            "is_video": true,
            "likes": 6,
            "id": "648aca8538aced40254f244d"
        },
        {
            "title": "Как правильно пользоваться химическим анкером: новые технологии крепежа",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "05.10.2021",
            "link": "kak-pravilno-polzovatsya-himicheskim-ankerom-novye-tehnologii-krepezha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-pravilno-polzovatsya-himicheskim-ankerom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-pravilno-polzovatsya-himicheskim-ankerom/000-photo.jpg/000-photo.jpg 2x",
            "views": 4761,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648aca8538aced40254f244e"
        },
        {
            "title": "Виды и использование бытового клея",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "vidy-i-ispolzovanie-bytovogo-kleya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-i-ispolzovanie-bytovogo-kleya/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-i-ispolzovanie-bytovogo-kleya/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 16391,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8538aced40254f2450"
        },
        {
            "title": "Виды затирок",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "vidy-zatirok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-zatirok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-zatirok/000-photo.jpg/000-photo.jpg 2x",
            "views": 8980,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8538aced40254f2451"
        },
        {
            "title": "Виды и использование клеев-герметиков для напольных покрытий",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "vidy-i-ispolzovanie-kleev-germetikov-dlya-napolnyh-pokrytiy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-i-ispolzovanie-kleev-germetikov-dlya-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-i-ispolzovanie-kleev-germetikov-dlya-napolnykh-pokrytiy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 12325,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8538aced40254f2452"
        },
        {
            "title": "Как покрасить стены в полоску",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-steny-v-polosku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kraski-kak-pokrasit-steny-v-polosku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kraski-kak-pokrasit-steny-v-polosku/000-photo.jpg/000-photo.jpg 2x",
            "views": 8880,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8638aced40254f2453"
        },
        {
            "title": "Окраска и грунтовка фасадов",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "11.07.2022",
            "link": "okraska-i-gruntovka-fasadov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/okraska-i-gruntovka-fasadov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/okraska-i-gruntovka-fasadov/000-photo.jpg/000-photo.jpg 2x",
            "views": 15468,
            "total_comment": 3,
            "is_video": false,
            "likes": 11,
            "id": "648aca8638aced40254f2454"
        },
        {
            "title": "Виды клеев ПВА",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.03.2022",
            "link": "vidy-kleev-pva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-kleev-pva/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-kleev-pva/000-photo.jpg/000-photo.jpg 2x",
            "views": 6457,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8638aced40254f2455"
        },
        {
            "title": "Виды средств против плесени",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "vidy-sredstv-protiv-pleseni",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-sredstv-protiv-pleseni/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-sredstv-protiv-pleseni/000-photo.jpg/000-photo.jpg 2x",
            "views": 10806,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca8638aced40254f2456"
        },
        {
            "title": "Предварительная обработка перед покраской",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "predvaritelnaya-obrabotka-pered-pokraskoy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/predvaritelnaya-obrabotka-pered-pokraskoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/predvaritelnaya-obrabotka-pered-pokraskoy/000-photo.jpg/000-photo.jpg 2x",
            "views": 11909,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8638aced40254f2457"
        },
        {
            "title": "Чем покрасить пол. Гид по краскам и лакам",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "chem-pokrasit-pol-gid-po-kraskam-i-lakam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit-pol-gid-po-kraskam-i-lakam/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-pokrasit-pol-gid-po-kraskam-i-lakam/000-photo.jpg/000-photo.jpg 2x",
            "views": 14697,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8738aced40254f2458"
        },
        {
            "title": "Виды герметиков",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "20.05.2023",
            "link": "vidy-germetikov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1775561640/fudzi/advice/vidi-germetikov-000-photo.jpg/vidi-germetikov-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1775561640/fudzi/advice/vidi-germetikov-000-photo.jpg/vidi-germetikov-000-photo.jpg 2x ",
            "views": 6861,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8738aced40254f2459"
        },
        {
            "title": "Выбираем краски Luxens для стен и потолка",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "vybiraem-kraski-luxens-dlya-sten-i-potolka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vybiraem-kraski-luxens-dlya-sten-i-potolka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vybiraem-kraski-luxens-dlya-sten-i-potolka/000-photo.jpg/000-photo.jpg 2x",
            "views": 12894,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca8738aced40254f245b"
        },
        {
            "title": "Как правильно использовать монтажную пену",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pravilno-ispolzovat-montazhnuyu-penu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-ispolzovat-montazhnuyu-penu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pravilno-ispolzovat-montazhnuyu-penu/000-photo.jpg/000-photo.jpg 2x",
            "views": 11434,
            "total_comment": 1,
            "is_video": false,
            "likes": 9,
            "id": "648aca8738aced40254f245c"
        },
        {
            "title": "Как покрасить ванную комнату",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-vannuyu-komnatu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-vannuyu-komnatu/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-vannuyu-komnatu/000-hero.jpg/000-hero.jpg 2x",
            "views": 15419,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8838aced40254f245d"
        },
        {
            "title": "Как покрасить крышу",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-derevyannyy-pol",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/как-покрасить-крышу/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/как-покрасить-крышу/000-photo.jpg/000-photo.jpg 2x",
            "views": 10715,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8838aced40254f245e"
        },
        {
            "title": "Как покрасить деревянный пол",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-derevyannyy-pol1",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannyy-pol/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannyy-pol/000-photo.jpg/000-photo.jpg 2x",
            "views": 11472,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8838aced40254f245f"
        },
        {
            "title": "Как покрасить деревянную дверь",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-derevyannuyu-dver",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannuyu-dver/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannuyu-dver/000-photo.jpg/000-photo.jpg 2x",
            "views": 9014,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8838aced40254f2460"
        },
        {
            "title": "Как покрасить деревянные окна",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-derevyannye-okna",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannye-okna/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannye-okna/000-photo.jpg/000-photo.jpg 2x",
            "views": 10496,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8838aced40254f2461"
        },
        {
            "title": "Как покрыть лаком деревянную дверь",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokryt-lakom-derevyannuyu-dver",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokryt-lakom-derevyannuyu-dver/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokryt-lakom-derevyannuyu-dver/000-photo.jpg/000-photo.jpg 2x",
            "views": 8821,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8938aced40254f2463"
        },
        {
            "title": "Как покрасить напольный плинтус",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-napolnyy-plintus",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-napolnyy-plintus/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-napolnyy-plintus/000-photo.jpg/000-photo.jpg 2x",
            "views": 15767,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8938aced40254f2464"
        },
        {
            "title": "Как покрасить обои",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "11.07.2022",
            "link": "kak-pokrasit-oboi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-oboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-oboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 11029,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca8938aced40254f2465"
        },
        {
            "title": "Как покрасить плинтус потолочный",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-plintus-potolochnyy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-plintus-potolochnyy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-plintus-potolochnyy/000-photo.jpg/000-photo.jpg 2x",
            "views": 7215,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8938aced40254f2466"
        },
        // {
        //     "title": "Чем обезжирить металл перед покраской",
        //     "description": "",
        //     "type": "Как сделать",
        //     "type_slug": "how-to-make",
        //     "dept": "Краски",
        //     "dept_slug": "kraski",
        //     "date_publish": "23.11.2022",
        //     "link": "chem-obezzhirit-metall-pered-pokraskoy1",
        //     "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-obezzhirit-metall-pered-pokraskoy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chem-obezzhirit-metall-pered-pokraskoy/000-photo.jpg/000-photo.jpg 2x",
        //     "views": 6843,
        //     "total_comment": 0,
        //     "is_video": false,
        //     "likes": 7,
        //     "id": "648aca8938aced40254f2467"
        // },
        {
            "title": "Как применять монтажные пены",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-primenyat-montazhnye-peny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-primenyat-montazhnye-peny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-primenyat-montazhnye-peny/000-photo.jpg/000-photo.jpg 2x",
            "views": 7331,
            "total_comment": 1,
            "is_video": false,
            "likes": 9,
            "id": "648aca8a38aced40254f2468"
        },
        {
            "title": "Как удалить двухсторонний скотч",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "10.11.2022",
            "link": "kak-udalit-dvuhstoronniy-skotch",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-udalit-dvukhstoronniy-skotch/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-udalit-dvukhstoronniy-skotch/000-photo.jpg/000-photo.jpg 2x",
            "views": 8593,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8a38aced40254f2469"
        },
        {
            "title": "Как покрасить деревянный дом",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-derevyannyy-dom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannyy-dom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-derevyannyy-dom/000-photo.jpg/000-photo.jpg 2x",
            "views": 6558,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8a38aced40254f246a"
        },
        {
            "title": "Контактные клеи",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kontaktnye-klei",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kontaktnye-klei/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kontaktnye-klei/000-photo.jpg/000-photo.jpg 2x",
            "views": 10881,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8a38aced40254f246b"
        },
        {
            "title": "Оформление стены: как расположить и скомбинировать рамки и картины",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "11.07.2022",
            "link": "oformlenie-steny-kak-raspolozhit-i-skombinirovat-ramki-i-kartiny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oformlenie-steny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/oformlenie-steny/000-photo.jpg/000-photo.jpg 2x",
            "views": 13177,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8a38aced40254f246c"
        },
        {
            "title": "Как клеить стеклообои",
            "description": "Делаем вместе: функциональная прихожая",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.08.2022",
            "link": "kak-kleit-steklooboi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-steklooboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-kleit-steklooboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 14526,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8b38aced40254f246d"
        },
        {
            "title": "Как правильно установить рулонную штору",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "19.10.2021",
            "link": "kak-pravilno-ustanovit-rulonnuyu-shtoru",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravilno-ustanovit-rulonnuyu-shtoru/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-pravilno-ustanovit-rulonnuyu-shtoru/000-photo.jpg/000-photo.jpg 2x",
            "views": 11282,
            "total_comment": 0,
            "is_video": true,
            "likes": 13,
            "id": "648aca8b38aced40254f246e"
        },
        {
            "title": "Как покрасить потолок",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "04.07.2022",
            "link": "kak-pokrasit-potolok",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-potolok/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-potolok/000-photo.jpg/000-photo.jpg 2x",
            "views": 15841,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8b38aced40254f246f"
        },
        {
            "title": "Выбор цвета",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.03.2022",
            "link": "vybor-cveta",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vybor-tsveta/000-photo.png/000-photo.png 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vybor-tsveta/000-photo.png/000-photo.png 2x",
            "views": 10288,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8b38aced40254f2470"
        },
        {
            "title": "Как нанести краску или штукатурку на фасад дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-nanesti-krasku-ili-shtukaturku-na-fasad-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1776092874/fudzi/advice/kak-nanesti-krasku-ili-shtukaturku-000-photo.jpg/kak-nanesti-krasku-ili-shtukaturku-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1776092874/fudzi/advice/kak-nanesti-krasku-ili-shtukaturku-000-photo.jpg/kak-nanesti-krasku-ili-shtukaturku-000-photo.jpg 2x",
            "views": 11096,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8b38aced40254f2471"
        },
        {
            "title": "Как выбрать антисептики",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "10.11.2022",
            "link": "kak-vybrat-antiseptiki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-antiseptiki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-antiseptiki/000-photo.jpg/000-photo.jpg 2x",
            "views": 13283,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8b38aced40254f2472"
        },
        {
            "title": "Как выбрать клей для внутренних и наружных облицовочных работ",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-kley-dlya-vnutrennih-i-naruzhnyh-oblicovochnyh-rabot",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-kley-dlya-vnutrennikh-i-naruzhnykh-oblitsovochnykh-rabot/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-kley-dlya-vnutrennikh-i-naruzhnykh-oblitsovochnykh-rabot/000-photo.jpg/000-photo.jpg 2x",
            "views": 11428,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8c38aced40254f2473"
        },
        {
            "title": "Инструменты для уборки",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "instrumenty-dlya-uborki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/instrumenty-dlya-uborki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/instrumenty-dlya-uborki/000-photo.jpg/000-photo.jpg 2x",
            "views": 5403,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca8c38aced40254f2474"
        },
        {
            "title": "Защита древесины",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "zashchita-drevesiny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/zashchita-drevesiny/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/zashchita-drevesiny/000-photo.jpg/000-photo.jpg 2x",
            "views": 13433,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca8c38aced40254f2475"
        },
        {
            "title": "Готовые красочные идеи для вашего дома",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "gotovye-krasochnye-idei-dlya-vashego-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/gotovye-krasochnye-idei-dlya-vashego-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/gotovye-krasochnye-idei-dlya-vashego-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 9717,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8c38aced40254f2476"
        },
        {
            "title": "Гид по монтажным лентам: как выбрать самоклеющееся крепление",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "19.11.2019",
            "link": "gid-po-montazhnym-lentam-kak-vybrat-samokleyushcheesya-kreplenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/gid-po-montazhnym-lentam-kak-vybrat-samokleyushcheesya-kreplenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/gid-po-montazhnym-lentam-kak-vybrat-samokleyushcheesya-kreplenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 9629,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8c38aced40254f2477"
        },
        {
            "title": "Виды красок, их назначение",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "10.08.2022",
            "link": "vidy-krasok-ih-naznachenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-krasok-ikh-naznachenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/vidy-krasok-ikh-naznachenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 11720,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca8d38aced40254f2478"
        },
        {
            "title": "Виды монтажной пены",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "04.07.2022",
            "link": "vidy-montazhnoy-peny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/v1775556181/fudzi/advice/raznovidnosty-montazhnoy-peni-000-photo.jpg/raznovidnosty-montazhnoy-peni-000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/v1775556181/fudzi/advice/raznovidnosty-montazhnoy-peni-000-photo.jpg/raznovidnosty-montazhnoy-peni-000-photo.jpg 2x",
            "views": 8888,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8d38aced40254f2479"
        },
        {
            "title": "Как нанести антисептик для защиты деревянных стен дома",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "05.04.2022",
            "link": "kak-nanesti-antiseptik-dlya-zashchity-derevyannyh-sten-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanesti-antiseptik-dlya-zashchity-derevyannykh-sten-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanesti-antiseptik-dlya-zashchity-derevyannykh-sten-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 4471,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca8d38aced40254f247a"
        },
        {
            "title": "Как привести в порядок дачный участок после зимы",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-privesti-v-poryadok-dachnyy-uchastok-posle-zimy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-privesti-v-poryadok-dachnyy-uchastok-posle-zimy/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-privesti-v-poryadok-dachnyy-uchastok-posle-zimy/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 6965,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8d38aced40254f247b"
        },
        {
            "title": "Дачные дела: выбираем оформление забора",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.03.2022",
            "link": "dachnye-dela-vybiraem-oformlenie-zabora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/dachnye-dela-vybiraem-oformlenie-zabora/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/dachnye-dela-vybiraem-oformlenie-zabora/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 14774,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca8d38aced40254f247c"
        },
        {
            "title": "Как выбрать краскопульт",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-kraskopult",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-kraskopult/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-kraskopult/000-photo.jpg/000-photo.jpg 2x",
            "views": 5620,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca8d38aced40254f247d"
        },
        {
            "title": "Как использовать антисептики",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-ispolzovat-antiseptiki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-antiseptiki/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-antiseptiki/000-hero.jpg/000-hero.jpg 2x",
            "views": 7112,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca8e38aced40254f247e"
        },
        {
            "title": "Как использовать клей для облицовочных работ",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-ispolzovat-kley-dlya-oblicovochnyh-rabot",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-kley-dlya-vnutrennikh-i-naruzhnykh-oblitsovochnykh-rabot/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-kley-dlya-vnutrennikh-i-naruzhnykh-oblitsovochnykh-rabot/000-photo.jpg/000-photo.jpg 2x",
            "views": 9190,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca8e38aced40254f247f"
        },
        {
            "title": "Как использовать валики",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-ispolzovat-valiki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-valiki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-valiki/000-photo.jpg/000-photo.jpg 2x",
            "views": 7462,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca8e38aced40254f2480"
        },
        {
            "title": "Как выбрать паркетный лак",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-vybrat-parketnyy-lak",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-parketnyy-lak/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-vybrat-parketnyy-lak/000-photo.jpg/000-photo.jpg 2x",
            "views": 10132,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca8e38aced40254f2481"
        },
        {
            "title": "Как защитить поверхность при окрашивании",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-zashchitit-poverhnost-pri-okrashivanii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-zashchitit-poverkhnost-pri-okrashivanii/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-zashchitit-poverkhnost-pri-okrashivanii/000-photo.jpg/000-photo.jpg 2x",
            "views": 4725,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8e38aced40254f2482"
        },
        {
            "title": "Как наносить латексные краски",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-nanosit-lateksnye-kraski",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanosit-lateksnye-kraski/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanosit-lateksnye-kraski/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 15423,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8f38aced40254f2483"
        },
        {
            "title": "Как покрасить балкон",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "19.10.2021",
            "link": "kak-pokrasit-balkon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-balkon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-balkon/000-photo.jpg/000-photo.jpg 2x",
            "views": 8356,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8f38aced40254f2484"
        },
        {
            "title": "Как использовать краскопульт",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "14.11.2022",
            "link": "kak-ispolzovat-kraskopult",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-kraskopult/ooo_Photo.jpg/ooo_Photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-ispolzovat-kraskopult/ooo_Photo.jpg/ooo_Photo.jpg 2x",
            "views": 5866,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca8f38aced40254f2486"
        },
        {
            "title": "Как наносить венецианскую штукатурку",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "18.04.2022",
            "link": "kak-nanosit-venecianskuyu-shtukaturku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanosit-venetsianskuyu-shtukaturku/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-nanosit-venetsianskuyu-shtukaturku/000-hero.jpg/000-hero.jpg 2x",
            "views": 8547,
            "total_comment": 2,
            "is_video": false,
            "likes": 8,
            "id": "648aca8f38aced40254f2487"
        },
        {
            "title": "Фильтры для воды: рейтинг",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "11.04.2023",
            "link": "filtry-dlya-vody-reyting",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/fil'tr-dlya-vodi-reiting/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/fil'tr-dlya-vodi-reiting/000-photo.jpg/000-photo.jpg 2x",
            "views": 6883,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca8f38aced40254f2488"
        },
        {
            "title": "Как выбрать стиральную машину",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "29.11.2022",
            "link": "kak-vybrat-stiralnuyu-mashinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-stiralnuyu-mashinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vybrat-stiralnuyu-mashinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 14692,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9038aced40254f2489"
        },
        {
            "title": "Как уложить рулонный газон правильно самостоятельно",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "30.11.2022",
            "link": "kak-ulozhit-rulonnyy-gazon-pravilno-samostoyatelno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ulozhit'rulonnii-gazon-pravil'no-samostoyatel'no/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-ulozhit'rulonnii-gazon-pravil'no-samostoyatel'no/000-photo.jpg/000-photo.jpg 2x",
            "views": 4690,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9038aced40254f248a"
        },
        {
            "title": "Что такое СИП-кабель и для чего он нужен",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "29.11.2022",
            "link": "chto-takoe-sip-kabel-i-dlya-chego-on-nuzhen",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-sip-kabel'-i-dlya-chego-on-nuzhen/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-sip-kabel'-i-dlya-chego-on-nuzhen/000-photo.jpg/000-photo.jpg 2x",
            "views": 16391,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9038aced40254f248b"
        },
        {
            "title": "Рейтинг погружных и стационарных блендеров 2022",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "30.11.2022",
            "link": "reyting-pogruzhnyh-i-stacionarnyh-blenderov-2022",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-pogruzhnyh-i-stacionarnyh-blenderov-2022/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/rejting-pogruzhnyh-i-stacionarnyh-blenderov-2022/000-photo.jpg/000-photo.jpg 2x",
            "views": 5804,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9038aced40254f248c"
        },
        {
            "title": "Чем, как и когда подкормить огурцы для плодоношения",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "30.11.2022",
            "link": "chem-kak-i-kogda-podkormit-ogurcy-dlya-plodonosheniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chem-kak-i-kogda-podkormit-ogurcy-dlya-plodonosheniya/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/chem-kak-i-kogda-podkormit-ogurcy-dlya-plodonosheniya/000-hero.jpg/000-hero.jpg 2x",
            "views": 11202,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca9038aced40254f248d"
        },
        {
            "title": "Ламинат или паркетная доска, что выбрать?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "06.12.2022",
            "link": "laminat-ili-parketnaya-doska-chto-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminat-ili-parketnaya-doska-chto-vybrat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminat-ili-parketnaya-doska-chto-vybrat/000-photo.jpg/000-photo.jpg 2x",
            "views": 15292,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9138aced40254f248e"
        },
        {
            "title": "Как выбрать клеевой пистолет и правильно им пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "05.12.2022",
            "link": "kak-vybrat-kleevoy-pistolet-i-pravilno-im-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-kleevoj-pistolet-i-pravilno-im-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vybrat-kleevoj-pistolet-i-pravilno-im-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 10901,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9138aced40254f248f"
        },
        {
            "title": "Стиль лофт: пульс города в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "06.12.2022",
            "link": "stil-loft-puls-goroda-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-loft-puls-goroda-v-interere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-loft-puls-goroda-v-interere/000-photo.jpg/000-photo.jpg 2x",
            "views": 12410,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648aca9138aced40254f2490"
        },
        {
            "title": "Как покрасить оцинковку, чтобы не облезла краска",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "08.12.2022",
            "link": "kak-pokrasit-ocinkovku-chtoby-ne-oblezla-kraska",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit'-ocinkovku-chtobi-ne-oblezla-kraska/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit'-ocinkovku-chtobi-ne-oblezla-kraska/000-photo.jpg/000-photo.jpg 2x",
            "views": 13159,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9138aced40254f2491"
        },
        {
            "title": "Как настроить и отрегулировать реле давления воды для гидроаккумулятора",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "07.12.2022",
            "link": "kak-nastroit-i-otregulirovat-rele-davleniya-vody-dlya-gidroakkumulyatora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-nastroit-i-otregulirovat-rele-davleniya-vody-dlya-gidroakkumulyatora/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-nastroit-i-otregulirovat-rele-davleniya-vody-dlya-gidroakkumulyatora/000-photo.jpg/000-photo.jpg 2x",
            "views": 5966,
            "total_comment": 1,
            "is_video": false,
            "likes": 12,
            "id": "648aca9138aced40254f2492"
        },
        {
            "title": "Какую посуду использовать для сервировки новогоднего стола?",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "07.12.2022",
            "link": "kakuyu-posudu-ispolzovat-dlya-servirovki-novogodnego-stola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakuyu-posudu-ispolzovat-dlya-servirovki-novogodnego-stola/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kakuyu-posudu-ispolzovat-dlya-servirovki-novogodnego-stola/000-photo.jpg/000-photo.jpg 2x",
            "views": 7026,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9238aced40254f2493"
        },
        {
            "title": "СВЧ в духовом шкафу — что это и как этим пользоваться?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "08.12.2022",
            "link": "svch-v-duhovom-shkafu-chto-eto-i-kak-etim-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/svch-v-duhovom-shkafu-chto-ehto-i-kak-ehtim-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/svch-v-duhovom-shkafu-chto-ehto-i-kak-ehtim-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 11494,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9238aced40254f2494"
        },
        {
            "title": "Стиль неоклассика в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "02.12.2022",
            "link": "stil-neoklassika-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-neoklassika-v-interere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-neoklassika-v-interere/000-photo.jpg/000-photo.jpg 2x",
            "views": 13435,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca9238aced40254f2495"
        },
        {
            "title": "Как отрегулировать доводчик входной двери в подъезде",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "02.12.2022",
            "link": "kak-otregulirovat-dovodchik-vhodnoy-dveri-v-podezde",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat'-dovodchik-vhodnoy-vderi-v-pod'ezde/kak-otregulirovat'-dovodchik-dhodnoy-dveri-v-pod'ezde.jpg/kak-otregulirovat'-dovodchik-dhodnoy-dveri-v-pod'ezde.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-otregulirovat'-dovodchik-vhodnoy-vderi-v-pod'ezde/kak-otregulirovat'-dovodchik-dhodnoy-dveri-v-pod'ezde.jpg/kak-otregulirovat'-dovodchik-dhodnoy-dveri-v-pod'ezde.jpg 2x",
            "views": 7054,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9238aced40254f2496"
        },
        {
            "title": "Что такое перфоратор, как им работать и как выбрать перфоратор",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "01.12.2022",
            "link": "chto-takoe-perforator-kak-im-rabotat-i-kak-vybrat-perforator",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-perforator-kak-im-rabotat-i-kak-vybrat-perforator/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-perforator-kak-im-rabotat-i-kak-vybrat-perforator/000-photo.jpg/000-photo.jpg 2x",
            "views": 5320,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9338aced40254f2497"
        },
        {
            "title": "Как подключить стиральную машину к водопроводу самостоятельно",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "01.12.2022",
            "link": "kak-podklyuchit-stiralnuyu-mashinu-k-vodoprovodu-samostoyatelno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-podklyuchit-stiralnuyu-mashinu-k-vodoprovodu-samostoyatelno/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-podklyuchit-stiralnuyu-mashinu-k-vodoprovodu-samostoyatelno/000-photo.jpg/000-photo.jpg 2x",
            "views": 7070,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9338aced40254f2498"
        },
        {
            "title": "Рейтинг унитазов, напольных и подвесных, а также инсталляций к ним",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "02.12.2022",
            "link": "reyting-unitazov-napolnyh-i-podvesnyh-a-takzhe-installyaciy-k-nim",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/rejting-unitazov-napolnyh-i-podvesnyh-a-takzhe-installyacij-k-nim/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/rejting-unitazov-napolnyh-i-podvesnyh-a-takzhe-installyacij-k-nim/000-photo.jpg/000-photo.jpg 2x",
            "views": 6909,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca9338aced40254f2499"
        },
        {
            "title": "Чем почистить контакты от окисления",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "01.12.2022",
            "link": "chem-pochistit-kontakty-ot-okisleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-pochistit'-kontakti-ot-okisleniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-pochistit'-kontakti-ot-okisleniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 4469,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9338aced40254f249a"
        },
        {
            "title": "Что такое пурифайер и чем он отличается от кулера",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "02.12.2022",
            "link": "chto-takoe-purifayer-i-chem-on-otlichaetsya-ot-kulera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-purifaier-i-chem-on-otlichaet'sya-ot-kulera/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-purifaier-i-chem-on-otlichaet'sya-ot-kulera/000-photo.jpg/000-photo.jpg 2x",
            "views": 16010,
            "total_comment": 1,
            "is_video": false,
            "likes": 13,
            "id": "648aca9338aced40254f249b"
        },
        {
            "title": "Как пользоваться бензиновым триммером",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Сад",
            "dept_slug": "sad",
            "date_publish": "02.12.2022",
            "link": "kak-polzovatsya-benzinovym-trimmerom",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-polzovatsya-benzinovym-trimmerom/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/sad/kak-polzovatsya-benzinovym-trimmerom/000-photo.jpg/000-photo.jpg 2x",
            "views": 11069,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9438aced40254f249c"
        },
        {
            "title": "Дровяник на даче: как сделать своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "09.12.2022",
            "link": "drovyanik-na-dache-kak-sdelat-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/drovyanik-na-dache-kak-sdelat-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/drovyanik-na-dache-kak-sdelat-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 12760,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9438aced40254f249d"
        },
        {
            "title": "Как украсить низ ёлки красиво и чем закрыть основание ёлки?",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.12.2022",
            "link": "kak-ukrasit-niz-elki-krasivo-i-chem-zakryt-osnovanie-elki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukrasit-niz-yolki-krasivo-i-chem-zakryt-osnovanie-yolki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-ukrasit-niz-yolki-krasivo-i-chem-zakryt-osnovanie-yolki/000-photo.jpg/000-photo.jpg 2x",
            "views": 12221,
            "total_comment": 1,
            "is_video": false,
            "likes": 6,
            "id": "648aca9438aced40254f249e"
        },
        {
            "title": "Что такое планкен и где его используют",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "08.12.2022",
            "link": "chto-takoe-planken-i-gde-ego-ispolzuyut",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-planken-i-gde-ego-ispolzuyut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-planken-i-gde-ego-ispolzuyut/000-photo.jpg/000-photo.jpg 2x",
            "views": 15649,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca9438aced40254f249f"
        },
        {
            "title": "Что такое тропический душ, как его выбрать и подключить к смесителю",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.12.2022",
            "link": "chto-takoe-tropicheskiy-dush-kak-ego-vybrat-i-podklyuchit-k-smesitelyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit'-k-smesitelu/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit-k-smesitelu.jpg/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit-k-smesitelu.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit'-k-smesitelu/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit-k-smesitelu.jpg/chto-takoe-tropicheskii-dush-kak-ego-vibrat'-i-podkluchit-k-smesitelu.jpg 2x",
            "views": 11224,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9438aced40254f24a0"
        },
        {
            "title": "Как и чем заделать трещины в бетоне на улице",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "12.12.2022",
            "link": "kak-i-chem-zadelat-treshchiny-v-betone-na-ulice",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-zadelat-treshchiny-v-betone-na-ulice/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-zadelat-treshchiny-v-betone-na-ulice/000-photo.jpg/000-photo.jpg 2x",
            "views": 11157,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9538aced40254f24a1"
        },
        {
            "title": "Скандинавский стиль в интерьере: красота в простоте",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "15.12.2022",
            "link": "skandinavskiy-stil-v-interere-krasota-v-prostote",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/skandinavskii-stil'-v-interere-krasota-i-prostota/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/skandinavskii-stil'-v-interere-krasota-i-prostota/000-photo.jpg/000-photo.jpg 2x",
            "views": 8934,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9538aced40254f24a2"
        },
        {
            "title": "Как выбрать надёжный гайковёрт",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "16.12.2022",
            "link": "kak-vybrat-nadezhnyy-gaykovert",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-nadezhnii-gaikovert/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-vibrat'-nadezhnii-gaikovert/000-photo.jpg/000-photo.jpg 2x",
            "views": 9585,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9538aced40254f24a3"
        },
        {
            "title": "Как и чем покрасить ОСБ-плиты внутри и снаружи дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "12.01.2023",
            "link": "kak-i-chem-pokrasit-osb-plity-vnutri-i-snaruzhi-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-pokrasit'-pliti-osb-vnutri-i-snaruzhi-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-pokrasit'-pliti-osb-vnutri-i-snaruzhi-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 11624,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca9538aced40254f24a4"
        },
        {
            "title": "Как сделать столешницу-подоконник на кухне и в комнате?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "12.12.2022",
            "link": "kak-sdelat-stoleshnicu-podokonnik-na-kuhne-i-v-komnate",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-sdelat-stoleshnicu-podokonnik-na-kuhne-i-v-komnate/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/kak-sdelat-stoleshnicu-podokonnik-na-kuhne-i-v-komnate/000-photo.jpg/000-photo.jpg 2x",
            "views": 5935,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9538aced40254f24a5"
        },
        {
            "title": "Как установить межкомнатную дверь самостоятельно",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "12.12.2022",
            "link": "kak-ustanovit-mezhkomnatnuyu-dver-samostoyatelno",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-mezhkomnatnuyu-dver-samostoyatelno/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-ustanovit-mezhkomnatnuyu-dver-samostoyatelno/000-photo.jpg/000-photo.jpg 2x",
            "views": 7518,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9638aced40254f24a6"
        },
        {
            "title": "Формы для выпечки: как пользоваться и какие бывают?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "14.12.2022",
            "link": "formy-dlya-vypechki-kak-polzovatsya-i-kakie-byvayut",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/formi-dlya-vipechki-kak-pol'zovat'sya-i-kakie-bivaut/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/formi-dlya-vipechki-kak-pol'zovat'sya-i-kakie-bivaut/000-photo.jpg/000-photo.jpg 2x",
            "views": 4050,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca9638aced40254f24a7"
        },
        {
            "title": "Растущий стул для школьника — что это?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "19.12.2022",
            "link": "rastushchiy-stul-dlya-shkolnika-chto-eto",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/rastuchii-stol-dlya-shkol'nika-chto-eto/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/rastuchii-stol-dlya-shkol'nika-chto-eto/000-photo.jpg/000-photo.jpg 2x",
            "views": 4200,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9638aced40254f24a8"
        },
        {
            "title": "Как сделать двери в бане правильно, с козырьком и откосами",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "08.12.2022",
            "link": "kak-sdelat-dveri-v-bane-pravilno-s-kozyrkom-i-otkosami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat-dveri-v-bane-pravilno-s-kozyrkom-i-otkosami/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat-dveri-v-bane-pravilno-s-kozyrkom-i-otkosami/000-hero.jpg/000-hero.jpg 2x",
            "views": 5515,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9638aced40254f24a9"
        },
        {
            "title": "Что такое тросы и для чего они используются",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "09.12.2022",
            "link": "chto-takoe-trosy-i-dlya-chego-oni-ispolzuyutsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-takoe-trosy-i-dlya-chego-oni-ispolzuyutsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-takoe-trosy-i-dlya-chego-oni-ispolzuyutsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 14681,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9638aced40254f24aa"
        },
        {
            "title": "Что такое блок-хаус и имитация бруса и лучше ли они сайдинга",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "08.12.2022",
            "link": "chto-takoe-blok-haus-i-imitaciya-brusa-i-luchshe-li-oni-saydinga",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-blok-haus-i-imitaciya-brusa-i-luchshe-li-oni-sajdinga/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-blok-haus-i-imitaciya-brusa-i-luchshe-li-oni-sajdinga/000-photo.jpg/000-photo.jpg 2x",
            "views": 8963,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9738aced40254f24ab"
        },
        {
            "title": "Что такое бутылочница в кухонном гарнитуре, и что в ней хранить?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Кухни",
            "dept_slug": "kuhni",
            "date_publish": "09.12.2022",
            "link": "chto-takoe-butylochnica-v-kuhonnom-garniture-i-chto-v-ney-hranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-butylochnica-v-kuhonnom-garniture-i-chto-v-nej-hranit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kuhni/chto-takoe-butylochnica-v-kuhonnom-garniture-i-chto-v-nej-hranit/000-photo.jpg/000-photo.jpg 2x",
            "views": 6802,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9738aced40254f24ac"
        },
        {
            "title": "Что такое импрегнированная доска и где она применяется",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "09.12.2022",
            "link": "chto-takoe-impregnirovannaya-doska-i-gde-ona-primenyaetsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-impregnirovannaya-doska-i-gde-ona-primenyaetsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-impregnirovannaya-doska-i-gde-ona-primenyaetsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 4115,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9738aced40254f24ad"
        },
        {
            "title": "Что такое тепловая завеса, как она работает и как выбрать тепловую завесу",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "06.12.2022",
            "link": "chto-takoe-teplovaya-zavesa-kak-ona-rabotaet-i-kak-vybrat-teplovuyu-zavesu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teplovaya-zavesa-kak-ona-rabotaet-i-kak-vybrat-teplovuyu-zavesu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teplovaya-zavesa-kak-ona-rabotaet-i-kak-vybrat-teplovuyu-zavesu/000-photo.jpg/000-photo.jpg 2x",
            "views": 14074,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9738aced40254f24ae"
        },
        {
            "title": "Такелажные крепления: виды, области применения и особенности использования",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "28.12.2022",
            "link": "takelazhnye-krepleniya-vidy-oblasti-primeneniya-i-osobennosti-ispolzovaniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/takelazhnie-krepleniya-vidi-oblasti-primeneniya-i-osobennosti-ispol'zovaniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/takelazhnie-krepleniya-vidi-oblasti-primeneniya-i-osobennosti-ispol'zovaniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 9016,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9838aced40254f24af"
        },
        {
            "title": "Что такое скрытый люк-невидимка: размеры, монтаж, регулировка",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "28.12.2022",
            "link": "chto-takoe-skrytyy-lyuk-nevidimka-razmery-montazh-regulirovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/chto-takoe-skrytyj-lyuk-nevidimka-razmery-montazh-regulirovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/chto-takoe-skrytyj-lyuk-nevidimka-razmery-montazh-regulirovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 9192,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9838aced40254f24b0"
        },
        {
            "title": "Мастер-класс: как сделать напольный светильник своими руками",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "28.12.2022",
            "link": "master-klass-kak-sdelat-napolnyy-svetilnik-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/master-klass-kak-sdelat'-napol'nii-svetol'nik-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/master-klass-kak-sdelat'-napol'nii-svetol'nik-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 8605,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca9838aced40254f24b1"
        },
        {
            "title": "Как выбрать компьютерное кресло?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "28.12.2022",
            "link": "kak-vybrat-kompyuternoe-kreslo",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-komp'uternoe-kreslo/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-komp'uternoe-kreslo/000-photo.jpg/000-photo.jpg 2x",
            "views": 8125,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9838aced40254f24b2"
        },
        {
            "title": "Что такое ревизионный (сантехнический) люк. Его разновидности",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "28.12.2022",
            "link": "chto-takoe-revizionnyy-santehnicheskiy-lyuk-ego-raznovidnosti",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/chto-takoe-revizionnyj-santekhnicheskij-lyuk-ego-raznovidnosti/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/chto-takoe-revizionnyj-santekhnicheskij-lyuk-ego-raznovidnosti/000-photo.jpg/000-photo.jpg 2x",
            "views": 9930,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9838aced40254f24b3"
        },
        {
            "title": "Что такое фацет на зеркалах и стекле?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "28.12.2022",
            "link": "chto-takoe-facet-na-zerkalah-i-stekle",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-facet-na-zerkalah-i-stekle/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-facet-na-zerkalah-i-stekle/000-photo.jpg/000-photo.jpg 2x",
            "views": 12302,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca9938aced40254f24b4"
        },
        {
            "title": "Виды настенных часов: от электронных до маятниковых",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "29.12.2022",
            "link": "vidy-nastennyh-chasov-ot-elektronnyh-do-mayatnikovyh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vid-nastenih-chasov-ot-elektronnih-do-mayatnikovih/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vid-nastenih-chasov-ot-elektronnih-do-mayatnikovih/000-photo.jpg/000-photo.jpg 2x",
            "views": 13289,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9938aced40254f24b5"
        },
        {
            "title": "Как паять полипропиленовые трубы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "09.01.2023",
            "link": "kak-payat-polipropilenovye-truby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-payat'-polipropilenovie-trubi/kak-payat'-polipropilenovie-trubi.jpg/kak-payat'-polipropilenovie-trubi.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/kak-payat'-polipropilenovie-trubi/kak-payat'-polipropilenovie-trubi.jpg/kak-payat'-polipropilenovie-trubi.jpg 2x",
            "views": 6834,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "648aca9938aced40254f24b6"
        },
        {
            "title": "Что важно знать при покупке цепи",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "22.12.2022",
            "link": "chto-vazhno-znat-pri-pokupke-cepi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-vazhno-znat'-pri-pokupke-cepi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/chto-vazhno-znat'-pri-pokupke-cepi/000-photo.jpg/000-photo.jpg 2x",
            "views": 9586,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9938aced40254f24b7"
        },
        {
            "title": "Стиль бохо: дух свободы в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "21.12.2022",
            "link": "stil-boho-duh-svobody-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-boho-duh-svobodi-v-inter'ere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/stil-boho-duh-svobodi-v-inter'ere/000-photo.jpg/000-photo.jpg 2x",
            "views": 14137,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9938aced40254f24b8"
        },
        {
            "title": "Средиземноморский стиль в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "21.12.2022",
            "link": "sredizemnomorskiy-stil-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/sredizemnomorskii-stil'-v-inter'ere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/sredizemnomorskii-stil'-v-inter'ere/000-photo.jpg/000-photo.jpg 2x",
            "views": 4190,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9a38aced40254f24b9"
        },
        {
            "title": "Виды верёвок и их применение",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "21.12.2022",
            "link": "vidy-verevok-i-ih-primenenie",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidi-verevok-i-ih-primenenie/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidi-verevok-i-ih-primenenie/000-photo.jpg/000-photo.jpg 2x",
            "views": 12814,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9a38aced40254f24ba"
        },
        {
            "title": "Газовый камин для дома и дачи: как выбрать?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "21.12.2022",
            "link": "gazovyy-kamin-dlya-doma-i-dachi-kak-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/gazovii-kamin-dlya-doma-i-dachi-kak-vibrat'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/gazovii-kamin-dlya-doma-i-dachi-kak-vibrat'/000-photo.jpg/000-photo.jpg 2x",
            "views": 9486,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648aca9a38aced40254f24bb"
        },
        {
            "title": "Система выравнивания плитки — что это и как ею пользоваться?",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "26.12.2022",
            "link": "sistema-vyravnivaniya-plitki-chto-eto-i-kak-eyu-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/sistema-viravnivaniya-plitki-chto-eto-i-kak-ei-pol'zovat'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/sistema-viravnivaniya-plitki-chto-eto-i-kak-ei-pol'zovat'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 11128,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9a38aced40254f24bc"
        },
        {
            "title": "Загородный стиль в интерьере",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "25.12.2022",
            "link": "zagorodnyy-stil-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/zagorodnii-stil'-v-inter'ere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/zagorodnii-stil'-v-inter'ere/000-photo.jpg/000-photo.jpg 2x",
            "views": 9404,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9b38aced40254f24bd"
        },
        {
            "title": "Как утеплить пол в деревянном доме: популярные материалы и способы",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "05.12.2022",
            "link": "kak-uteplit-pol-v-derevyannom-dome-populyarnye-materialy-i-sposoby",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-pol-v-derevyannom-dome-populyarnye-materialy-i-sposoby/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/kak-uteplit-pol-v-derevyannom-dome-populyarnye-materialy-i-sposoby/000-hero.jpg/000-hero.jpg 2x",
            "views": 8441,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca9b38aced40254f24be"
        },
        {
            "title": "Как покрасить алюминий в домашних условиях",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "05.12.2022",
            "link": "kak-pokrasit-alyuminiy-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-alyuminij-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pokrasit-alyuminij-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 11452,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648aca9b38aced40254f24bf"
        },
        {
            "title": "Умный свет — дистанционное управление освещением",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "27.12.2022",
            "link": "umnyy-svet-distancionnoe-upravlenie-osveshcheniem",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/umnii-svet-distancionnoe-upravlenie-osvecheniem/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/umnii-svet-distancionnoe-upravlenie-osvecheniem/000-photo.jpg/000-photo.jpg 2x",
            "views": 8796,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca9b38aced40254f24c0"
        },
        {
            "title": "Виды мебельной фурнитуры для крепежа",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "27.12.2022",
            "link": "vidy-mebelnoy-furnitury-dlya-krepezha",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidi-mebel'noy-furnituri-dlya-krepezha/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/vidi-mebel'noy-furnituri-dlya-krepezha/000-photo.jpg/000-photo.jpg 2x",
            "views": 6392,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9b38aced40254f24c1"
        },
        {
            "title": "Ламинат или линолеум, что выбрать?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "26.12.2022",
            "link": "laminat-ili-linoleum-chto-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminat-i-linoleum-chto-vibrat'/laminat-ili-linoleum-chto-vibrat'.jpg/laminat-ili-linoleum-chto-vibrat'.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/laminat-i-linoleum-chto-vibrat'/laminat-ili-linoleum-chto-vibrat'.jpg/laminat-ili-linoleum-chto-vibrat'.jpg 2x",
            "views": 8074,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9c38aced40254f24c2"
        },
        {
            "title": "Газовый конвектор для отопления, его преимущества и недостатки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "09.01.2023",
            "link": "gazovyy-konvektor-dlya-otopleniya-ego-preimushchestva-i-nedostatki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/gazovii-konvektor-dlya-otopleniya-ego-preimuchestva-i-nedostatki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/gazovii-konvektor-dlya-otopleniya-ego-preimuchestva-i-nedostatki/000-photo.jpg/000-photo.jpg 2x",
            "views": 10381,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9c38aced40254f24c3"
        },
        {
            "title": "Какой пылесос выбрать для дома?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "26.12.2022",
            "link": "kakoy-pylesos-vybrat-dlya-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakoy-pilesos-vibrat'-dlya-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakoy-pilesos-vibrat'-dlya-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 10132,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9c38aced40254f24c4"
        },
        {
            "title": "Ремни и стропы для подъёма и транспортировки грузов",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "26.12.2022",
            "link": "remni-i-stropy-dlya-podema-i-transportirovki-gruzov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/remni-i-stropi-dlya-pod'ema-i-transportirovki-gruza/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/remni-i-stropi-dlya-pod'ema-i-transportirovki-gruza/000-photo.jpg/000-photo.jpg 2x",
            "views": 4404,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9c38aced40254f24c5"
        },
        {
            "title": "Что такое насос для повышения давления воды и зачем он нужен?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Водоснабжение",
            "dept_slug": "vodosnabzhenie",
            "date_publish": "27.12.2022",
            "link": "chto-takoe-nasos-dlya-povysheniya-davleniya-vody-i-zachem-on-nuzhen",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-nasos-dlya-povisheniya-vodi-i-zachem-on-nuzhen/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/vodosnabzhenie/chto-takoe-nasos-dlya-povisheniya-vodi-i-zachem-on-nuzhen/000-photo.jpg/000-photo.jpg 2x",
            "views": 9182,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648aca9d38aced40254f24c6"
        },
        {
            "title": "Что такое кельма, каких бывает видов и как выбрать подходящую",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "29.12.2022",
            "link": "chto-takoe-kelma-kakih-byvaet-vidov-i-kak-vybrat-podhodyashchuyu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-kel'ma-kakih-bivaut-vidov-i-kak-vibrat'-podhodyachuy/chto-takoe-kel'ma-kakih-bivaet-vidov-i-kak-vibrat'-podhodyachuu.jpg/chto-takoe-kel'ma-kakih-bivaet-vidov-i-kak-vibrat'-podhodyachuu.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-kel'ma-kakih-bivaut-vidov-i-kak-vibrat'-podhodyachuy/chto-takoe-kel'ma-kakih-bivaet-vidov-i-kak-vibrat'-podhodyachuu.jpg/chto-takoe-kel'ma-kakih-bivaet-vidov-i-kak-vibrat'-podhodyachuu.jpg 2x",
            "views": 4398,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9d38aced40254f24c7"
        },
        {
            "title": "Банкетки и пуфы: что это такое, виды, размеры и примеры в интерьере",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "29.12.2022",
            "link": "banketki-i-pufy-chto-eto-takoe-vidy-razmery-i-primery-v-interere",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/banketki-i-pufi-chto-eto-takoe-vidi-razmeri-i-primeri-v-inter'ere/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/banketki-i-pufi-chto-eto-takoe-vidi-razmeri-i-primeri-v-inter'ere/000-photo.jpg/000-photo.jpg 2x",
            "views": 7215,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648aca9d38aced40254f24c8"
        },
        {
            "title": "Что такое штангенциркуль и как им пользоваться",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "28.12.2022",
            "link": "chto-takoe-shtangencirkul-i-kak-im-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-shtangencirkul-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-shtangencirkul-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 5303,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648aca9d38aced40254f24c9"
        },
        {
            "title": "Махровые полотенца: как выбирать, стирать, сушить и хранить",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "27.12.2022",
            "link": "mahrovye-polotenca-kak-vybirat-stirat-sushit-i-hranit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/mahrovie-polotenca-kak-vibirat'-stirat'-sushit'-i-hranit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/mahrovie-polotenca-kak-vibirat'-stirat'-sushit'-i-hranit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 6338,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9d38aced40254f24ca"
        },
        {
            "title": "Что такое тепловентилятор, как он работает и как выбрать тепловентилятор для квартиры",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "27.12.2022",
            "link": "chto-takoe-teploventilyator-kak-on-rabotaet-i-kak-vybrat-teploventilyator-dlya-kvartiry",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teploventilyator-kak-on-rabotaet-i-kak-vibrat'-dlya-kvartiri/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teploventilyator-kak-on-rabotaet-i-kak-vibrat'-dlya-kvartiri/000-photo.jpg/000-photo.jpg 2x",
            "views": 4498,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9e38aced40254f24cb"
        },
        {
            "title": "Как организовать рабочее место школьника в соответствии с требованиями?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "29.12.2022",
            "link": "kak-organizovat-rabochee-mesto-shkolnika-v-sootvetstvii-s-trebovaniyami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-organizovat-rabochee-mesto-shkolnika-v-sootvetstvii-s-trebovaniyami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-organizovat-rabochee-mesto-shkolnika-v-sootvetstvii-s-trebovaniyami/000-photo.jpg/000-photo.jpg 2x",
            "views": 12297,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648aca9e38aced40254f24cc"
        },
        {
            "title": "Как установить и подключить сушильную машину",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "12.01.2023",
            "link": "kak-ustanovit-i-podklyuchit-sushilnuyu-mashinu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit-i-podkluchit-sushilnuy-mashinu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-ustanovit-i-podkluchit-sushilnuy-mashinu/000-photo.jpg/000-photo.jpg 2x",
            "views": 5080,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9e38aced40254f24cd"
        },
        {
            "title": "Как выбрать комод в спальню для белья и одежды?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "27.12.2022",
            "link": "kak-vybrat-komod-v-spalnyu-dlya-belya-i-odezhdy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-komod-v-spal'nu-dlya-bel'ya-i-odezhdi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-komod-v-spal'nu-dlya-bel'ya-i-odezhdi/000-photo.jpg/000-photo.jpg 2x",
            "views": 11116,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648aca9e38aced40254f24ce"
        },
        {
            "title": "Организация рабочего места в домашних условиях",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "11.01.2023",
            "link": "organizaciya-rabochego-mesta-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/organizaciya-rabochego-mesta-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/organizaciya-rabochego-mesta-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 4187,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648aca9e38aced40254f24cf"
        },
        {
            "title": "Что такое чистовая и предчистовая отделка, в чём разница и что в них входит",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Стройматериалы",
            "dept_slug": "stroymaterialy",
            "date_publish": "15.12.2022",
            "link": "chto-takoe-chistovaya-i-predchistovaya-otdelka-v-chem-raznica-i-chto-v-nih-vhodit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chto-takoe-chistovaya-i-predchistovaya-otdelka-v-chem-raznica-i-chto-v-nih-vhodit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stroymaterialy/chto-takoe-chistovaya-i-predchistovaya-otdelka-v-chem-raznica-i-chto-v-nih-vhodit/000-photo.jpg/000-photo.jpg 2x",
            "views": 5277,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9f38aced40254f24d0"
        },
        {
            "title": "Чем и как заделать трещины в брусе снаружи дома",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "29.12.2022",
            "link": "chem-i-kak-zadelat-treshchiny-v-bruse-snaruzhi-doma",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chem-i-kak-zadelat-treshchiny-v-bruse-snaruzhi-doma/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chem-i-kak-zadelat-treshchiny-v-bruse-snaruzhi-doma/000-photo.jpg/000-photo.jpg 2x",
            "views": 14465,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648aca9f38aced40254f24d1"
        },
        {
            "title": "Что такое кварцвиниловая плитка для пола?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "09.01.2023",
            "link": "chto-takoe-kvarcvinilovaya-plitka-dlya-pola",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/chto-takoe-kvarcevinilovaya-plitka-dlya-pola/chto-takoe-kvarcevidnaya-plitka-dlya-pola.jpg/chto-takoe-kvarcevidnaya-plitka-dlya-pola.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/chto-takoe-kvarcevinilovaya-plitka-dlya-pola/chto-takoe-kvarcevidnaya-plitka-dlya-pola.jpg/chto-takoe-kvarcevidnaya-plitka-dlya-pola.jpg 2x",
            "views": 10420,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648aca9f38aced40254f24d2"
        },
        {
            "title": "Смесители на борту ванны: виды, установка",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "13.01.2023",
            "link": "smesiteli-na-bortu-vanny-vidy-ustanovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/smesiteli-na-bortu-vanni-vidi-ustanovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/smesiteli-na-bortu-vanni-vidi-ustanovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 9475,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648aca9f38aced40254f24d3"
        },
        {
            "title": "Как выбрать батарейки и как их отличить друг от друга по видам",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "16.01.2023",
            "link": "kak-vybrat-batareyki-i-kak-ih-otlichit-drug-ot-druga-po-vidam",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-batarei-i-kak-ih-otlichit'-drug-ot-druga-po-vidam/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-batarei-i-kak-ih-otlichit'-drug-ot-druga-po-vidam/000-photo.jpg/000-photo.jpg 2x",
            "views": 5177,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648acaa038aced40254f24d4"
        },
        {
            "title": "Как выбрать для школьника письменный стол с ящиками и полками?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Хранение",
            "dept_slug": "hranenie",
            "date_publish": "19.12.2022",
            "link": "kak-vybrat-dlya-shkolnika-pismennyy-stol-s-yashchikami-i-polkami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-dlya-shkol'nika-pismennii-stol-s-yachikami-i-polkami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/hranenie/kak-vibrat'-dlya-shkol'nika-pismennii-stol-s-yachikami-i-polkami/000-photo.jpg/000-photo.jpg 2x",
            "views": 4215,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648acaa038aced40254f24d5"
        },
        {
            "title": "Что такое струбцина, как её выбрать и как пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "29.12.2022",
            "link": "chto-takoe-strubcina-kak-ee-vybrat-i-kak-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-strubcina-kak-eyo-vybrat-i-kak-polzovatsya/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-strubcina-kak-eyo-vybrat-i-kak-polzovatsya/000-hero.jpg/000-hero.jpg 2x",
            "views": 15878,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648acaa038aced40254f24d6"
        },
        {
            "title": "Как выбрать сушильную машину для белья",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "12.01.2023",
            "link": "kak-vybrat-sushilnuyu-mashinu-dlya-belya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vibrat'-sushil'nuy-mashinu-dlya-bel'ya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kak-vibrat'-sushil'nuy-mashinu-dlya-bel'ya/000-photo.jpg/000-photo.jpg 2x",
            "views": 4185,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648acaa038aced40254f24d7"
        },
        {
            "title": "Интерьеры в стиле поп-арт: яркость и экстравагантность",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "20.12.2022",
            "link": "interery-v-stile-pop-art-yarkost-i-ekstravagantnost",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/inter'eri-v-stile-pop-art-yarkost'-i-ekstravagantnost'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/inter'eri-v-stile-pop-art-yarkost'-i-ekstravagantnost'/000-photo.jpg/000-photo.jpg 2x",
            "views": 16389,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648acaa038aced40254f24d8"
        },
        {
            "title": "Как пользоваться герметиком: как правильно наносить герметик",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "20.12.2022",
            "link": "kak-polzovatsya-germetikom-kak-pravilno-nanosit-germetik",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pol'zovat'sya-germetikom-kak-pravil'no-nanosit'-germetik/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-pol'zovat'sya-germetikom-kak-pravil'no-nanosit'-germetik/000-photo.jpg/000-photo.jpg 2x",
            "views": 14171,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648acaa138aced40254f24d9"
        },
        {
            "title": "Варианты фартука на кухню: плитка и не только",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Плитка",
            "dept_slug": "plitka",
            "date_publish": "20.12.2022",
            "link": "varianty-fartuka-na-kuhnyu-plitka-i-ne-tolko",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/varianti-fartuka-na-kuhnu-plitka-i-ne-tol'ko/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/plitka/varianti-fartuka-na-kuhnu-plitka-i-ne-tol'ko/000-photo.jpg/000-photo.jpg 2x",
            "views": 12776,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa138aced40254f24da"
        },
        {
            "title": "Виды домкратов, и какой лучше для легковой машины",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "21.12.2022",
            "link": "vidy-domkratov-i-kakoy-luchshe-dlya-legkovoy-mashiny",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vidi-domkratov-i-kakoy-luchshe-dlya-legkovoy-mashini/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/vidi-domkratov-i-kakoy-luchshe-dlya-legkovoy-mashini/000-photo.jpg/000-photo.jpg 2x",
            "views": 10871,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648acaa138aced40254f24db"
        },
        {
            "title": "Как выбрать HDMI-кабель для телевизора и монитора",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "16.12.2022",
            "link": "kak-vybrat-hdmi-kabel-dlya-televizora-i-monitora",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-hdmi-kabel'-dlya-televizora-i-monitora/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-hdmi-kabel'-dlya-televizora-i-monitora/000-photo.jpg/000-photo.jpg 2x",
            "views": 15357,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648acaa138aced40254f24dc"
        },
        {
            "title": "Что такое ДСП, разница с другими материалами",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "16.12.2022",
            "link": "chto-takoe-dsp-raznica-s-drugimi-materialami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-dsp-raznica-s-drugumi-materialami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/chto-takoe-dsp-raznica-s-drugumi-materialami/000-photo.jpg/000-photo.jpg 2x",
            "views": 5759,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648acaa138aced40254f24dd"
        },
        {
            "title": "Рейтинг ванн",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "16.12.2022",
            "link": "reyting-vann",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/reiting-vann/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/reiting-vann/000-photo.jpg/000-photo.jpg 2x",
            "views": 11477,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648acaa238aced40254f24de"
        },
        {
            "title": "Как укладывать плитку ПВХ",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "24.01.2023",
            "link": "kak-ukladyvat-plitku-pvh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukladyvat-plitku-pvh/000-hero.jpg/000-hero.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-ukladyvat-plitku-pvh/000-hero.jpg/000-hero.jpg 2x",
            "views": 6827,
            "total_comment": 1,
            "is_video": false,
            "likes": 10,
            "id": "648acaa238aced40254f24df"
        },
        {
            "title": "Как удалить ржавчину с металла в домашних условиях?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "23.01.2023",
            "link": "kak-udalit-rzhavchinu-s-metalla-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-udalit'-rzhavchinu-s-metalla-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-udalit'-rzhavchinu-s-metalla-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 4032,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648acaa238aced40254f24e0"
        },
        {
            "title": "Что такое тепловая пушка, как она работает и как выбрать тепловую пушку",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "17.01.2023",
            "link": "chto-takoe-teplovaya-pushka-kak-ona-rabotaet-i-kak-vybrat-teplovuyu-pushku",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teplovaya-pushka-kak-ona-rabotaet-i-kak-vibrat'-teplovuy-pushku/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-teplovaya-pushka-kak-ona-rabotaet-i-kak-vibrat'-teplovuy-pushku/000-photo.jpg/000-photo.jpg 2x",
            "views": 4584,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648acaa238aced40254f24e1"
        },
        {
            "title": "Что такое микрометр и как им пользоваться",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "20.01.2023",
            "link": "chto-takoe-mikrometr-i-kak-im-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-mikrometr-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/chto-takoe-mikrometr-i-kak-im-polzovatsya/000-photo.jpg/000-photo.jpg 2x",
            "views": 14415,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaa338aced40254f24e2"
        },
        {
            "title": "Ароматы для дома: как они действуют, как их выбрать и пользоваться",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "07.02.2023",
            "link": "aromaty-dlya-doma-kak-oni-deystvuyut-kak-ih-vybrat-i-polzovatsya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/aromati-dlya-doma-kak-oni-deistvuyt-kak-ih-vibrat'-i-polzovat'sya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/aromati-dlya-doma-kak-oni-deistvuyt-kak-ih-vibrat'-i-polzovat'sya/000-photo.jpg/000-photo.jpg 2x",
            "views": 15799,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648acaa338aced40254f24e3"
        },
        {
            "title": "Как соединить провода в распределительной коробке",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "02.02.2023",
            "link": "kak-soedinit-provoda-v-raspredelitelnoy-korobke",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-soedinit'-provoda-v-raspredelitelnoy-korobke/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-soedinit'-provoda-v-raspredelitelnoy-korobke/000-photo.jpg/000-photo.jpg 2x",
            "views": 6517,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648acaa338aced40254f24e4"
        },
        {
            "title": "Как выбрать портативный аккумулятор (power bank) для смартфона, планшета и ноутбука",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "03.02.2023",
            "link": "kak-vybrat-portativnyy-akkumulyator-power-bank-dlya-smartfona-plansheta-i-noutbuka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-portativnyj-akkumulyator-power-bank-dlya-smartfona-plansheta-i-noutbuka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-portativnyj-akkumulyator-power-bank-dlya-smartfona-plansheta-i-noutbuka/000-photo.jpg/000-photo.jpg 2x",
            "views": 15573,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648acaa338aced40254f24e5"
        },
        {
            "title": "Какой клей нужен для дерева?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "02.02.2023",
            "link": "kakoy-kley-nuzhen-dlya-dereva",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kakoj-klej-nuzhen-dlya-dereva/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kakoj-klej-nuzhen-dlya-dereva/000-photo.jpg/000-photo.jpg 2x",
            "views": 6937,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648acaa338aced40254f24e6"
        },
        {
            "title": "Трековые системы освещения: компоненты, преимущества, виды и монтаж",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "07.02.2023",
            "link": "trekovye-sistemy-osveshcheniya-komponenty-preimushchestva-vidy-i-montazh",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/trekovye-sistemy-osveshcheniya-komponenty-preimushchestva-vidy-i-montazh/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/trekovye-sistemy-osveshcheniya-komponenty-preimushchestva-vidy-i-montazh/000-photo.jpg/000-photo.jpg 2x",
            "views": 7551,
            "total_comment": 0,
            "is_video": true,
            "likes": 6,
            "id": "648acaa438aced40254f24e7"
        },
        {
            "title": "Как выбрать покрывало или плед, их размеры и виды",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "27.01.2023",
            "link": "kak-vybrat-pokryvalo-ili-pled-ih-razmery-i-vidy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-pokryvalo-ili-pled-ih-razmery-i-vidy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-pokryvalo-ili-pled-ih-razmery-i-vidy/000-photo.jpg/000-photo.jpg 2x",
            "views": 13281,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaa438aced40254f24e8"
        },
        {
            "title": "Как сделать свечи своими руками в домашних условиях?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "26.01.2023",
            "link": "kak-sdelat-svechi-svoimi-rukami-v-domashnih-usloviyah",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat'-svechi-svoimi-rukami-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat'-svechi-svoimi-rukami-v-domashnih-usloviyah/000-photo.jpg/000-photo.jpg 2x",
            "views": 13105,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648acaa438aced40254f24e9"
        },
        {
            "title": "Электрокарнизы для штор: особенности, разновидности, установка",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "30.01.2023",
            "link": "elektrokarnizy-dlya-shtor-osobennosti-raznovidnosti-ustanovka",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/elektrokarnizi-dlya-shtor-osobennosti-raznovidnosti-ustanovka/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/elektrokarnizi-dlya-shtor-osobennosti-raznovidnosti-ustanovka/000-photo.jpg/000-photo.jpg 2x",
            "views": 15060,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa438aced40254f24ea"
        },
        {
            "title": "Как выбрать фурнитуру для окон?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "27.01.2023",
            "link": "kak-vybrat-furnituru-dlya-okon",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-furnituru-dlya-okon/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/kak-vybrat-furnituru-dlya-okon/000-photo.jpg/000-photo.jpg 2x",
            "views": 13157,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa438aced40254f24eb"
        },
        {
            "title": "Как выбрать сетевой фильтр для техники и компьютера",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "27.01.2023",
            "link": "kak-vybrat-setevoy-filtr-dlya-tehniki-i-kompyutera",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-setevoj-filtr-dlya-tekhniki-i-kompyutera/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vybrat-setevoj-filtr-dlya-tekhniki-i-kompyutera/000-photo.jpg/000-photo.jpg 2x",
            "views": 7967,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648acaa538aced40254f24ec"
        },
        {
            "title": "Как рассчитать ламинат на комнату по площади",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "31.01.2023",
            "link": "kak-rasschitat-laminat-na-komnatu-po-ploshchadi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-rasschitat'-laminat-na-komnatu-po-plochadi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/kak-rasschitat'-laminat-na-komnatu-po-plochadi/000-photo.jpg/000-photo.jpg 2x",
            "views": 10738,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648acaa538aced40254f24ed"
        },
        {
            "title": "Как и чем можно резать пластиковый плинтус",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "31.03.2023",
            "link": "kak-i-chem-mozhno-rezat-plastikovyy-plintus",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-mozhno-rezat'-plastikivii-plintus/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-mozhno-rezat'-plastikivii-plintus/000-photo.jpg/000-photo.jpg 2x",
            "views": 14389,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa538aced40254f24ee"
        },
        {
            "title": "Виды кабель-каналов и способы крепления",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "01.04.2023",
            "link": "vidy-kabel-kanalov-i-sposoby-krepleniya",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidi-kabel'-kanalov-i-sposobi-krepleniya/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/vidi-kabel'-kanalov-i-sposobi-krepleniya/000-photo.jpg/000-photo.jpg 2x",
            "views": 6500,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648acaa538aced40254f24ef"
        },
        {
            "title": "Как и чем можно резать профлист",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Инструменты",
            "dept_slug": "instrumenty",
            "date_publish": "31.03.2023",
            "link": "kak-i-chem-mozhno-rezat-proflist",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-mozhno-rezat'-proflist/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/instrumenty/kak-i-chem-mozhno-rezat'-proflist/000-photo.jpg/000-photo.jpg 2x",
            "views": 14056,
            "total_comment": 0,
            "is_video": false,
            "likes": 14,
            "id": "648acaa638aced40254f24f0"
        },
        {
            "title": "Коллекция душевых ограждений Sensea Easy",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Сантехника",
            "dept_slug": "santehnika",
            "date_publish": "30.03.2023",
            "link": "kollekciya-dushevyh-ograzhdeniy-sensea-easy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kollekciya-dushevih-ograzhdenii-sensea-easy/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/santehnika/kollekciya-dushevih-ograzhdenii-sensea-easy/000-photo.jpg/000-photo.jpg 2x",
            "views": 9507,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648acaa638aced40254f24f1"
        },
        {
            "title": "Что такое дизайн-проект интерьера и что в него входит?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.02.2023",
            "link": "chto-takoe-dizayn-proekt-interera-i-chto-v-nego-vhodit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-dizain-proekt-inter'era-i-chto-v-nego-vhodit/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/chto-takoe-dizain-proekt-inter'era-i-chto-v-nego-vhodit/000-photo.jpg/000-photo.jpg 2x",
            "views": 12200,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaa638aced40254f24f2"
        },
        {
            "title": "Как и чем отмыть жир на кухонной мебели и плите?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "09.03.2023",
            "link": "kak-i-chem-otmyt-zhir-na-kuhonnoy-mebeli-i-plite",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-otmit'-zhir-na-kuhonnoy-mebeli-i-plite/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-i-chem-otmit'-zhir-na-kuhonnoy-mebeli-i-plite/000-photo.jpg/000-photo.jpg 2x",
            "views": 7893,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaa638aced40254f24f3"
        },
        {
            "title": "Как установить и подключить светодиодную панель?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "27.02.2023",
            "link": "kak-ustanovit-i-podklyuchit-svetodiodnuyu-panel",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit'-i-podkluchit'-svetodiodnuy-panel/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-ustanovit'-i-podkluchit'-svetodiodnuy-panel/000-photo.jpg/000-photo.jpg 2x",
            "views": 7045,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648acaa638aced40254f24f4"
        },
        {
            "title": "Виды журнальных столиков: формы, высота, материалы, стили",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "16.02.2023",
            "link": "vidy-zhurnalnyh-stolikov-formy-vysota-materialy-stili",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vidy-zhurnalnyh-stolikov-formy-vysota-materialy-stili/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/vidy-zhurnalnyh-stolikov-formy-vysota-materialy-stili/000-photo.jpg/000-photo.jpg 2x",
            "views": 15828,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648acaa738aced40254f24f5"
        },
        {
            "title": "Как выбрать и подключить светодиодный прожектор?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "01.03.2023",
            "link": "kak-vybrat-i-podklyuchit-svetodiodnyy-prozhektor",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-podklyuchit-svetodiodnyj-prozhektor/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-podklyuchit-svetodiodnyj-prozhektor/000-photo.jpg/000-photo.jpg 2x",
            "views": 4378,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa738aced40254f24f6"
        },
        {
            "title": "Что такое бактерицидная лампа и как она работает?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "16.03.2023",
            "link": "chto-takoe-baktericidnaya-lampa-i-kak-ona-rabotaet",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-takoe-bakrericidnaya-lampa-i-kak-ona-rabotaet/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-takoe-bakrericidnaya-lampa-i-kak-ona-rabotaet/000-photo.jpg/000-photo.jpg 2x",
            "views": 9846,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaa738aced40254f24f7"
        },
        {
            "title": "Что такое жидкие гвозди?",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "01.03.2023",
            "link": "chto-takoe-zhidkie-gvozdi",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-zhidkie-gvozdi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-zhidkie-gvozdi/000-photo.jpg/000-photo.jpg 2x",
            "views": 13577,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa738aced40254f24f8"
        },
        {
            "title": "Как выбрать декоративное зеркало — виды, размеры, стили",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.02.2023",
            "link": "kak-vybrat-dekorativnoe-zerkalo-vidy-razmery-stili",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-dekorativnoe-zerkalo-vidy-razmery-stili/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-vybrat-dekorativnoe-zerkalo-vidy-razmery-stili/000-photo.jpg/000-photo.jpg 2x",
            "views": 12468,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648acaa738aced40254f24f9"
        },
        {
            "title": "Как сделать журнальный столик из дерева своими руками?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "27.02.2023",
            "link": "kak-sdelat-zhurnalnyy-stolik-iz-dereva-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat-zhurnalnyj-stolik-iz-dereva-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/kak-sdelat-zhurnalnyj-stolik-iz-dereva-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 6087,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648acaa838aced40254f24fa"
        },
        {
            "title": "Как настроить универсальный пульт к телевизору",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "05.03.2023",
            "link": "kak-nastroit-universalnyy-pult-k-televizoru",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-nastroit'-universal'nii-pul't-k-televozoru/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-nastroit'-universal'nii-pul't-k-televozoru/000-photo.jpg/000-photo.jpg 2x",
            "views": 10566,
            "total_comment": 0,
            "is_video": false,
            "likes": 12,
            "id": "648acaa838aced40254f24fb"
        },
        {
            "title": "Что такое домашняя метеостанция и как её правильно выбрать",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "27.02.2023",
            "link": "chto-takoe-domashnyaya-meteostanciya-i-kak-ee-pravilno-vybrat",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-domashnyaya-meteostanciya-i-kak-eyo-pravilno-vybrat/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-domashnyaya-meteostanciya-i-kak-eyo-pravilno-vybrat/000-photo.jpg/000-photo.jpg 2x",
            "views": 11307,
            "total_comment": 0,
            "is_video": false,
            "likes": 8,
            "id": "648acaa838aced40254f24fc"
        },
        {
            "title": "Узлы для связывания верёвок, которые пригодятся в быту",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Скобяные изделия",
            "dept_slug": "skobyanye-izdeliya",
            "date_publish": "06.03.2023",
            "link": "uzly-dlya-svyazyvaniya-verevok-kotorye-prigodyatsya-v-bytu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/uzly-dlya-svyazyvaniya-veryovok-kotorye-prigodyatsya-v-bytu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/skobyanye-izdeliya/uzly-dlya-svyazyvaniya-veryovok-kotorye-prigodyatsya-v-bytu/000-photo.jpg/000-photo.jpg 2x",
            "views": 11565,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648acaa838aced40254f24fd"
        },
        {
            "title": "PECAN 4 (Орех пекан) – цвет года 2024",
            "description": "",
            "type": "Вдохновиться",
            "type_slug": "be-inspired",
            "dept": "Декор",
            "dept_slug": "dekor",
            "date_publish": "17.03.2023",
            "link": "pecan-4-oreh-pekan-cvet-goda-2023-v-lerua-merlen",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/pecan-4-opex-pecan-cvet-goda-2023-v-lerua-merlen/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/dekor/pecan-4-opex-pecan-cvet-goda-2023-v-lerua-merlen/000-photo.jpg/000-photo.jpg 2x",
            "views": 7460,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648acaa938aced40254f24fe"
        },
        {
            "title": "Как правильно заряжать аккумулятор",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "20.03.2023",
            "link": "kak-pravilno-zaryazhat-akkumulyator",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravil'no-zaryazhat'-akkumulyator/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-pravil'no-zaryazhat'-akkumulyator/000-photo.jpg/000-photo.jpg 2x",
            "views": 4586,
            "total_comment": 0,
            "is_video": false,
            "likes": 9,
            "id": "648acaa938aced40254f24ff"
        },
        {
            "title": "Какая влажность должна быть в квартире",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "07.03.2023",
            "link": "kakaya-vlazhnost-dolzhna-byt-v-kvartire",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakaya-vlazhnost-dolzhna-byt-v-kvartire/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kakaya-vlazhnost-dolzhna-byt-v-kvartire/000-photo.jpg/000-photo.jpg 2x",
            "views": 12317,
            "total_comment": 0,
            "is_video": false,
            "likes": 7,
            "id": "648acaa938aced40254f2500"
        },
        {
            "title": "Выбор и укладка кварцвиниловой плитки",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Напольные покрытия",
            "dept_slug": "napolnye-pokrytiya",
            "date_publish": "05.04.2023",
            "link": "vybor-i-ukladka-kvarcvinilovoy-plitki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vibor-i-ukladka-kvarcvinil'noy-plitki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/napolnye-pokrytiya/vibor-i-ukladka-kvarcvinil'noy-plitki/000-photo.jpg/000-photo.jpg 2x",
            "views": 10425,
            "total_comment": 0,
            "is_video": false,
            "likes": 11,
            "id": "648acaa938aced40254f2501"
        },
        {
            "title": "Как навести порядок на даче весной: подборка советов",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "05.04.2023",
            "link": "kak-navesti-poryadok-na-dache-vesnoy-podborka-sovetov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-navesti-poryadok-na-dache-vesnoy-podborka-sovetov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/kak-navesti-poryadok-na-dache-vesnoy-podborka-sovetov/000-photo.jpg/000-photo.jpg 2x",
            "views": 5959,
            "total_comment": 2,
            "is_video": false,
            "likes": 13,
            "id": "648acaa938aced40254f2502"
        },
        {
            "title": "Что такое эпоксидный клей, как им пользоваться, применение и инструкции",
            "description": "",
            "type": "Как использовать",
            "type_slug": "how-to-use",
            "dept": "Краски",
            "dept_slug": "kraski",
            "date_publish": "16.04.2023",
            "link": "chto-takoe-epoksidnyy-kley-kak-im-polzovatsya-primenenie-i-instrukcii",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-epoksidnii-kley-kak-im-pol'zovat'sya-primenenie-i-instrukcii/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/kraski/chto-takoe-epoksidnii-kley-kak-im-pol'zovat'sya-primenenie-i-instrukcii/000-photo.jpg/000-photo.jpg 2x",
            "views": 5661,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaaa38aced40254f2503"
        },
        {
            "title": "Как соединить алюминиевые и медные провода между собой?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "17.04.2023",
            "link": "kak-soedinit-alyuminievye-i-mednye-provoda-mezhdu-soboy",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-soedinit'-aluminivie-i-mednie-provoda-mezhdu-soboi/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-soedinit'-aluminivie-i-mednie-provoda-mezhdu-soboi/000-photo.jpg/000-photo.jpg 2x",
            "views": 16053,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648acaaa38aced40254f2504"
        },
        {
            "title": "Что такое диммер и как его подключить",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "17.04.2023",
            "link": "chto-takoe-dimmer-i-kak-ego-podklyuchit",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-dimmer-i-kak-ego-podkluchit'/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chto-takoe-dimmer-i-kak-ego-podkluchit'/000-photo.jpg/000-photo.jpg 2x",
            "views": 15288,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaaa38aced40254f2505"
        },
        {
            "title": "Чем отличается кабель от провода",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "24.04.2023",
            "link": "chem-otlichaetsya-kabel-ot-provoda",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichaetsya-kabel'-ot-provoda/chem-otlichaetsya-kabel'-ot-provoda.jpg/chem-otlichaetsya-kabel'-ot-provoda.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_888,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/chem-otlichaetsya-kabel'-ot-provoda/chem-otlichaetsya-kabel'-ot-provoda.jpg/chem-otlichaetsya-kabel'-ot-provoda.jpg 2x",
            "views": 4986,
            "total_comment": 0,
            "is_video": false,
            "likes": 13,
            "id": "648acaaa38aced40254f2506"
        },
        {
            "title": "Что нужно знать про консольные и магистральные светильники",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "13.04.2023",
            "link": "chto-nuzhno-znat-pro-konsolnye-i-magistralnye-svetilniki",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-nuzhno-znat'-pro-konsol'nie-i-magistral'nie-svetil'niki/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chto-nuzhno-znat'-pro-konsol'nie-i-magistral'nie-svetil'niki/000-photo.jpg/000-photo.jpg 2x",
            "views": 10382,
            "total_comment": 0,
            "is_video": false,
            "likes": 6,
            "id": "648acaaa38aced40254f2507"
        },
        {
            "title": "Какие люстры в моде сейчас в 2023 году",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "27.04.2023",
            "link": "kakie-lyustry-v-mode-seychas-v-2023-godu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kakie-lyustry-v-mode-sejchas-v-2022-godu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/kakie-lyustry-v-mode-sejchas-v-2022-godu/000-photo.jpg/000-photo.jpg 2x",
            "views": 16556,
            "total_comment": 0,
            "is_video": false,
            "likes": 15,
            "id": "648acaab38aced40254f2508"
        },
        {
            "title": "Как выбрать телевизионную антенну",
            "description": "",
            "type": "Как выбрать",
            "type_slug": "how-to-choose",
            "dept": "Электротовары",
            "dept_slug": "elektrotovary",
            "date_publish": "04.05.2023",
            "link": "kak-vybrat-televizionnuyu-antennu",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-televizionnuy-antennu/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/elektrotovary/kak-vibrat'-televizionnuy-antennu/000-photo.jpg/000-photo.jpg 2x",
            "views": 10062,
            "total_comment": 0,
            "is_video": false,
            "likes": 10,
            "id": "648acaab38aced40254f2509"
        },
        {
            "title": "Как сделать табуретку из дерева своими руками?",
            "description": "",
            "type": "Как сделать",
            "type_slug": "how-to-make",
            "dept": "Столярные изделия",
            "dept_slug": "stolyarnye-izdeliya",
            "date_publish": "22.05.2023",
            "link": "kak-sdelat-taburetku-iz-dereva-svoimi-rukami",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat'-taburetku-iz-dereva-svoimi-rukami/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/stolyarnye-izdeliya/kak-sdelat'-taburetku-iz-dereva-svoimi-rukami/000-photo.jpg/000-photo.jpg 2x",
            "views": 4810,
            "total_comment": 0,
            "is_video": false,
            "likes": 5,
            "id": "648acaab38aced40254f250a"
        },
        {
            "title": "Чтобы снова заблестела: как мыть люстры из различных материалов",
            "description": "",
            "type": "Как ухаживать",
            "type_slug": "how-to-look",
            "dept": "Освещение",
            "dept_slug": "osveshchenie",
            "date_publish": "02.06.2022",
            "link": "chtoby-snova-zablestela-kak-myt-lyustry-iz-razlichnyh-materialov",
            "preview_srcset": "https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,c_pad,b_white,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chtoby-snova-zablestela-kak-myt-lyustry-iz-razlichnyh-materialov/000-photo.jpg/000-photo.jpg 1x, https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto,w_428,dpr_2.0,d_photoiscoming.png/fudzi/elbrus/advice-new/osveshchenie/chtoby-snova-zablestela-kak-myt-lyustry-iz-razlichnyh-materialov/000-photo.jpg/000-photo.jpg 2x",
            "views": 8983,
            "total_comment": 1,
            "is_video": false,
            "likes": 8,
            "id": "64c7b6ae32b8b366630359b7"
        }
    ]
}